import { __extends, __decorate, __metadata } from 'tslib';
import { Validators, FormGroup, FormControl, ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, DefaultValueAccessor, NgControlStatus, FormControlName, NumberValueAccessor, NgModel, NgForm, SelectControlValueAccessor, NgSelectOption, ɵangular_packages_forms_forms_x, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { of, Subject as Subject$1 } from 'rxjs';
import { map, tap, filter } from 'rxjs/operators';
import { ɵɵgetCurrentView, ɵɵelementStart, ɵɵlistener, ɵɵrestoreView, ɵɵnextContext, ɵɵelementEnd, ɵɵtext, ɵɵadvance, ɵɵproperty, ɵɵpipe, ɵɵtextInterpolate1, ɵɵpipeBind1, ɵɵtextInterpolate2, ɵɵtemplate, ɵɵelement, ɵɵattribute, ɵɵpropertyInterpolate, ɵɵpureFunction1, ɵɵdirectiveInject, Renderer2, ElementRef, ChangeDetectorRef, ɵɵdefineComponent, ɵɵInheritDefinitionFeature, ɵɵNgOnChangesFeature, ɵsetClassMetadata, Component, Input, Output, ɵɵdefineInjectable, Injectable, ɵɵtextInterpolate, EventEmitter, ɵɵelementContainerStart, ɵɵelementContainerEnd, ɵɵdefinePipe, Pipe, ɵɵclassProp, ɵɵtemplateRefExtractor, ɵɵreference, ɵɵpipeBind2, ɵɵstaticViewQuery, ɵɵqueryRefresh, ɵɵloadQuery, ɵɵresolveDocument, ɵɵstyleProp, ViewChild, HostListener, ɵɵinject, ɵɵpureFunction2, ViewEncapsulation, ɵɵprojectionDef, ɵɵprojection, ɵɵclassMap, ɵɵnamespaceSVG, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { v4 } from 'uuid';
import { cloneDeep, isEqual } from 'lodash';
import { JsonConvert, OperationMode, ValueCheckingMode, JsonProperty, JsonObject, JsonConverter } from 'json2typescript';
import { Router, RouterLinkWithHref, RouterModule } from '@angular/router';
import { NgIf, NgClass, NgForOf, DatePipe, PlatformLocation, CommonModule } from '@angular/common';
import { TranslatePipe, TranslateService, TranslateModule } from '@ngx-translate/core';
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbRadioGroup, NgbButtonLabel, NgbRadio, NgbCalendar, NgbDatepicker, NgbInputDatepicker, NgbActiveModal, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import * as momentNs from 'moment';
import * as momentDurationFormat from 'moment-duration-format';
import { DatatableComponent, DataTableColumnDirective, DataTableColumnCellDirective, DatatableFooterDirective, DataTableFooterTemplateDirective, DataTablePagerComponent, NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ExportToCsv } from 'export-to-csv';
import { saveAs } from 'file-saver';
import { utils, write } from 'xlsx';
import { HttpClient } from '@angular/common/http';
import { webSocket } from 'rxjs/webSocket';
import { JwtHelperService, JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt';
import { CookieService, CookieModule } from 'ngx-cookie';
import { D3Service } from 'd3-ng2-service';
import { UiSwitchComponent, UiSwitchModule } from 'ngx-ui-switch';

var ValueAccessorBase = /** @class */ (function () {
    function ValueAccessorBase() {
        this.onChange = function (value) { };
        this.onTouched = function () { };
        // touch() {
        //   console.log('touch')
        //   this.onTouched();
        // }
    }
    Object.defineProperty(ValueAccessorBase.prototype, "value", {
        get: function () {
            return this.innerValue;
        },
        set: function (value) {
            if (this.innerValue !== value) {
                this.innerValue = value;
                this.onChange(this.value);
            }
        },
        enumerable: true,
        configurable: true
    });
    ValueAccessorBase.prototype.writeValue = function (value) {
        this.innerValue = value;
    };
    ValueAccessorBase.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    ValueAccessorBase.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    return ValueAccessorBase;
}());

var normalizeValidator = function (validator) {
    var func = validator.validate.bind(validator);
    if (typeof func === 'function') {
        return function (c) { return func(c); };
    }
    else {
        return validator;
    }
};
var composeValidators = function (validators) {
    if (validators == null || validators.length === 0) {
        return null;
    }
    return Validators.compose(validators.map(normalizeValidator));
};
var validate = function (validators, asyncValidators) {
    return function (control) {
        var synchronousValid = function () { return composeValidators(validators)(control); };
        if (asyncValidators) {
            var asyncValidator = composeValidators(asyncValidators);
            return asyncValidator(control).map(function (v) {
                var secondary = synchronousValid();
                if (secondary || v) { // compose async and sync validator results
                    return Object.assign({}, secondary, v);
                }
            });
        }
        if (validators) {
            return of(synchronousValid());
        }
        return of(null);
    };
};
var message = function (validator, key) {
    switch (key) {
        case 'required':
            return 'Please enter a value';
        case 'pattern':
            return 'Value does not match required pattern';
        case 'minlength':
            return 'Value must be N characters';
        case 'maxlength':
            return 'Value must be a maximum of N characters';
    }
    switch (typeof validator[key]) {
        case 'string':
            return validator[key];
        default:
            return "Validation failed: " + key;
    }
};

var ElementBase = /** @class */ (function (_super) {
    __extends(ElementBase, _super);
    function ElementBase(validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this.validators = validators;
        _this.asyncValidators = asyncValidators;
        return _this;
    }
    ElementBase.prototype.validate = function () {
        return validate(this.validators, this.asyncValidators)(this.model.control);
    };
    Object.defineProperty(ElementBase.prototype, "invalid", {
        get: function () {
            return this.validate().
                pipe(map(function (v) { return Object.keys(v || {}).length > 0; }));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementBase.prototype, "failures", {
        get: function () {
            return this.validate().
                pipe(map(function (v) { return Object.keys(v).map(function (k) { return message(v, k); }); }));
        },
        enumerable: true,
        configurable: true
    });
    return ElementBase;
}(ValueAccessorBase));

var Highlighter = /** @class */ (function () {
    function Highlighter() {
        this._isHighlighting = false;
        this.timer = null;
    }
    Object.defineProperty(Highlighter.prototype, "isHighlighting", {
        get: function () {
            return this._isHighlighting;
        },
        enumerable: true,
        configurable: true
    });
    Highlighter.prototype.highlight = function () {
        var _this = this;
        this._isHighlighting = true;
        clearTimeout(this.timer);
        this.timer = setTimeout(function () {
            _this._isHighlighting = false;
        }, 1000);
    };
    Object.defineProperty(Highlighter.prototype, "cssClassHighlight", {
        get: function () {
            return this.isHighlighting ? 'timer-highlight timer-highlight-show' : 'timer-highlight-hide';
        },
        enumerable: true,
        configurable: true
    });
    return Highlighter;
}());

var JsonConvertorUtility = /** @class */ (function () {
    function JsonConvertorUtility() {
    }
    JsonConvertorUtility.deserialize = function (from, toType) {
        if (from == null) {
            return null;
        }
        var jsonConvert = new JsonConvert(OperationMode.ENABLE, ValueCheckingMode.ALLOW_NULL);
        var result = jsonConvert.deserialize(from, toType);
        return result;
    };
    JsonConvertorUtility.serialize = function (from) {
        if (from == null) {
            return null;
        }
        var jsonConvert = new JsonConvert(OperationMode.ENABLE, ValueCheckingMode.ALLOW_NULL);
        var result = jsonConvert.serialize(from);
        return result;
    };
    return JsonConvertorUtility;
}());

var StaffCard = /** @class */ (function () {
    function StaffCard(barcode, count, employeeName, employeeId, isLocal) {
        if (barcode === void 0) { barcode = ''; }
        if (count === void 0) { count = 0; }
        if (employeeName === void 0) { employeeName = ''; }
        if (employeeId === void 0) { employeeId = ''; }
        if (isLocal === void 0) { isLocal = false; }
        this.id = undefined;
        this.name = undefined;
        this.count = undefined;
        this.employeeName = undefined;
        this.employeeId = undefined;
        this.isLocal = undefined;
        this.id = null;
        this.name = barcode;
        this.count = count;
        this.employeeName = employeeName;
        this.employeeId = employeeId;
        this.isLocal = isLocal;
        this.gateIds = [];
    }
    StaffCard_1 = StaffCard;
    StaffCard.areEqual = function (a, b) {
        if (a == null ||
            b == null ||
            !Array.isArray(a) ||
            !Array.isArray(b) ||
            a.length !== b.length) {
            return false;
        }
        for (var i = 0; i < a.length; i++) {
            if (!a[i].isEqualTo(b[i])) {
                return false;
            }
        }
        return true;
    };
    StaffCard.fromJsonWithArray = function (json) {
        var barcodeInfos = [];
        json.forEach(function (x) { return barcodeInfos.push(new StaffCard_1(x.barcode, x.count, x.employee_name, x.employee_id, x.is_local)); });
        return barcodeInfos;
    };
    StaffCard.fromOther = function (x) {
        if (x == null) {
            return null;
        }
        return Object.assign(new StaffCard_1(), x);
    };
    StaffCard.fromJson = function (x) {
        return JsonConvertorUtility.deserialize(x, StaffCard_1);
    };
    StaffCard.prototype.isEqualTo = function (x) {
        return this.name === x.name
            && this.count === x.count
            && this.employeeName === x.employeeName
            && this.employeeId === x.employeeId
            && this.isLocal === x.isLocal;
    };
    StaffCard.prototype.clone = function () {
        return cloneDeep(this);
    };
    StaffCard.prototype.updateFromOher = function (x) {
        if (!x) {
            return;
        }
        this.name = x.name;
        this.count = x.count;
        this.employeeName = x.employeeName;
        this.employeeId = x.employeeId;
        this.isLocal = x.isLocal;
    };
    StaffCard.prototype.toJson = function () {
        return JsonConvertorUtility.serialize(this);
    };
    StaffCard.prototype.getTypeName = function () {
        return 'StaffCard';
    };
    var StaffCard_1;
    __decorate([
        JsonProperty('id', Number),
        __metadata("design:type", Number)
    ], StaffCard.prototype, "id", void 0);
    __decorate([
        JsonProperty('barcode', String),
        __metadata("design:type", String)
    ], StaffCard.prototype, "name", void 0);
    __decorate([
        JsonProperty('count', Number),
        __metadata("design:type", Number)
    ], StaffCard.prototype, "count", void 0);
    __decorate([
        JsonProperty('employee_name', String),
        __metadata("design:type", String)
    ], StaffCard.prototype, "employeeName", void 0);
    __decorate([
        JsonProperty('employee_id', String),
        __metadata("design:type", String)
    ], StaffCard.prototype, "employeeId", void 0);
    __decorate([
        JsonProperty('is_local', Boolean, true),
        __metadata("design:type", Boolean)
    ], StaffCard.prototype, "isLocal", void 0);
    __decorate([
        JsonProperty('gate_ids', [Number]),
        __metadata("design:type", Array)
    ], StaffCard.prototype, "gateIds", void 0);
    StaffCard = StaffCard_1 = __decorate([
        JsonObject,
        __metadata("design:paramtypes", [String, Number, String, String, Object])
    ], StaffCard);
    return StaffCard;
}());

function CardComponent_form_0_div_4_Template(rf, ctx) { if (rf & 1) {
    var _r11 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 17);
    ɵɵelementStart(1, "input", 18);
    ɵɵlistener("change", function CardComponent_form_0_div_4_Template_input_change_1_listener() { ɵɵrestoreView(_r11); var ctx_r10 = ɵɵnextContext(2); return ctx_r10.isChecked = !ctx_r10.isChecked; });
    ɵɵelementEnd();
    ɵɵelementStart(2, "label", 19);
    ɵɵtext(3, "\u00A0");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("checked", ctx_r1.isChecked);
} }
function CardComponent_form_0_div_6_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1);
    ɵɵpipe(2, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(2, 1, "The field is required"), " ");
} }
function CardComponent_form_0_div_6_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1);
    ɵɵpipe(2, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r13 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵtextInterpolate2(" ", ɵɵpipeBind1(2, 2, "The maximum length:"), " ", ctx_r13.barcodeMaxLength, " ");
} }
function CardComponent_form_0_div_6_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1);
    ɵɵpipe(2, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(2, 1, "The barcode is already in use"), " ");
} }
function CardComponent_form_0_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 20);
    ɵɵtemplate(1, CardComponent_form_0_div_6_div_1_Template, 3, 3, "div", 21);
    ɵɵtemplate(2, CardComponent_form_0_div_6_div_2_Template, 3, 4, "div", 21);
    ɵɵtemplate(3, CardComponent_form_0_div_6_div_3_Template, 3, 3, "div", 21);
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r2 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r2.barcode.errors == null ? null : ctx_r2.barcode.errors.required);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r2.barcode.errors == null ? null : ctx_r2.barcode.errors.maxlength);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r2.barcode.errors == null ? null : ctx_r2.barcode.errors.barcodeInUse);
} }
function CardComponent_form_0_div_9_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1);
    ɵɵpipe(2, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(2, 1, "The field is required"), " ");
} }
function CardComponent_form_0_div_9_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1);
    ɵɵpipe(2, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r16 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵtextInterpolate2(" ", ɵɵpipeBind1(2, 2, "The maximum length:"), " ", ctx_r16.barcodeMaxLength, " ");
} }
function CardComponent_form_0_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 22);
    ɵɵtemplate(1, CardComponent_form_0_div_9_div_1_Template, 3, 3, "div", 21);
    ɵɵtemplate(2, CardComponent_form_0_div_9_div_2_Template, 3, 4, "div", 21);
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r3 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r3.employeeName.errors == null ? null : ctx_r3.employeeName.errors.required);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r3.employeeName.errors == null ? null : ctx_r3.employeeName.errors.maxlength);
} }
function CardComponent_form_0_div_12_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1);
    ɵɵpipe(2, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(2, 1, "The field is required"), " ");
} }
function CardComponent_form_0_div_12_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1);
    ɵɵpipe(2, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r18 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵtextInterpolate2(" ", ɵɵpipeBind1(2, 2, "The maximum length:"), " ", ctx_r18.barcodeMaxLength, " ");
} }
function CardComponent_form_0_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 22);
    ɵɵtemplate(1, CardComponent_form_0_div_12_div_1_Template, 3, 3, "div", 21);
    ɵɵtemplate(2, CardComponent_form_0_div_12_div_2_Template, 3, 4, "div", 21);
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r4 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r4.employeeId.errors == null ? null : ctx_r4.employeeId.errors.required);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r4.employeeId.errors == null ? null : ctx_r4.employeeId.errors.maxlength);
} }
function CardComponent_form_0_button_16_Template(rf, ctx) { if (rf & 1) {
    var _r20 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 23);
    ɵɵlistener("click", function CardComponent_form_0_button_16_Template_button_click_0_listener() { ɵɵrestoreView(_r20); var ctx_r19 = ɵɵnextContext(2); return ctx_r19.enableButtonClick(); });
    ɵɵpipe(1, "translate");
    ɵɵelement(2, "i", 24);
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r5 = ɵɵnextContext(2);
    ɵɵproperty("disabled", !ctx_r5.canUpdate || !ctx_r5.enabled);
    ɵɵattribute("title", ɵɵpipeBind1(1, 2, "Enable"));
} }
function CardComponent_form_0_button_17_Template(rf, ctx) { if (rf & 1) {
    var _r22 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 23);
    ɵɵlistener("click", function CardComponent_form_0_button_17_Template_button_click_0_listener() { ɵɵrestoreView(_r22); var ctx_r21 = ɵɵnextContext(2); return ctx_r21.disableButtonClick(); });
    ɵɵpipe(1, "translate");
    ɵɵelement(2, "i", 25);
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r6 = ɵɵnextContext(2);
    ɵɵproperty("disabled", !ctx_r6.canUpdate || !ctx_r6.enabled);
    ɵɵattribute("title", ɵɵpipeBind1(1, 2, "Disable"));
} }
function CardComponent_form_0_button_18_Template(rf, ctx) { if (rf & 1) {
    var _r24 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 23);
    ɵɵlistener("click", function CardComponent_form_0_button_18_Template_button_click_0_listener() { ɵɵrestoreView(_r24); var ctx_r23 = ɵɵnextContext(2); return ctx_r23.navigateClick(); });
    ɵɵpipe(1, "translate");
    ɵɵelement(2, "i", 26);
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r7 = ɵɵnextContext(2);
    ɵɵproperty("disabled", !ctx_r7.canNavigate);
    ɵɵattribute("title", ɵɵpipeBind1(1, 2, "Navigate to the card"));
} }
function CardComponent_form_0_button_19_Template(rf, ctx) { if (rf & 1) {
    var _r26 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 27);
    ɵɵlistener("click", function CardComponent_form_0_button_19_Template_button_click_0_listener() { ɵɵrestoreView(_r26); var ctx_r25 = ɵɵnextContext(2); return ctx_r25.deleteButtonClick(); });
    ɵɵpipe(1, "translate");
    ɵɵelement(2, "i", 28);
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r8 = ɵɵnextContext(2);
    ɵɵproperty("disabled", !ctx_r8.canDelete || !ctx_r8.enabled);
    ɵɵattribute("title", ɵɵpipeBind1(1, 2, "Delete"));
} }
function CardComponent_form_0_div_20_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1);
    ɵɵpipe(2, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(2, 1, "The field is required"), " ");
} }
function CardComponent_form_0_div_20_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1);
    ɵɵpipe(2, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r28 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵtextInterpolate2(" ", ɵɵpipeBind1(2, 2, "The minimum value"), ": ", ctx_r28.countMinValue, " ");
} }
function CardComponent_form_0_div_20_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1);
    ɵɵpipe(2, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r29 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵtextInterpolate2(" ", ɵɵpipeBind1(2, 2, "The maximum value"), ": ", ctx_r29.countMaxValue, " ");
} }
function CardComponent_form_0_div_20_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 22);
    ɵɵtemplate(1, CardComponent_form_0_div_20_div_1_Template, 3, 3, "div", 21);
    ɵɵtemplate(2, CardComponent_form_0_div_20_div_2_Template, 3, 4, "div", 21);
    ɵɵtemplate(3, CardComponent_form_0_div_20_div_3_Template, 3, 4, "div", 21);
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r9 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r9.count.errors == null ? null : ctx_r9.count.errors.required);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r9.count.errors == null ? null : ctx_r9.count.errors.min);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r9.count.errors == null ? null : ctx_r9.count.errors.max);
} }
var _c0 = function (a0) { return { disabled: a0 }; };
function CardComponent_form_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "form", 1);
    ɵɵelementStart(1, "div", 2);
    ɵɵelementStart(2, "div", 3);
    ɵɵelementStart(3, "div", 4);
    ɵɵtemplate(4, CardComponent_form_0_div_4_Template, 4, 1, "div", 5);
    ɵɵelement(5, "input", 6);
    ɵɵelementEnd();
    ɵɵtemplate(6, CardComponent_form_0_div_6_Template, 4, 3, "div", 7);
    ɵɵelementEnd();
    ɵɵelementStart(7, "div", 3);
    ɵɵelement(8, "input", 8);
    ɵɵtemplate(9, CardComponent_form_0_div_9_Template, 3, 2, "div", 9);
    ɵɵelementEnd();
    ɵɵelementStart(10, "div", 10);
    ɵɵelement(11, "input", 11);
    ɵɵtemplate(12, CardComponent_form_0_div_12_Template, 3, 2, "div", 9);
    ɵɵelementEnd();
    ɵɵelementStart(13, "div", 12);
    ɵɵelementStart(14, "div", 13);
    ɵɵelement(15, "input", 14);
    ɵɵtemplate(16, CardComponent_form_0_button_16_Template, 3, 4, "button", 15);
    ɵɵtemplate(17, CardComponent_form_0_button_17_Template, 3, 4, "button", 15);
    ɵɵtemplate(18, CardComponent_form_0_button_18_Template, 3, 4, "button", 15);
    ɵɵtemplate(19, CardComponent_form_0_button_19_Template, 3, 4, "button", 16);
    ɵɵelementEnd();
    ɵɵtemplate(20, CardComponent_form_0_div_20_Template, 4, 3, "div", 9);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵɵnextContext();
    ɵɵproperty("formGroup", ctx_r0.formGroup);
    ɵɵadvance(4);
    ɵɵproperty("ngIf", ctx_r0.isVisibleSelect);
    ɵɵadvance(1);
    ɵɵpropertyInterpolate("id", ctx_r0.id);
    ɵɵproperty("readOnly", !ctx_r0.canUpdate);
    ɵɵattribute("class", ctx_r0.cssClass);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.barcode.invalid && (ctx_r0.barcode.dirty || ctx_r0.barcode.touched));
    ɵɵadvance(2);
    ɵɵproperty("readOnly", !ctx_r0.canUpdate);
    ɵɵattribute("class", ctx_r0.cssClass);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.employeeName.invalid && (ctx_r0.employeeName.dirty || ctx_r0.employeeName.touched));
    ɵɵadvance(2);
    ɵɵproperty("readOnly", !ctx_r0.canUpdate);
    ɵɵattribute("class", ctx_r0.cssClass);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.employeeId.invalid && (ctx_r0.employeeId.dirty || ctx_r0.employeeId.touched));
    ɵɵadvance(3);
    ɵɵpropertyInterpolate("min", ctx_r0.countMinValue);
    ɵɵpropertyInterpolate("max", ctx_r0.countMaxValue);
    ɵɵproperty("readOnly", !ctx_r0.canUpdate)("ngClass", ɵɵpureFunction1(22, _c0, !ctx_r0.enabled));
    ɵɵattribute("class", ctx_r0.cssClass);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.isVisibleToggle && ctx_r0.count.value < 1);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.isVisibleToggle && ctx_r0.count.value > 0);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.isVisibleNavigate);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.isVisibleDelete);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.count.invalid && (ctx_r0.count.dirty || ctx_r0.count.touched));
} }
function barcodeInUseValidator(isBarcodeAlreadyInUse) {
    return function (control) {
        var barcodeInUse = isBarcodeAlreadyInUse(control.value);
        return barcodeInUse ? { barcodeInUse: { value: control.value } } : null;
    };
}
/* tslint:disable:no-bitwise */
var ControlsVisibilityFlags;
(function (ControlsVisibilityFlags) {
    ControlsVisibilityFlags[ControlsVisibilityFlags["None"] = 0] = "None";
    ControlsVisibilityFlags[ControlsVisibilityFlags["All"] = 255] = "All";
    ControlsVisibilityFlags[ControlsVisibilityFlags["Default"] = 3] = "Default";
    ControlsVisibilityFlags[ControlsVisibilityFlags["Toggle"] = 1] = "Toggle";
    ControlsVisibilityFlags[ControlsVisibilityFlags["Delete"] = 2] = "Delete";
    ControlsVisibilityFlags[ControlsVisibilityFlags["Select"] = 4] = "Select";
    ControlsVisibilityFlags[ControlsVisibilityFlags["Navigate"] = 8] = "Navigate";
})(ControlsVisibilityFlags || (ControlsVisibilityFlags = {}));
var CardComponent = /** @class */ (function (_super) {
    __extends(CardComponent, _super);
    function CardComponent(renderer, element, cdRef, router) {
        var _this = _super.call(this) || this;
        _this.renderer = renderer;
        _this.element = element;
        _this.cdRef = cdRef;
        _this.router = router;
        _this.id = v4();
        _this.isInactive = false;
        _this.controlsVisibility = ControlsVisibilityFlags.Default;
        _this.employeeRequired = false;
        _this.enabled = true;
        _this.formGroupChanged = new Subject();
        _this.deleteClick = new Subject();
        _this.checkedChanged = new Subject();
        return _this;
    }
    CardComponent.prototype.ngOnInit = function () {
        this.reset();
    };
    CardComponent.prototype.ngOnChanges = function (changes) {
        this.isInactive = false;
        if (changes.enabled != null) {
            this.enabled = changes.enabled.currentValue;
            if (this.formGroup != null) {
                this.cdRef.detectChanges();
            }
        }
        if (changes.barcodeInfo != null) {
            var barcodeInfo = changes.barcodeInfo.currentValue;
            this.barcodeOriginal = barcodeInfo == null ? null : barcodeInfo.name;
        }
    };
    CardComponent.prototype.ngOnDestroy = function () {
        this.formGroupChangedUnsubscribe();
    };
    Object.defineProperty(CardComponent.prototype, "countMinValue", {
        get: function () {
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardComponent.prototype, "countMaxValue", {
        get: function () {
            return 1000;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardComponent.prototype, "barcodeMaxLength", {
        get: function () {
            return 10000;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardComponent.prototype, "employeeNameMaxLength", {
        get: function () {
            return 1000;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardComponent.prototype, "employeeIdMaxLength", {
        get: function () {
            return 100;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardComponent.prototype, "barcode", {
        get: function () {
            return this.formGroup.get('barcode');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardComponent.prototype, "count", {
        get: function () {
            return this.formGroup.get('count');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardComponent.prototype, "employeeName", {
        get: function () {
            return this.formGroup.get('employeeName');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardComponent.prototype, "employeeId", {
        get: function () {
            return this.formGroup.get('employeeId');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardComponent.prototype, "invalid", {
        get: function () {
            return this.formGroup.invalid || this.barcode.value == null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardComponent.prototype, "dirty", {
        get: function () {
            return this.formGroup.dirty;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardComponent.prototype, "pristine", {
        get: function () {
            return this.formGroup.pristine;
        },
        enumerable: true,
        configurable: true
    });
    CardComponent.prototype.reset = function () {
        var emplyeeValidators = this.employeeRequired ? [Validators.required] : [];
        emplyeeValidators.push(Validators.maxLength(this.employeeNameMaxLength));
        this.formGroup = new FormGroup({
            barcode: new FormControl(this.barcodeInfo.name, [
                Validators.required,
                Validators.maxLength(this.barcodeMaxLength),
                barcodeInUseValidator(this.isBarcodeAlreadyInUseEffective.bind(this))
            ]),
            count: new FormControl(this.barcodeInfo.count, [
                Validators.required,
                Validators.min(this.countMinValue),
                Validators.max(this.countMaxValue)
            ]),
            employeeName: new FormControl(this.barcodeInfo.employeeName, emplyeeValidators),
            employeeId: new FormControl(this.barcodeInfo.employeeId, [
                Validators.maxLength(this.employeeIdMaxLength),
            ])
        });
        this.formGroupChangedUnsubscribe();
        this.formGroupChangedSubscribe();
    };
    CardComponent.prototype.formGroupChangedSubscribe = function () {
        var _this = this;
        this.subscriptionValueChanges = this.formGroup.valueChanges.subscribe(function (x) {
            _this.formGroupChanged.next(_this.formGroup);
            _this.barcodeInfo.name = _this.barcode.value;
            _this.barcodeInfo.count = _this.count.value;
            _this.barcodeInfo.employeeName = _this.employeeName.value;
            _this.barcodeInfo.employeeId = _this.employeeId.value;
        });
    };
    CardComponent.prototype.formGroupChangedUnsubscribe = function () {
        if (this.subscriptionValueChanges != null) {
            this.subscriptionValueChanges.unsubscribe();
        }
    };
    CardComponent.prototype.enableButtonClick = function () {
        this.enable();
    };
    CardComponent.prototype.enable = function () {
        this.setCount(1);
    };
    CardComponent.prototype.disableButtonClick = function () {
        this.disable();
    };
    CardComponent.prototype.disable = function () {
        this.setCount(0);
    };
    CardComponent.prototype.setCount = function (value) {
        var count = this.count.value;
        this.count.setValue(value);
        if (count !== value) {
            this.count.markAsDirty();
            this.formGroupChanged.next();
        }
    };
    CardComponent.prototype.deleteButtonClick = function () {
        this.deleteClick.next(this);
    };
    CardComponent.prototype.setFocus = function () {
        document.getElementById(this.id).focus();
    };
    Object.defineProperty(CardComponent.prototype, "cssClass", {
        get: function () {
            return "form-control " + this.cssClassHighlight;
        },
        enumerable: true,
        configurable: true
    });
    CardComponent.prototype.onBarcodeRead = function () {
        this.highlight();
    };
    Object.defineProperty(CardComponent.prototype, "isChecked", {
        get: function () {
            return this._isChecked;
        },
        set: function (value) {
            if (value === this.isChecked) {
                return;
            }
            this._isChecked = value;
            this.checkedChanged.next(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardComponent.prototype, "canNavigate", {
        get: function () {
            return this.url != null;
        },
        enumerable: true,
        configurable: true
    });
    CardComponent.prototype.navigateClick = function () {
        if (this.url != null) {
            this.router.navigateByUrl(this.url);
        }
    };
    Object.defineProperty(CardComponent.prototype, "isVisibleSelect", {
        get: function () {
            return this.isFlagSet(ControlsVisibilityFlags.Select);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardComponent.prototype, "isVisibleToggle", {
        get: function () {
            return this.isFlagSet(ControlsVisibilityFlags.Toggle);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardComponent.prototype, "isVisibleNavigate", {
        get: function () {
            return this.isFlagSet(ControlsVisibilityFlags.Navigate);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardComponent.prototype, "isVisibleDelete", {
        get: function () {
            return this.isFlagSet(ControlsVisibilityFlags.Delete);
        },
        enumerable: true,
        configurable: true
    });
    CardComponent.prototype.isFlagSet = function (flag) {
        return (this.controlsVisibility & flag) > 0;
    };
    CardComponent.prototype.isBarcodeAlreadyInUseEffective = function (barcode) {
        if (this.barcodeOriginal === barcode) {
            return false;
        }
        return this.isBarcodeAlreadyInUse(barcode);
    };
    /** @nocollapse */ CardComponent.ɵfac = function CardComponent_Factory(t) { return new (t || CardComponent)(ɵɵdirectiveInject(Renderer2), ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(ChangeDetectorRef), ɵɵdirectiveInject(Router)); };
    /** @nocollapse */ CardComponent.ɵcmp = ɵɵdefineComponent({ type: CardComponent, selectors: [["lib-card"]], inputs: { selectionMode: "selectionMode", controlsVisibility: "controlsVisibility", url: "url", employeeRequired: "employeeRequired", enabled: "enabled", barcodeInfo: "barcodeInfo", isBarcodeAlreadyInUse: "isBarcodeAlreadyInUse", canDelete: "canDelete", canUpdate: "canUpdate" }, outputs: { formGroupChanged: "formGroupChanged", deleteClick: "deleteClick", checkedChanged: "checkedChanged" }, features: [ɵɵInheritDefinitionFeature, ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["role", "form", 3, "formGroup", 4, "ngIf"], ["role", "form", 3, "formGroup"], [1, "form-row"], [1, "col-3"], [1, "input-group"], ["class", "form-check form-check-inline", 4, "ngIf"], ["type", "text", "formControlName", "barcode", 3, "readOnly", "id"], ["class", "alert alert-danger ml-28p", 4, "ngIf"], ["type", "text", "formControlName", "employeeName", 3, "readOnly"], ["class", "alert alert-danger", 4, "ngIf"], [1, "col-2"], ["type", "text", "formControlName", "employeeId", 3, "readOnly"], [1, "col-4", "pl-0"], [1, "input-group", 2, "margin-left", "5px !important"], ["type", "number", "formControlName", "count", "step", "1", 3, "readOnly", "min", "max", "ngClass"], ["class", "btn btn-outline-light float-right", 3, "disabled", "click", 4, "ngIf"], ["class", "btn btn-outline-light float-right mr-1", 3, "disabled", "click", 4, "ngIf"], [1, "form-check", "form-check-inline"], ["type", "checkbox", 1, "form-check-input", 3, "checked", "change"], ["for", "autoSizingCheck2", 1, "form-check-label"], [1, "alert", "alert-danger", "ml-28p"], [4, "ngIf"], [1, "alert", "alert-danger"], [1, "btn", "btn-outline-light", "float-right", 3, "disabled", "click"], [1, "fa", "fa-lg", "fa-toggle-off", "color-gray"], [1, "fa", "fa-lg", "fa-toggle-on", "color-gray"], [1, "fa", "fa-lg", "fa-id-card-o", "color-gray"], [1, "btn", "btn-outline-light", "float-right", "mr-1", 3, "disabled", "click"], [1, "fa", "fa-lg", "fa-trash", "color-gray"]], template: function CardComponent_Template(rf, ctx) { if (rf & 1) {
            ɵɵtemplate(0, CardComponent_form_0_Template, 21, 24, "form", 0);
        } if (rf & 2) {
            ɵɵproperty("ngIf", ctx.formGroup != null);
        } }, directives: [NgIf, ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, DefaultValueAccessor, NgControlStatus, FormControlName, NumberValueAccessor, NgClass], pipes: [TranslatePipe], styles: [".fa[_ngcontent-%COMP%]{margin-right:0}input.ng-valid.required[_ngcontent-%COMP%], input.ng-valid[required][_ngcontent-%COMP%]{border-left:5px solid #42a948}input.ng-invalid[_ngcontent-%COMP%]{border-left:5px solid #a94442}input.ng-dirty[_ngcontent-%COMP%]{background-color:#ffffb8}.check-box[_ngcontent-%COMP%]{margin-top:12px}.input-group[_ngcontent-%COMP%] > .form-control[_ngcontent-%COMP%]:not(:first-child){border-top-left-radius:.25rem;border-bottom-left-radius:.25rem}.input-group[_ngcontent-%COMP%] > .form-control[_ngcontent-%COMP%]:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.last-inline-control[_ngcontent-%COMP%]{margin-right:5px!important}.ml-28p[_ngcontent-%COMP%]{margin-left:28px}"] });
    return CardComponent;
}(Highlighter));
/*@__PURE__*/ (function () { ɵsetClassMetadata(CardComponent, [{
        type: Component,
        args: [{
                selector: 'lib-card',
                templateUrl: 'card.component.html',
                styleUrls: ['card.component.scss']
            }]
    }], function () { return [{ type: Renderer2 }, { type: ElementRef }, { type: ChangeDetectorRef }, { type: Router }]; }, { selectionMode: [{
            type: Input
        }], controlsVisibility: [{
            type: Input
        }], url: [{
            type: Input
        }], employeeRequired: [{
            type: Input
        }], enabled: [{
            type: Input
        }], barcodeInfo: [{
            type: Input
        }], isBarcodeAlreadyInUse: [{
            type: Input
        }], canDelete: [{
            type: Input
        }], canUpdate: [{
            type: Input
        }], formGroupChanged: [{
            type: Output
        }], deleteClick: [{
            type: Output
        }], checkedChanged: [{
            type: Output
        }] }); })();

var ComboBoxItem = /** @class */ (function () {
    function ComboBoxItem(value, title) {
        if (title === void 0) { title = null; }
        this.value = value;
        this.title = title;
    }
    ComboBoxItem.fromJson = function (x) {
        return new ComboBoxItem(x.value, x.title);
    };
    ComboBoxItem.prototype.toJson = function () {
        return {
            value: this.value,
            title: this.title
        };
    };
    ComboBoxItem.prototype.clone = function () {
        return new ComboBoxItem(this.value, this.title);
    };
    return ComboBoxItem;
}());

var StorageService = /** @class */ (function () {
    function StorageService() {
    }
    StorageService.prototype.get = function (key) {
        return localStorage.getItem(key);
    };
    StorageService.prototype.set = function (key, value) {
        localStorage.setItem(key, value);
    };
    StorageService.prototype.getObject = function (key) {
        var s = this.get(key);
        return s == null ? s : JSON.parse(s);
    };
    StorageService.prototype.setObject = function (key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    };
    StorageService.prototype.remove = function (key) {
        localStorage.removeItem(key);
    };
    /** @nocollapse */ StorageService.ɵfac = function StorageService_Factory(t) { return new (t || StorageService)(); };
    /** @nocollapse */ StorageService.ɵprov = ɵɵdefineInjectable({ token: StorageService, factory: StorageService.ɵfac });
    return StorageService;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(StorageService, [{
        type: Injectable
    }], null, null); })();

function ComboBoxComponent_button_11_Template(rf, ctx) { if (rf & 1) {
    var _r3 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 9);
    ɵɵlistener("click", function ComboBoxComponent_button_11_Template_button_click_0_listener($event) { ɵɵrestoreView(_r3); var ctx_r2 = ɵɵnextContext(); return ctx_r2.onClick($event); });
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    var x_r1 = ctx.$implicit;
    ɵɵattribute("title", x_r1.title);
    ɵɵadvance(1);
    ɵɵtextInterpolate(x_r1.value);
} }
var ComboBoxComponent = /** @class */ (function () {
    function ComboBoxComponent(storageService) {
        this.storageService = storageService;
        this._value = '';
        this.items = [];
        this.cookieKey = 'barcodes';
        this.maxStack = 30;
        this.valueChange = new EventEmitter();
        this.defaultItems = [];
    }
    ComboBoxComponent.prototype.ngOnChanges = function (changes) {
        this.loadValues();
        this.loadSelectedValue();
    };
    ComboBoxComponent.prototype.loadValues = function () {
        var text = this.storageService.get(this.cookieKey);
        if (text == null) {
            this.onReset();
            return;
        }
        var values = JSON.parse(text);
        if (values != null) {
            var items_1 = [];
            values.forEach(function (x) { return items_1.push(ComboBoxItem.fromJson(x)); });
            this.items = items_1;
        }
    };
    ComboBoxComponent.prototype.loadSelectedValue = function () {
        var value = this.storageService.get(this.cookieKeySelected);
        if (value != null) {
            this.value = value;
        }
    };
    Object.defineProperty(ComboBoxComponent.prototype, "cookieKeySelected", {
        get: function () {
            return this.cookieKey + "-selected";
        },
        enumerable: true,
        configurable: true
    });
    ComboBoxComponent.prototype.onFocusout = function () {
        this.updateValues();
        this.saveValues();
    };
    ComboBoxComponent.prototype.saveValues = function () {
        this.storageService.set(this.cookieKey, JSON.stringify(this.items.map(function (x) { return x.toJson(); })));
    };
    ComboBoxComponent.prototype.updateValues = function () {
        var value = this.value;
        if (value == null) {
            return;
        }
        var items = this.items;
        var index = items.findIndex(function (x) { return x.value === value; }, 0);
        if (index > -1) {
            return;
        }
        items.push(new ComboBoxItem(value));
        if (items.length > this.maxStack) {
            this.items.shift();
        }
    };
    ComboBoxComponent.prototype.onClick = function (event) {
        var value = event.target.innerHTML;
        var parser = new DOMParser();
        var dom = parser.parseFromString('<!doctype html><body>' + value, 'text/html');
        this.value = dom.body.textContent;
    };
    ComboBoxComponent.prototype.onDelete = function () {
        var _this = this;
        var index = this.items.findIndex(function (x) { return x.value === _this.value; }, 0);
        if (index > -1) {
            this.items.splice(index, 1);
        }
        this.value = null;
        this.saveValues();
    };
    ComboBoxComponent.prototype.onReset = function () {
        this.items = this.defaultItems.map(function (x) { return x.clone(); });
        this.saveValues();
        this.value = null;
    };
    Object.defineProperty(ComboBoxComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (x) {
            if (x === this.value) {
                return;
            }
            this._value = x;
            this.valueChange.next(x);
            if (x == null || x === '') {
                this.storageService.remove(this.cookieKeySelected);
            }
            else {
                this.storageService.set(this.cookieKeySelected, x);
            }
        },
        enumerable: true,
        configurable: true
    });
    /** @nocollapse */ ComboBoxComponent.ɵfac = function ComboBoxComponent_Factory(t) { return new (t || ComboBoxComponent)(ɵɵdirectiveInject(StorageService)); };
    /** @nocollapse */ ComboBoxComponent.ɵcmp = ɵɵdefineComponent({ type: ComboBoxComponent, selectors: [["lib-combo-box"]], inputs: { cookieKey: "cookieKey", maxStack: "maxStack", defaultItems: "defaultItems" }, outputs: { valueChange: "valueChange" }, features: [ɵɵNgOnChangesFeature], decls: 12, vars: 8, consts: [[1, "form-inline", "input-group", "combobox"], ["type", "text", 1, "form-control", "mr-1", 3, "ngModel", "ngModelChange", "focusout"], [1, "btn", "btn-delete", "mr-1", 3, "click"], [1, "fa", "fa-remove", "fa-button"], [1, "fa", "fa-refresh", "fa-button"], ["ngbDropdown", "", "placement", "bottom-right", 1, "mr-0"], ["id", "dropdownBasic1", "ngbDropdownToggle", "", 1, "btn", "btn-outline-primary"], ["ngbDropdownMenu", "", "aria-labelledby", "dropdownBasic1"], ["class", "dropdown-item", 3, "click", 4, "ngFor", "ngForOf"], [1, "dropdown-item", 3, "click"]], template: function ComboBoxComponent_Template(rf, ctx) { if (rf & 1) {
            ɵɵelementStart(0, "div", 0);
            ɵɵelementStart(1, "input", 1);
            ɵɵlistener("ngModelChange", function ComboBoxComponent_Template_input_ngModelChange_1_listener($event) { return ctx.value = $event; })("focusout", function ComboBoxComponent_Template_input_focusout_1_listener() { return ctx.onFocusout(); });
            ɵɵelementEnd();
            ɵɵelementStart(2, "button", 2);
            ɵɵlistener("click", function ComboBoxComponent_Template_button_click_2_listener() { return ctx.onDelete(); });
            ɵɵpipe(3, "translate");
            ɵɵelement(4, "span", 3);
            ɵɵelementEnd();
            ɵɵelementStart(5, "button", 2);
            ɵɵlistener("click", function ComboBoxComponent_Template_button_click_5_listener() { return ctx.onReset(); });
            ɵɵpipe(6, "translate");
            ɵɵelement(7, "span", 4);
            ɵɵelementEnd();
            ɵɵelementStart(8, "div", 5);
            ɵɵelement(9, "button", 6);
            ɵɵelementStart(10, "div", 7);
            ɵɵtemplate(11, ComboBoxComponent_button_11_Template, 2, 2, "button", 8);
            ɵɵelementEnd();
            ɵɵelementEnd();
            ɵɵelementEnd();
        } if (rf & 2) {
            ɵɵadvance(1);
            ɵɵproperty("ngModel", ctx.value);
            ɵɵadvance(1);
            ɵɵattribute("title", ɵɵpipeBind1(3, 4, "Delete"));
            ɵɵadvance(3);
            ɵɵattribute("title", ɵɵpipeBind1(6, 6, "Reset"));
            ɵɵadvance(6);
            ɵɵproperty("ngForOf", ctx.items);
        } }, directives: [DefaultValueAccessor, NgControlStatus, NgModel, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgForOf], pipes: [TranslatePipe], styles: [".combobox[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{margin-left:0}.combobox[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]{min-width:200px}.btn-delete[_ngcontent-%COMP%]{padding-left:0;padding-right:0;color:#666}.dropdown-item[_ngcontent-%COMP%]{min-width:200px;max-width:600px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}"] });
    return ComboBoxComponent;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(ComboBoxComponent, [{
        type: Component,
        args: [{
                selector: 'lib-combo-box',
                templateUrl: 'combo-box.component.html',
                styleUrls: ['combo-box.component.scss']
            }]
    }], function () { return [{ type: StorageService }]; }, { cookieKey: [{
            type: Input
        }], maxStack: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], defaultItems: [{
            type: Input
        }] }); })();

function ItemsListComponent_span_0_ng_container_1_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 7);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    var item_r2 = ɵɵnextContext(2).$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate(item_r2.name);
} }
function ItemsListComponent_span_0_ng_container_1_a_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "a", 8);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    var item_r2 = ɵɵnextContext(2).$implicit;
    var ctx_r5 = ɵɵnextContext();
    ɵɵproperty("routerLink", ctx_r5.getRouterLink(item_r2));
    ɵɵadvance(1);
    ɵɵtextInterpolate(item_r2.name);
} }
function ItemsListComponent_span_0_ng_container_1_span_3_Template(rf, ctx) { if (rf & 1) {
    var _r11 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "span", 9);
    ɵɵlistener("click", function ItemsListComponent_span_0_ng_container_1_span_3_Template_span_click_0_listener() { ɵɵrestoreView(_r11); var item_r2 = ɵɵnextContext(2).$implicit; var ctx_r9 = ɵɵnextContext(); return ctx_r9.onRemove(item_r2); });
    ɵɵtext(1, "x");
    ɵɵelementEnd();
} }
function ItemsListComponent_span_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, ItemsListComponent_span_0_ng_container_1_span_1_Template, 2, 1, "span", 4);
    ɵɵtemplate(2, ItemsListComponent_span_0_ng_container_1_a_2_Template, 2, 2, "a", 5);
    ɵɵtemplate(3, ItemsListComponent_span_0_ng_container_1_span_3_Template, 2, 0, "span", 6);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    var ctx_r3 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r3.path == null);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r3.path != null);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r3.deleteDisabled);
} }
function ItemsListComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 2);
    ɵɵtemplate(1, ItemsListComponent_span_0_ng_container_1_Template, 4, 3, "ng-container", 3);
    ɵɵelementEnd();
} if (rf & 2) {
    var item_r2 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", item_r2 != null);
} }
function ItemsListComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    var _r13 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "span", 2);
    ɵɵelementStart(1, "span", 10);
    ɵɵlistener("click", function ItemsListComponent_span_1_Template_span_click_1_listener() { ɵɵrestoreView(_r13); var ctx_r12 = ɵɵnextContext(); return ctx_r12.onAdd(); });
    ɵɵtext(2, "+");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
var ItemsListComponent = /** @class */ (function () {
    function ItemsListComponent() {
        this.enabled = true;
        this.itemAdd = new EventEmitter();
        this.itemRemove = new EventEmitter();
    }
    ItemsListComponent.prototype.ngOnInit = function () {
    };
    ItemsListComponent.prototype.onRemove = function (item) {
        if (this.enabled) {
            this.itemRemove.next(item);
        }
    };
    ItemsListComponent.prototype.onAdd = function () {
        if (this.enabled) {
            this.itemAdd.next();
        }
    };
    ItemsListComponent.prototype.getRouterLink = function (item) {
        return [this.path, item.id];
    };
    /** @nocollapse */ ItemsListComponent.ɵfac = function ItemsListComponent_Factory(t) { return new (t || ItemsListComponent)(); };
    /** @nocollapse */ ItemsListComponent.ɵcmp = ɵɵdefineComponent({ type: ItemsListComponent, selectors: [["lib-items-list"]], inputs: { items: "items", addDisabled: "addDisabled", deleteDisabled: "deleteDisabled", path: "path", enabled: "enabled" }, outputs: { itemAdd: "itemAdd", itemRemove: "itemRemove" }, decls: 2, vars: 2, consts: [["class", "item", 4, "ngFor", "ngForOf"], ["class", "item", 4, "ngIf"], [1, "item"], [4, "ngIf"], ["class", "title", 4, "ngIf"], ["class", "title", 3, "routerLink", 4, "ngIf"], ["class", "control delete", 3, "click", 4, "ngIf"], [1, "title"], [1, "title", 3, "routerLink"], [1, "control", "delete", 3, "click"], [1, "control", "add", 3, "click"]], template: function ItemsListComponent_Template(rf, ctx) { if (rf & 1) {
            ɵɵtemplate(0, ItemsListComponent_span_0_Template, 2, 1, "span", 0);
            ɵɵtemplate(1, ItemsListComponent_span_1_Template, 3, 0, "span", 1);
        } if (rf & 2) {
            ɵɵproperty("ngForOf", ctx.items);
            ɵɵadvance(1);
            ɵɵproperty("ngIf", !ctx.addDisabled);
        } }, directives: [NgForOf, NgIf, RouterLinkWithHref], styles: [".item[_ngcontent-%COMP%]{padding:3px;border:1px solid #ced4da;border-radius:.25rem;margin-right:4px;display:inline-block;margin-bottom:4px}.title[_ngcontent-%COMP%]{padding:3px 4px 3px 3px}.control[_ngcontent-%COMP%]{padding-left:3px;padding-right:3px;cursor:pointer}.add[_ngcontent-%COMP%]{color:green}.delete[_ngcontent-%COMP%]{color:red;padding:3px 5px 3px 7px;border-left:1px solid #ced4da}"] });
    return ItemsListComponent;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(ItemsListComponent, [{
        type: Component,
        args: [{
                selector: 'lib-items-list',
                templateUrl: './items-list.component.html',
                styleUrls: ['./items-list.component.css']
            }]
    }], function () { return []; }, { items: [{
            type: Input
        }], addDisabled: [{
            type: Input
        }], deleteDisabled: [{
            type: Input
        }], path: [{
            type: Input
        }], enabled: [{
            type: Input
        }], itemAdd: [{
            type: Output
        }], itemRemove: [{
            type: Output
        }] }); })();

var FmcuCoreNgService = /** @class */ (function () {
    function FmcuCoreNgService() {
    }
    /** @nocollapse */ FmcuCoreNgService.ɵfac = function FmcuCoreNgService_Factory(t) { return new (t || FmcuCoreNgService)(); };
    /** @nocollapse */ FmcuCoreNgService.ɵprov = ɵɵdefineInjectable({ token: FmcuCoreNgService, factory: FmcuCoreNgService.ɵfac, providedIn: 'root' });
    return FmcuCoreNgService;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(FmcuCoreNgService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

var FmcuCoreNgComponent = /** @class */ (function () {
    function FmcuCoreNgComponent() {
    }
    FmcuCoreNgComponent.prototype.ngOnInit = function () {
    };
    /** @nocollapse */ FmcuCoreNgComponent.ɵfac = function FmcuCoreNgComponent_Factory(t) { return new (t || FmcuCoreNgComponent)(); };
    /** @nocollapse */ FmcuCoreNgComponent.ɵcmp = ɵɵdefineComponent({ type: FmcuCoreNgComponent, selectors: [["lib-fmcu-core-ng"]], decls: 2, vars: 0, template: function FmcuCoreNgComponent_Template(rf, ctx) { if (rf & 1) {
            ɵɵelementStart(0, "p");
            ɵɵtext(1, " fmcu-core-ng works! ");
            ɵɵelementEnd();
        } }, encapsulation: 2 });
    return FmcuCoreNgComponent;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(FmcuCoreNgComponent, [{
        type: Component,
        args: [{
                selector: 'lib-fmcu-core-ng',
                template: "\n    <p>\n      fmcu-core-ng works!\n    </p>\n  ",
                styles: []
            }]
    }], function () { return []; }, null); })();

var moment = momentNs;
var momentDF = momentDurationFormat;
momentDF(moment);
var DateTime = /** @class */ (function () {
    function DateTime() {
    }
    DateTime.convertDateToUTC = function (date) {
        return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    };
    DateTime.getDurationString = function (from, to) {
        if (from == null || to == null) {
            return null;
        }
        var ms = moment(to).diff(moment(from));
        return moment.duration(ms, 'milliseconds').format('d [days] hh:mm:ss');
    };
    DateTime.differenceInSeconds = function (date1, date2) {
        return (date1.getTime() - date2.getTime()) / 1000;
    };
    DateTime.fromISOString = function (x) {
        if (x == null) {
            return null;
        }
        return new Date(x);
    };
    DateTime.clone = function (x) {
        return x ? new Date(x.toISOString()) : x;
    };
    return DateTime;
}());

var DateRange = /** @class */ (function () {
    function DateRange(from, to) {
        this.from = from;
        this.to = to;
    }
    DateRange.clone = function (x) {
        return x ? new DateRange(DateTime.clone(x.from), DateTime.clone(x.to)) : x;
    };
    DateRange.equals = function (a, b) {
        return (a &&
            b &&
            a.from &&
            a.to &&
            b.from &&
            b.to &&
            a.from.getTime() === b.from.getTime() &&
            a.to.getTime() === b.to.getTime());
    };
    DateRange.valid = function (x) {
        return x && x.from && x.to && x.from.getTime() <= x.to.getTime();
    };
    return DateRange;
}());

var moment$1 = momentNs;
var PredefinedDateRange;
(function (PredefinedDateRange) {
    PredefinedDateRange[PredefinedDateRange["Today"] = 0] = "Today";
    PredefinedDateRange[PredefinedDateRange["Yesterday"] = 1] = "Yesterday";
    PredefinedDateRange[PredefinedDateRange["ThisWeek"] = 2] = "ThisWeek";
    PredefinedDateRange[PredefinedDateRange["PreviousWeek"] = 3] = "PreviousWeek";
    PredefinedDateRange[PredefinedDateRange["ThisMonth"] = 4] = "ThisMonth";
    PredefinedDateRange[PredefinedDateRange["PreviousMonth"] = 5] = "PreviousMonth";
    PredefinedDateRange[PredefinedDateRange["TwoPreviousMonths"] = 6] = "TwoPreviousMonths";
    PredefinedDateRange[PredefinedDateRange["ThreePreviousMonths"] = 7] = "ThreePreviousMonths";
    PredefinedDateRange[PredefinedDateRange["SixPreviousMonths"] = 8] = "SixPreviousMonths";
    PredefinedDateRange[PredefinedDateRange["ThisYear"] = 9] = "ThisYear";
    PredefinedDateRange[PredefinedDateRange["PreviousYear"] = 10] = "PreviousYear";
    PredefinedDateRange[PredefinedDateRange["Custom"] = 11] = "Custom";
})(PredefinedDateRange || (PredefinedDateRange = {}));
var DateRangeCalculator = /** @class */ (function () {
    function DateRangeCalculator(now) {
        if (now === void 0) { now = null; }
        this.now = now ? now : moment$1().toDate();
    }
    DateRangeCalculator.calculateDateRange = function (pdr, now) {
        if (now === void 0) { now = null; }
        return (new DateRangeCalculator(now)).calculateDateRange(pdr);
    };
    DateRangeCalculator.normalizeFromDate = function (date) {
        return moment$1(date).startOf('d').toDate();
    };
    DateRangeCalculator.normalizeToDate = function (date) {
        return moment$1(date).endOf('d').toDate();
    };
    DateRangeCalculator.localDateFromFormattedString = function (s) {
        return moment$1(s, 'YYYY-MM-DD HH:mm:ss.SSS').toDate();
    };
    DateRangeCalculator.prototype.calculateDateRange = function (pdr) {
        switch (pdr) {
            case PredefinedDateRange.Today:
                return this.fromToday();
            case PredefinedDateRange.Yesterday:
                return this.fromYesterday();
            case PredefinedDateRange.ThisWeek:
                return this.fromThisWeek();
            case PredefinedDateRange.PreviousWeek:
                return this.fromPreviousWeek();
            case PredefinedDateRange.ThisMonth:
                return this.fromThisMonth();
            case PredefinedDateRange.PreviousMonth:
                return this.fromPreviousMonths(1);
            case PredefinedDateRange.TwoPreviousMonths:
                return this.fromPreviousMonths(2);
            case PredefinedDateRange.ThreePreviousMonths:
                return this.fromPreviousMonths(3);
            case PredefinedDateRange.SixPreviousMonths:
                return this.fromPreviousMonths(6);
            case PredefinedDateRange.ThisYear:
                return this.fromThisYear();
            case PredefinedDateRange.PreviousYear:
                return this.fromPreviousYear();
            default:
                return this.fromToday();
        }
    };
    DateRangeCalculator.prototype.fromToday = function () {
        var today = moment$1(this.now);
        return this.createDateRange(today.clone().startOf('d'), today.endOf('d'));
    };
    DateRangeCalculator.prototype.fromYesterday = function () {
        var yesterday = moment$1(this.now).add(-1, 'd');
        return this.createDateRange(yesterday.clone().startOf('d'), yesterday.endOf('d'));
    };
    DateRangeCalculator.prototype.fromThisWeek = function () {
        return this.createDateRange(moment$1(this.now).startOf('isoWeek'), moment$1(this.now).endOf('isoWeek'));
    };
    DateRangeCalculator.prototype.fromPreviousWeek = function () {
        var from = moment$1(this.now)
            .add(-1, 'w')
            .startOf('isoWeek');
        return this.createDateRange(from.clone(), from.endOf('isoWeek'));
    };
    DateRangeCalculator.prototype.fromThisMonth = function () {
        return this.createDateRange(moment$1(this.now).startOf('month'), moment$1(this.now).endOf('month'));
    };
    DateRangeCalculator.prototype.fromPreviousMonths = function (count) {
        count = Math.abs(count);
        var from = moment$1(this.now)
            .add(-count, 'month')
            .startOf('month');
        return this.createDateRange(from.clone(), from.add(count - 1, 'month').endOf('month'));
    };
    DateRangeCalculator.prototype.fromThisYear = function () {
        return this.createDateRange(moment$1(this.now).startOf('year'), moment$1(this.now).endOf('year'));
    };
    DateRangeCalculator.prototype.fromPreviousYear = function () {
        var from = moment$1(this.now)
            .add(-1, 'year')
            .startOf('year');
        return this.createDateRange(from.clone(), from.endOf('year'));
    };
    DateRangeCalculator.prototype.createDateRange = function (from, to) {
        return new DateRange(from.toDate(), to.toDate());
    };
    return DateRangeCalculator;
}());

var ButtonClass = /** @class */ (function () {
    function ButtonClass() {
    }
    ButtonClass.getButtonClass = function (isOutline, buttonType) {
        return (isOutline ? 'btn-outline-' : 'btn-') + buttonType;
    };
    return ButtonClass;
}());

var _c0$1 = function (a0) { return [a0]; };
function PredefinedDateRangeComponent_label_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 3);
    ɵɵelement(1, "input", 4);
    ɵɵtext(2);
    ɵɵpipe(3, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵɵnextContext();
    ɵɵproperty("ngClass", ɵɵpureFunction1(6, _c0$1, ctx_r0.getButtonClass("primary")));
    ɵɵadvance(1);
    ɵɵproperty("value", ctx_r0.pdr.Custom)("disabled", ctx_r0.isDisabled);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(3, 4, "Custom"), " ");
} }
function PredefinedDateRangeComponent_label_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 3);
    ɵɵelement(1, "input", 4);
    ɵɵtext(2);
    ɵɵpipe(3, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵɵnextContext();
    ɵɵproperty("ngClass", ɵɵpureFunction1(6, _c0$1, ctx_r1.getButtonClass("primary")));
    ɵɵadvance(1);
    ɵɵproperty("value", ctx_r1.pdr.Today)("disabled", ctx_r1.isDisabled);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(3, 4, "Today"), " ");
} }
function PredefinedDateRangeComponent_label_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 3);
    ɵɵelement(1, "input", 4);
    ɵɵtext(2);
    ɵɵpipe(3, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r2 = ɵɵnextContext();
    ɵɵproperty("ngClass", ɵɵpureFunction1(6, _c0$1, ctx_r2.getButtonClass("primary")));
    ɵɵadvance(1);
    ɵɵproperty("value", ctx_r2.pdr.Yesterday)("disabled", ctx_r2.isDisabled);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(3, 4, "Yesterday"), " ");
} }
function PredefinedDateRangeComponent_label_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 3);
    ɵɵelement(1, "input", 4);
    ɵɵtext(2);
    ɵɵpipe(3, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r3 = ɵɵnextContext();
    ɵɵproperty("ngClass", ɵɵpureFunction1(6, _c0$1, ctx_r3.getButtonClass("primary")));
    ɵɵadvance(1);
    ɵɵproperty("value", ctx_r3.pdr.ThisWeek)("disabled", ctx_r3.isDisabled);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(3, 4, "This week"), " ");
} }
function PredefinedDateRangeComponent_label_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 3);
    ɵɵelement(1, "input", 4);
    ɵɵtext(2);
    ɵɵpipe(3, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r4 = ɵɵnextContext();
    ɵɵproperty("ngClass", ɵɵpureFunction1(6, _c0$1, ctx_r4.getButtonClass("primary")));
    ɵɵadvance(1);
    ɵɵproperty("value", ctx_r4.pdr.PreviousWeek)("disabled", ctx_r4.isDisabled);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(3, 4, "Previous week"), " ");
} }
function PredefinedDateRangeComponent_label_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 3);
    ɵɵelement(1, "input", 4);
    ɵɵtext(2);
    ɵɵpipe(3, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r5 = ɵɵnextContext();
    ɵɵproperty("ngClass", ɵɵpureFunction1(6, _c0$1, ctx_r5.getButtonClass("primary")));
    ɵɵadvance(1);
    ɵɵproperty("value", ctx_r5.pdr.ThisMonth)("disabled", ctx_r5.isDisabled);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(3, 4, "This month"), " ");
} }
function PredefinedDateRangeComponent_label_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 3);
    ɵɵelement(1, "input", 4);
    ɵɵtext(2);
    ɵɵpipe(3, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r6 = ɵɵnextContext();
    ɵɵproperty("ngClass", ɵɵpureFunction1(6, _c0$1, ctx_r6.getButtonClass("primary")));
    ɵɵadvance(1);
    ɵɵproperty("value", ctx_r6.pdr.PreviousMonth)("disabled", ctx_r6.isDisabled);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(3, 4, "Previous month"), " ");
} }
function PredefinedDateRangeComponent_label_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 3);
    ɵɵelement(1, "input", 4);
    ɵɵtext(2);
    ɵɵpipe(3, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r7 = ɵɵnextContext();
    ɵɵproperty("ngClass", ɵɵpureFunction1(6, _c0$1, ctx_r7.getButtonClass("primary")));
    ɵɵadvance(1);
    ɵɵproperty("value", ctx_r7.pdr.TwoPreviousMonths)("disabled", ctx_r7.isDisabled);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(3, 4, "Two previous months"), " ");
} }
function PredefinedDateRangeComponent_label_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 3);
    ɵɵelement(1, "input", 4);
    ɵɵtext(2);
    ɵɵpipe(3, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r8 = ɵɵnextContext();
    ɵɵproperty("ngClass", ɵɵpureFunction1(6, _c0$1, ctx_r8.getButtonClass("primary")));
    ɵɵadvance(1);
    ɵɵproperty("value", ctx_r8.pdr.ThreePreviousMonths)("disabled", ctx_r8.isDisabled);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(3, 4, "Three previous months"), " ");
} }
function PredefinedDateRangeComponent_label_11_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 3);
    ɵɵelement(1, "input", 4);
    ɵɵtext(2);
    ɵɵpipe(3, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r9 = ɵɵnextContext();
    ɵɵproperty("ngClass", ɵɵpureFunction1(6, _c0$1, ctx_r9.getButtonClass("primary")));
    ɵɵadvance(1);
    ɵɵproperty("value", ctx_r9.pdr.SixPreviousMonths)("disabled", ctx_r9.isDisabled);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(3, 4, "Six previous months"), " ");
} }
function PredefinedDateRangeComponent_label_12_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 3);
    ɵɵelement(1, "input", 4);
    ɵɵtext(2);
    ɵɵpipe(3, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r10 = ɵɵnextContext();
    ɵɵproperty("ngClass", ɵɵpureFunction1(6, _c0$1, ctx_r10.getButtonClass("primary")));
    ɵɵadvance(1);
    ɵɵproperty("value", ctx_r10.pdr.ThisYear)("disabled", ctx_r10.isDisabled);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(3, 4, "This year"), " ");
} }
function PredefinedDateRangeComponent_label_13_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 3);
    ɵɵelement(1, "input", 4);
    ɵɵtext(2);
    ɵɵpipe(3, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r11 = ɵɵnextContext();
    ɵɵproperty("ngClass", ɵɵpureFunction1(6, _c0$1, ctx_r11.getButtonClass("primary")));
    ɵɵadvance(1);
    ɵɵproperty("value", ctx_r11.pdr.PreviousYear)("disabled", ctx_r11.isDisabled);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(3, 4, "Previous year"), " ");
} }
var moment$2 = momentNs;
var KEY_PREDEFINED_DATE_RANGE = 'predefined-date-range';
var KEY_CUSTOM_DATE_RANGE_FROM = 'custom-date-range-from';
var KEY_CUSTOM_DATE_RANGE_TO = 'custom-date-range-to';
var PredefinedDateRangeComponent = /** @class */ (function () {
    function PredefinedDateRangeComponent(storageService, cdRef) {
        this.storageService = storageService;
        this.cdRef = cdRef;
        this.disabled = false;
        this.predefinedDateRangeChanged = new Subject();
        this.pdr = PredefinedDateRange;
        this.supressEvent = false;
        this.savedSystemDate = moment$2();
        this.updateDateRange();
    }
    PredefinedDateRangeComponent.prototype.ngOnInit = function () {
        this.systemDateChangedInterval = undefined;
        this.initializePredefinedDateRangeComponent();
        this.startTimer();
    };
    PredefinedDateRangeComponent.prototype.ngOnDestroy = function () {
        this.stopTimer();
    };
    PredefinedDateRangeComponent.prototype.ngOnChanges = function (changes) {
        if (changes.disabled != null) {
            this.disabled = changes.disabled.currentValue;
            this.cdRef.detectChanges();
        }
    };
    PredefinedDateRangeComponent.prototype.startTimer = function () {
        var _this = this;
        this.systemDateChangedInterval = setTimeout(function () {
            if (moment$2(_this.savedSystemDate).date() !== moment$2().date()) {
                console.log('Date changed');
                _this.savedSystemDate = moment$2();
                _this.updateDateRange();
            }
            _this.startTimer();
        }, 10000);
    };
    PredefinedDateRangeComponent.prototype.stopTimer = function () {
        clearInterval(this.systemDateChangedInterval);
    };
    PredefinedDateRangeComponent.prototype.getButtonClass = function (buttonType) {
        return ButtonClass.getButtonClass(this.outlineButtons, buttonType);
    };
    PredefinedDateRangeComponent.prototype.initializePredefinedDateRangeComponent = function () {
        var from = DateTime.fromISOString(this.storageService.get(KEY_CUSTOM_DATE_RANGE_FROM));
        var to = DateTime.fromISOString(this.storageService.get(KEY_CUSTOM_DATE_RANGE_TO));
        var customDateRange = from && to
            ? new DateRange(from, to)
            : DateRangeCalculator.calculateDateRange(PredefinedDateRange.Today);
        var predefinedDateRange = parseInt(this.storageService.get(KEY_PREDEFINED_DATE_RANGE), 10);
        if (predefinedDateRange === NaN ||
            PredefinedDateRange[predefinedDateRange] == null) {
            predefinedDateRange = PredefinedDateRange.Today;
        }
        this.customDateRange = customDateRange;
        this.predefinedDateRange = predefinedDateRange;
    };
    Object.defineProperty(PredefinedDateRangeComponent.prototype, "predefinedDateRange", {
        get: function () {
            return this._predefinedDateRange;
        },
        set: function (x) {
            this._predefinedDateRange = x;
            this.storageService.set(KEY_PREDEFINED_DATE_RANGE, x.toString());
            this.updateDateRange();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PredefinedDateRangeComponent.prototype, "customDateRange", {
        get: function () {
            return this._customDateRange;
        },
        set: function (dr) {
            if (!dr) {
                console.error('updateDateRange received an empty value');
                return;
            }
            if (this._customDateRange != null && DateRange.equals(this._customDateRange, dr)) {
                return;
            }
            this._customDateRange = dr;
            this.putDateToCookie(KEY_CUSTOM_DATE_RANGE_FROM, dr ? dr.from : null);
            this.putDateToCookie(KEY_CUSTOM_DATE_RANGE_TO, dr ? dr.to : null);
            this.supressEvent = true;
            var c = new DateRangeCalculator();
            var r = Object.values(PredefinedDateRange)
                .map(function (x) { return x; })
                .filter(function (x) { return !isNaN(Number(x)); })
                .filter(function (x) { return x !== PredefinedDateRange.Custom; })
                .filter(function (x) { return DateRange.equals(dr, c.calculateDateRange(x)); });
            var predefinedDateRange = r.length ? r[0] : PredefinedDateRange.Custom;
            this.predefinedDateRange = predefinedDateRange;
            this.supressEvent = false;
        },
        enumerable: true,
        configurable: true
    });
    PredefinedDateRangeComponent.prototype.putDateToCookie = function (cookieName, x) {
        this.storageService.set(cookieName, x ? x.toISOString() : null);
    };
    Object.defineProperty(PredefinedDateRangeComponent.prototype, "dateRange", {
        get: function () {
            return this._dateRange;
        },
        set: function (x) {
            this._dateRange = x;
            if (!this.supressEvent) {
                this.predefinedDateRangeChanged.next(x);
            }
        },
        enumerable: true,
        configurable: true
    });
    PredefinedDateRangeComponent.prototype.changed = function () {
        this.updateDateRange();
    };
    PredefinedDateRangeComponent.prototype.updateDateRange = function () {
        if (this.predefinedDateRange === PredefinedDateRange.Custom) {
            this.dateRange = this.customDateRange;
            return;
        }
        this.dateRange = DateRangeCalculator.calculateDateRange(this.predefinedDateRange);
    };
    PredefinedDateRangeComponent.prototype.showButton = function (x) {
        return this.buttonsCount === undefined || x <= this.buttonsCount - 1;
    };
    Object.defineProperty(PredefinedDateRangeComponent.prototype, "isDisabled", {
        get: function () {
            return this.disabled != null && this.disabled;
        },
        enumerable: true,
        configurable: true
    });
    /** @nocollapse */ PredefinedDateRangeComponent.ɵfac = function PredefinedDateRangeComponent_Factory(t) { return new (t || PredefinedDateRangeComponent)(ɵɵdirectiveInject(StorageService), ɵɵdirectiveInject(ChangeDetectorRef)); };
    /** @nocollapse */ PredefinedDateRangeComponent.ɵcmp = ɵɵdefineComponent({ type: PredefinedDateRangeComponent, selectors: [["lib-predefined-date-range"]], inputs: { outlineButtons: "outlineButtons", buttonsCount: "buttonsCount", disabled: "disabled" }, outputs: { predefinedDateRangeChanged: "predefinedDateRangeChanged" }, features: [ɵɵNgOnChangesFeature], decls: 14, vars: 13, consts: [["ngbRadioGroup", "", "name", "radioBasic", 1, "btn-group", 3, "ngModel", "ngModelChange"], [1, "btn-group-toggle", "btn-group-justified"], ["ngbButtonLabel", "", 3, "ngClass", 4, "ngIf"], ["ngbButtonLabel", "", 3, "ngClass"], ["ngbButton", "", "type", "radio", 3, "value", "disabled"]], template: function PredefinedDateRangeComponent_Template(rf, ctx) { if (rf & 1) {
            ɵɵelementStart(0, "div", 0);
            ɵɵlistener("ngModelChange", function PredefinedDateRangeComponent_Template_div_ngModelChange_0_listener($event) { return ctx.predefinedDateRange = $event; })("ngModelChange", function PredefinedDateRangeComponent_Template_div_ngModelChange_0_listener() { return ctx.changed(); });
            ɵɵelementStart(1, "div", 1);
            ɵɵtemplate(2, PredefinedDateRangeComponent_label_2_Template, 4, 8, "label", 2);
            ɵɵtemplate(3, PredefinedDateRangeComponent_label_3_Template, 4, 8, "label", 2);
            ɵɵtemplate(4, PredefinedDateRangeComponent_label_4_Template, 4, 8, "label", 2);
            ɵɵtemplate(5, PredefinedDateRangeComponent_label_5_Template, 4, 8, "label", 2);
            ɵɵtemplate(6, PredefinedDateRangeComponent_label_6_Template, 4, 8, "label", 2);
            ɵɵtemplate(7, PredefinedDateRangeComponent_label_7_Template, 4, 8, "label", 2);
            ɵɵtemplate(8, PredefinedDateRangeComponent_label_8_Template, 4, 8, "label", 2);
            ɵɵtemplate(9, PredefinedDateRangeComponent_label_9_Template, 4, 8, "label", 2);
            ɵɵtemplate(10, PredefinedDateRangeComponent_label_10_Template, 4, 8, "label", 2);
            ɵɵtemplate(11, PredefinedDateRangeComponent_label_11_Template, 4, 8, "label", 2);
            ɵɵtemplate(12, PredefinedDateRangeComponent_label_12_Template, 4, 8, "label", 2);
            ɵɵtemplate(13, PredefinedDateRangeComponent_label_13_Template, 4, 8, "label", 2);
            ɵɵelementEnd();
            ɵɵelementEnd();
        } if (rf & 2) {
            ɵɵproperty("ngModel", ctx.predefinedDateRange);
            ɵɵadvance(2);
            ɵɵproperty("ngIf", ctx.showButton(0));
            ɵɵadvance(1);
            ɵɵproperty("ngIf", ctx.showButton(1));
            ɵɵadvance(1);
            ɵɵproperty("ngIf", ctx.showButton(2));
            ɵɵadvance(1);
            ɵɵproperty("ngIf", ctx.showButton(3));
            ɵɵadvance(1);
            ɵɵproperty("ngIf", ctx.showButton(4));
            ɵɵadvance(1);
            ɵɵproperty("ngIf", ctx.showButton(5));
            ɵɵadvance(1);
            ɵɵproperty("ngIf", ctx.showButton(6));
            ɵɵadvance(1);
            ɵɵproperty("ngIf", ctx.showButton(7));
            ɵɵadvance(1);
            ɵɵproperty("ngIf", ctx.showButton(8));
            ɵɵadvance(1);
            ɵɵproperty("ngIf", ctx.showButton(9));
            ɵɵadvance(1);
            ɵɵproperty("ngIf", ctx.showButton(10));
            ɵɵadvance(1);
            ɵɵproperty("ngIf", ctx.showButton(11));
        } }, directives: [NgbRadioGroup, NgControlStatus, NgModel, NgIf, NgbButtonLabel, NgClass, NgbRadio], pipes: [TranslatePipe], styles: [".btn-group-justified[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{margin-bottom:10px}.btn.focus[_ngcontent-%COMP%], .btn[_ngcontent-%COMP%]:focus{outline:0;box-shadow:none}"] });
    return PredefinedDateRangeComponent;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(PredefinedDateRangeComponent, [{
        type: Component,
        args: [{
                selector: 'lib-predefined-date-range',
                templateUrl: 'predefined-date-range.component.html',
                styleUrls: ['predefined-date-range.component.scss']
            }]
    }], function () { return [{ type: StorageService }, { type: ChangeDetectorRef }]; }, { outlineButtons: [{
            type: Input
        }], buttonsCount: [{
            type: Input
        }], disabled: [{
            type: Input
        }], predefinedDateRangeChanged: [{
            type: Output
        }] }); })();

var TIME_MIN = new Date('0001-01-01T00:00:00').getTime();
var LocalizedDatePipe = /** @class */ (function () {
    function LocalizedDatePipe(translateService) {
        this.translateService = translateService;
    }
    LocalizedDatePipe.prototype.transform = function (value, pattern) {
        if (pattern === void 0) { pattern = 'medium'; }
        if (value instanceof Date && value.getTime() <= TIME_MIN) {
            return '';
        }
        var datePipe = new DatePipe(this.translateService.currentLang);
        if (pattern === 'mediumDateTime') {
            return datePipe.transform(value, 'mediumDate') + " " + datePipe.transform(value, 'mediumTime');
        }
        else if (pattern === 'mediumDate') {
            return datePipe.transform(value, 'mediumDate');
        }
        else if (pattern === 'monthYear') {
            return datePipe.transform(value, 'LLLL') + ", " + datePipe.transform(value, 'yyyy');
        }
        return datePipe.transform(value, pattern);
    };
    /** @nocollapse */ LocalizedDatePipe.ɵfac = function LocalizedDatePipe_Factory(t) { return new (t || LocalizedDatePipe)(ɵɵdirectiveInject(TranslateService)); };
    /** @nocollapse */ LocalizedDatePipe.ɵpipe = ɵɵdefinePipe({ name: "localizedDate", type: LocalizedDatePipe, pure: false });
    return LocalizedDatePipe;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(LocalizedDatePipe, [{
        type: Pipe,
        args: [{
                name: 'localizedDate',
                pure: false
            }]
    }], function () { return [{ type: TranslateService }]; }, null); })();

function DatepickerRangeComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    var _r6 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "span", 3);
    ɵɵlistener("mouseenter", function DatepickerRangeComponent_ng_template_2_Template_span_mouseenter_0_listener() { ɵɵrestoreView(_r6); var date_r3 = ctx.date; var ctx_r5 = ɵɵnextContext(); return ctx_r5.hoveredDate = date_r3; })("mouseleave", function DatepickerRangeComponent_ng_template_2_Template_span_mouseleave_0_listener() { ɵɵrestoreView(_r6); var ctx_r7 = ɵɵnextContext(); return ctx_r7.hoveredDate = null; });
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    var date_r3 = ctx.date;
    var focused_r4 = ctx.focused;
    var ctx_r2 = ɵɵnextContext();
    ɵɵclassProp("focused", focused_r4)("range", ctx_r2.isRange(date_r3))("faded", ctx_r2.isHovered(date_r3) || ctx_r2.isInside(date_r3));
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", date_r3.day, " ");
} }
var DatepickerRangeComponent = /** @class */ (function () {
    function DatepickerRangeComponent(calendar) {
        this.enabled = true;
        this.fromDate = calendar.getToday();
        this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);
    }
    DatepickerRangeComponent.prototype.getDateFromNgbDate = function (ngbDate) {
        return ngbDate == null
            ? null
            : new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day);
    };
    Object.defineProperty(DatepickerRangeComponent.prototype, "from", {
        get: function () {
            return this.getDateFromNgbDate(this.fromDate);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatepickerRangeComponent.prototype, "to", {
        get: function () {
            return this.getDateFromNgbDate(this.toDate);
        },
        enumerable: true,
        configurable: true
    });
    DatepickerRangeComponent.prototype.onDateSelection = function (date) {
        if (!this.fromDate && !this.toDate) {
            this.fromDate = date;
        }
        else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
            this.toDate = date;
        }
        else {
            this.toDate = null;
            this.fromDate = date;
        }
    };
    DatepickerRangeComponent.prototype.isHovered = function (date) {
        return (this.fromDate &&
            !this.toDate &&
            this.hoveredDate &&
            date.after(this.fromDate) &&
            date.before(this.hoveredDate));
    };
    DatepickerRangeComponent.prototype.isInside = function (date) {
        return date.after(this.fromDate) && date.before(this.toDate);
    };
    DatepickerRangeComponent.prototype.isRange = function (date) {
        return (date.equals(this.fromDate) ||
            date.equals(this.toDate) ||
            this.isInside(date) ||
            this.isHovered(date));
    };
    /** @nocollapse */ DatepickerRangeComponent.ɵfac = function DatepickerRangeComponent_Factory(t) { return new (t || DatepickerRangeComponent)(ɵɵdirectiveInject(NgbCalendar)); };
    /** @nocollapse */ DatepickerRangeComponent.ɵcmp = ɵɵdefineComponent({ type: DatepickerRangeComponent, selectors: [["lib-datepicker-range"]], decls: 12, vars: 10, consts: [[3, "displayMonths", "dayTemplate", "select"], ["dp", ""], ["t", ""], [1, "custom-day", 3, "mouseenter", "mouseleave"]], template: function DatepickerRangeComponent_Template(rf, ctx) { if (rf & 1) {
            ɵɵelementStart(0, "ngb-datepicker", 0, 1);
            ɵɵlistener("select", function DatepickerRangeComponent_Template_ngb_datepicker_select_0_listener($event) { return ctx.onDateSelection($event); });
            ɵɵelementEnd();
            ɵɵtemplate(2, DatepickerRangeComponent_ng_template_2_Template, 2, 7, "ng-template", null, 2, ɵɵtemplateRefExtractor);
            ɵɵelementStart(4, "div");
            ɵɵelementStart(5, "strong");
            ɵɵtext(6);
            ɵɵpipe(7, "localizedDate");
            ɵɵelementEnd();
            ɵɵtext(8, " - ");
            ɵɵelementStart(9, "strong");
            ɵɵtext(10);
            ɵɵpipe(11, "localizedDate");
            ɵɵelementEnd();
            ɵɵelementEnd();
        } if (rf & 2) {
            var _r1 = ɵɵreference(3);
            ɵɵproperty("displayMonths", 5)("dayTemplate", _r1);
            ɵɵadvance(6);
            ɵɵtextInterpolate(ɵɵpipeBind2(7, 4, ctx.from, "mediumDate"));
            ɵɵadvance(4);
            ɵɵtextInterpolate(ɵɵpipeBind2(11, 7, ctx.to, "mediumDate"));
        } }, directives: [NgbDatepicker], pipes: [LocalizedDatePipe], styles: [".custom-day[_ngcontent-%COMP%]{text-align:center;padding:.185rem .25rem;display:inline-block;height:2rem;width:2rem}.custom-day.focused[_ngcontent-%COMP%]{background-color:#e6e6e6}.custom-day.range[_ngcontent-%COMP%], .custom-day[_ngcontent-%COMP%]:hover{background-color:#0275d8;color:#fff}.custom-day.faded[_ngcontent-%COMP%]{background-color:rgba(2,117,216,.5)}"] });
    return DatepickerRangeComponent;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(DatepickerRangeComponent, [{
        type: Component,
        args: [{
                selector: 'lib-datepicker-range',
                templateUrl: 'datepicker-range.component.html',
                styleUrls: ['datepicker-range.component.scss']
            }]
    }], function () { return [{ type: NgbCalendar }]; }, null); })();

var _c0$2 = ["dp"];
function DateRangeSelectionComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    var _r6 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "span", 7);
    ɵɵlistener("mouseenter", function DateRangeSelectionComponent_ng_template_8_Template_span_mouseenter_0_listener() { ɵɵrestoreView(_r6); var date_r3 = ctx.date; var ctx_r5 = ɵɵnextContext(); return ctx_r5.hoveredDate = ctx_r5.toDate(date_r3); })("mouseleave", function DateRangeSelectionComponent_ng_template_8_Template_span_mouseleave_0_listener() { ɵɵrestoreView(_r6); var ctx_r7 = ɵɵnextContext(); return ctx_r7.hoveredDate = null; });
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    var date_r3 = ctx.date;
    var focused_r4 = ctx.focused;
    var ctx_r2 = ɵɵnextContext();
    ɵɵclassProp("focused", focused_r4)("range", ctx_r2.isFrom(date_r3) || ctx_r2.isTo(date_r3) || ctx_r2.isInside(date_r3) || ctx_r2.isHovered(date_r3))("faded", ctx_r2.isHovered(date_r3) || ctx_r2.isInside(date_r3));
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", date_r3.day, " ");
} }
var _c1 = function (a1) { return ["btn", a1]; };
var moment$3 = momentNs;
var DateRangeSelectionComponent = /** @class */ (function () {
    function DateRangeSelectionComponent(localizedDatePipe) {
        this.localizedDatePipe = localizedDatePipe;
        this.placeholder = 'starting today';
        this.dateRangeChanged = new Subject();
        this.isOpen = false;
    }
    DateRangeSelectionComponent.prototype.ngOnInit = function () { };
    DateRangeSelectionComponent.prototype.ngOnChanges = function (changes) {
        if (changes.disabled != null) {
            this.disabled = changes.disabled.currentValue;
        }
    };
    DateRangeSelectionComponent.prototype.getButtonClass = function (buttonType) {
        return ButtonClass.getButtonClass(this.outlineButtons, buttonType);
    };
    Object.defineProperty(DateRangeSelectionComponent.prototype, "dateRange", {
        get: function () {
            return this._dateRange;
        },
        set: function (x) {
            this._dateRange = x;
            this.from = x.from;
            this.to = x.to;
        },
        enumerable: true,
        configurable: true
    });
    DateRangeSelectionComponent.prototype.onClick = function (element) {
        var host = document.getElementById('dateRangePicker');
        if (this.datePicker && this.isOpen && !this.isDescendant(host, element)) {
            this.emit(true, 'onClick(element)');
        }
    };
    Object.defineProperty(DateRangeSelectionComponent.prototype, "width", {
        get: function () {
            return 1.6 * this.getTextWidth(this.formattedDateRange, 'Arial 14px');
        },
        enumerable: true,
        configurable: true
    });
    DateRangeSelectionComponent.prototype.getTextWidth = function (text, font) {
        // if given, use cached canvas for better performance
        // else, create new canvas
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        context.font = font;
        var metrics = context.measureText(text);
        return metrics.width;
    };
    DateRangeSelectionComponent.prototype.calendarClick = function () {
        this.datePicker.toggle();
        this.isOpen = !this.isOpen;
    };
    DateRangeSelectionComponent.prototype.emit = function (close, callContext) {
        var from = this.from ? this.from : new Date(Date.now());
        var to = this.to ? this.to : from;
        this.dateRange = new DateRange(DateRangeCalculator.normalizeFromDate(from), DateRangeCalculator.normalizeToDate(to));
        this.dateRangeChanged.next(this.dateRange);
        if (close) {
            this.isOpen = false;
            this.datePicker.close();
        }
    };
    /*
     * Check whether or not an element is a child of another element
     *
     * @private
     * @param {any} parent
     * @param {any} child
     * @returns if child is a descendant of parent
     * @memberof DateRangeSelectionComponent
     */
    DateRangeSelectionComponent.prototype.isDescendant = function (parent, child) {
        var node = child;
        while (node !== null) {
            if (node === parent) {
                return true;
            }
            else {
                node = node.parentNode;
            }
        }
        return false;
    };
    Object.defineProperty(DateRangeSelectionComponent.prototype, "formattedDateRange", {
        get: function () {
            if (!this.from) {
                return "missing start date";
            }
            var normalizedFrom = DateRangeCalculator.normalizeFromDate(this.from);
            var to = this.to ? this.to : this.from;
            var normalizedTo = DateRangeCalculator.normalizeToDate(to);
            var strFrom = this.localizedDatePipe.transform(normalizedFrom, 'mediumDate');
            var strTo = this.localizedDatePipe.transform(normalizedTo, 'mediumDate');
            return strFrom + " - " + strTo;
        },
        enumerable: true,
        configurable: true
    });
    DateRangeSelectionComponent.prototype.onDateSelection = function (date) {
        if (!this.from && !this.to) {
            this.from = this.toDate(date);
        }
        else if (this.from &&
            !this.to &&
            this.toMoment(date).isAfter(this.from)) {
            this.to = this.toDate(date);
            this.emit(true, 'onDateSelection');
        }
        else {
            this.to = null;
            this.from = this.toDate(date);
        }
    };
    DateRangeSelectionComponent.prototype.toDate = function (dateStruct) {
        return dateStruct
            ? new Date(dateStruct.year, dateStruct.month - 1, dateStruct.day)
            : null;
    };
    DateRangeSelectionComponent.prototype.toMoment = function (dateStruct) {
        return moment$3(this.toDate(dateStruct));
    };
    DateRangeSelectionComponent.prototype.isHovered = function (date) {
        return (this.from &&
            !this.to &&
            this.hoveredDate &&
            this.toMoment(date).isAfter(this.from) &&
            this.toMoment(date).isBefore(this.hoveredDate));
    };
    DateRangeSelectionComponent.prototype.isInside = function (date) {
        return (this.toMoment(date).isAfter(moment$3(this.from).startOf('day')) &&
            this.toMoment(date).isBefore(moment$3(this.to).startOf('day')));
    };
    DateRangeSelectionComponent.prototype.isFrom = function (date) {
        return this.toMoment(date).isSame(this.from, 'd');
    };
    DateRangeSelectionComponent.prototype.isTo = function (date) {
        return this.toMoment(date).isSame(this.to, 'd');
    };
    /** @nocollapse */ DateRangeSelectionComponent.ɵfac = function DateRangeSelectionComponent_Factory(t) { return new (t || DateRangeSelectionComponent)(ɵɵdirectiveInject(LocalizedDatePipe)); };
    /** @nocollapse */ DateRangeSelectionComponent.ɵcmp = ɵɵdefineComponent({ type: DateRangeSelectionComponent, selectors: [["lib-date-range-selection"]], viewQuery: function DateRangeSelectionComponent_Query(rf, ctx) { if (rf & 1) {
            ɵɵstaticViewQuery(_c0$2, true);
        } if (rf & 2) {
            var _t;
            ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.datePicker = _t.first);
        } }, hostBindings: function DateRangeSelectionComponent_HostBindings(rf, ctx) { if (rf & 1) {
            ɵɵlistener("click", function DateRangeSelectionComponent_click_HostBindingHandler($event) { return ctx.onClick($event.target); }, false, ɵɵresolveDocument);
        } }, inputs: { placeholder: "placeholder", outlineButtons: "outlineButtons", disabled: "disabled", dateRange: "dateRange" }, outputs: { dateRangeChanged: "dateRangeChanged" }, features: [ɵɵNgOnChangesFeature], decls: 10, vars: 14, consts: [[1, "form-inline"], [1, "form-group"], ["id", "dateRangePicker", 1, "input-group"], ["id", "dateRange", "name", "dp", "ngbDatepicker", "", "readonly", "", 1, "form-control", "mr-0", 3, "placeholder", "value", "displayMonths", "dayTemplate", "autoClose", "dateSelect", "click"], ["dp", "ngbDatepicker"], ["type", "button", 3, "ngClass", "disabled", "click"], ["t", ""], [1, "custom-day", 3, "mouseenter", "mouseleave"]], template: function DateRangeSelectionComponent_Template(rf, ctx) { if (rf & 1) {
            ɵɵelementStart(0, "form", 0);
            ɵɵelementStart(1, "div", 1);
            ɵɵelementStart(2, "div", 2);
            ɵɵelementStart(3, "input", 3, 4);
            ɵɵlistener("dateSelect", function DateRangeSelectionComponent_Template_input_dateSelect_3_listener($event) { return ctx.onDateSelection($event); })("click", function DateRangeSelectionComponent_Template_input_click_3_listener() { return ctx.calendarClick(); });
            ɵɵelementEnd();
            ɵɵelementStart(5, "button", 5);
            ɵɵlistener("click", function DateRangeSelectionComponent_Template_button_click_5_listener() { return ctx.calendarClick(); });
            ɵɵtext(6);
            ɵɵpipe(7, "translate");
            ɵɵelementEnd();
            ɵɵelementEnd();
            ɵɵelementEnd();
            ɵɵelementEnd();
            ɵɵtemplate(8, DateRangeSelectionComponent_ng_template_8_Template, 2, 7, "ng-template", null, 6, ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            var _r1 = ɵɵreference(9);
            ɵɵadvance(3);
            ɵɵstyleProp("width", ctx.width, "px");
            ɵɵproperty("placeholder", ctx.placeholder)("value", ctx.formattedDateRange)("displayMonths", 2)("dayTemplate", _r1)("autoClose", false);
            ɵɵadvance(2);
            ɵɵproperty("ngClass", ɵɵpureFunction1(12, _c1, ctx.getButtonClass("primary")))("disabled", ctx.disabled);
            ɵɵadvance(1);
            ɵɵtextInterpolate(ɵɵpipeBind1(7, 10, "Change"));
        } }, directives: [ɵangular_packages_forms_forms_y, NgControlStatusGroup, NgForm, NgbInputDatepicker, NgClass], pipes: [TranslatePipe], styles: [".custom-day[_ngcontent-%COMP%]{text-align:center;padding:.185rem .25rem;display:inline-block;height:2rem;width:2rem}.custom-day.focused[_ngcontent-%COMP%]{background-color:#e6e6e6}.custom-day.range[_ngcontent-%COMP%], .custom-day[_ngcontent-%COMP%]:hover{background-color:#0275d8;color:#fff}.custom-day.faded[_ngcontent-%COMP%]{background-color:rgba(2,117,216,.5)}#dateRangePicker[_ngcontent-%COMP%]   input.form-control[_ngcontent-%COMP%]{border:none;cursor:pointer;background-color:transparent}#dateRangePicker[_ngcontent-%COMP%]   i.material-icons[_ngcontent-%COMP%]{position:absolute;right:0;top:calc(50% - 12px)}.btn-fa[_ngcontent-%COMP%]{padding-right:1px;background-color:transparent}.btn-fa[_ngcontent-%COMP%]:hover{background-color:#eee}"] });
    return DateRangeSelectionComponent;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(DateRangeSelectionComponent, [{
        type: Component,
        args: [{
                selector: 'lib-date-range-selection',
                templateUrl: './date-range-selection.component.html',
                styleUrls: ['./date-range-selection.component.scss']
            }]
    }], function () { return [{ type: LocalizedDatePipe }]; }, { datePicker: [{
            type: ViewChild,
            args: ['dp', { static: true }]
        }], placeholder: [{
            type: Input
        }], outlineButtons: [{
            type: Input
        }], disabled: [{
            type: Input
        }], dateRangeChanged: [{
            type: Output
        }], dateRange: [{
            type: Input
        }], onClick: [{
            type: HostListener,
            args: ['document:click', ['$event.target']]
        }] }); })();

var CompositeDateRangeComponent = /** @class */ (function () {
    function CompositeDateRangeComponent() {
        this._dateRange = new DateRange(new Date(Date.now()), new Date(Date.now()));
        this.dateRangeChanged = new Subject$1();
    }
    CompositeDateRangeComponent.prototype.ngOnInit = function () { };
    CompositeDateRangeComponent.prototype.ngAfterViewInit = function () {
        this.dateRangeSelectionComponent.dateRange = this.predefinedDateRangeComponent.dateRange;
    };
    CompositeDateRangeComponent.prototype.getButtonClass = function (buttonType) {
        return ButtonClass.getButtonClass(this.outlineButtons, buttonType);
    };
    CompositeDateRangeComponent.prototype.onDateRangeSelectionChanged = function (x) {
        this.predefinedDateRangeComponent.customDateRange = x;
        this.dateRange = DateRange.clone(x);
    };
    CompositeDateRangeComponent.prototype.onPredefinedDateRangeChanged = function (x) {
        if (this.dateRangeSelectionComponent) {
            this.dateRangeSelectionComponent.dateRange = x;
        }
        this.dateRange = DateRange.clone(x);
    };
    Object.defineProperty(CompositeDateRangeComponent.prototype, "dateRange", {
        get: function () {
            return this._dateRange;
        },
        set: function (x) {
            if (this._dateRange && DateRange.equals(this._dateRange, x)) {
                return;
            }
            this._dateRange = x;
            this.dateRangeChanged.next(x);
        },
        enumerable: true,
        configurable: true
    });
    /** @nocollapse */ CompositeDateRangeComponent.ɵfac = function CompositeDateRangeComponent_Factory(t) { return new (t || CompositeDateRangeComponent)(); };
    /** @nocollapse */ CompositeDateRangeComponent.ɵcmp = ɵɵdefineComponent({ type: CompositeDateRangeComponent, selectors: [["lib-composite-date-range"]], viewQuery: function CompositeDateRangeComponent_Query(rf, ctx) { if (rf & 1) {
            ɵɵstaticViewQuery(PredefinedDateRangeComponent, true);
            ɵɵstaticViewQuery(DateRangeSelectionComponent, true);
        } if (rf & 2) {
            var _t;
            ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.predefinedDateRangeComponent = _t.first);
            ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.dateRangeSelectionComponent = _t.first);
        } }, inputs: { outlineButtons: "outlineButtons", buttonsCount: "buttonsCount", disabled: "disabled" }, outputs: { dateRangeChanged: "dateRangeChanged" }, decls: 6, vars: 5, consts: [[2, "float", "left"], [3, "outlineButtons", "buttonsCount", "disabled", "predefinedDateRangeChanged"], [3, "outlineButtons", "disabled", "dateRangeChanged"], [2, "clear", "left"]], template: function CompositeDateRangeComponent_Template(rf, ctx) { if (rf & 1) {
            ɵɵelementStart(0, "div");
            ɵɵelementStart(1, "div", 0);
            ɵɵelementStart(2, "lib-predefined-date-range", 1);
            ɵɵlistener("predefinedDateRangeChanged", function CompositeDateRangeComponent_Template_lib_predefined_date_range_predefinedDateRangeChanged_2_listener($event) { return ctx.onPredefinedDateRangeChanged($event); });
            ɵɵelementEnd();
            ɵɵelementEnd();
            ɵɵelementStart(3, "div", 0);
            ɵɵelementStart(4, "lib-date-range-selection", 2);
            ɵɵlistener("dateRangeChanged", function CompositeDateRangeComponent_Template_lib_date_range_selection_dateRangeChanged_4_listener($event) { return ctx.onDateRangeSelectionChanged($event); });
            ɵɵelementEnd();
            ɵɵelementEnd();
            ɵɵelementEnd();
            ɵɵelement(5, "div", 3);
        } if (rf & 2) {
            ɵɵadvance(2);
            ɵɵproperty("outlineButtons", ctx.outlineButtons)("buttonsCount", ctx.buttonsCount)("disabled", ctx.disabled);
            ɵɵadvance(2);
            ɵɵproperty("outlineButtons", ctx.outlineButtons)("disabled", ctx.disabled);
        } }, directives: [PredefinedDateRangeComponent, DateRangeSelectionComponent], styles: [""] });
    return CompositeDateRangeComponent;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(CompositeDateRangeComponent, [{
        type: Component,
        args: [{
                selector: 'lib-composite-date-range',
                templateUrl: 'composite-date-range.component.html',
                styleUrls: ['composite-date-range.component.scss']
            }]
    }], function () { return []; }, { predefinedDateRangeComponent: [{
            type: ViewChild,
            args: [PredefinedDateRangeComponent, { static: true }]
        }], dateRangeSelectionComponent: [{
            type: ViewChild,
            args: [DateRangeSelectionComponent, { static: true }]
        }], outlineButtons: [{
            type: Input
        }], dateRangeChanged: [{
            type: Output
        }], buttonsCount: [{
            type: Input
        }], disabled: [{
            type: Input
        }] }); })();

var _c0$3 = function (a0) { return [a0]; };
function GroupingComponent_label_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 3);
    ɵɵelement(1, "input", 4);
    ɵɵtext(2);
    ɵɵpipe(3, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    var groupingItem_r1 = ctx.$implicit;
    var ctx_r0 = ɵɵnextContext();
    ɵɵproperty("ngClass", ɵɵpureFunction1(5, _c0$3, ctx_r0.getButtonClass("primary")));
    ɵɵadvance(1);
    ɵɵproperty("value", groupingItem_r1);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(3, 3, groupingItem_r1), " ");
} }
var COOKIE_PREDEFINED_GROUPING = 'predefined-grouping';
var GroupingComponent = /** @class */ (function () {
    function GroupingComponent(storageService) {
        this.storageService = storageService;
        this.coockieName = COOKIE_PREDEFINED_GROUPING;
        this.groupingTypeChanged = new Subject$1();
    }
    GroupingComponent.prototype.ngOnInit = function () {
        this.restoreSelectedGroupingType();
    };
    GroupingComponent.prototype.getButtonClass = function (buttonType) {
        return ButtonClass.getButtonClass(this.outlineButtons, buttonType);
    };
    GroupingComponent.prototype.restoreSelectedGroupingType = function () {
        var savedValue = this.storageService.get(this.coockieName);
        if (savedValue == null || this.groupingType[savedValue] == null || this.groupingType[savedValue] === undefined) {
            var keys = Object.keys(this.groupingType);
            if (keys.length > 0) {
                this._selectedGroupingType = this.groupingType[keys[0]];
            }
        }
        else {
            this._selectedGroupingType = this.groupingType[savedValue];
        }
    };
    Object.defineProperty(GroupingComponent.prototype, "selectedGroupingType", {
        get: function () {
            return this._selectedGroupingType;
        },
        set: function (x) {
            this._selectedGroupingType = x;
            this.storageService.set(this.coockieName, this.getGroupingTypeKeyByValue(x));
            this.groupingTypeChanged.next(x);
        },
        enumerable: true,
        configurable: true
    });
    GroupingComponent.prototype.getGroupingTypeValues = function () {
        var _this = this;
        return Object.keys(this.groupingType).map(function (x) { return _this.groupingType[x]; });
    };
    GroupingComponent.prototype.getGroupingTypeKeyByValue = function (value) {
        var _this = this;
        if (value == null || value === undefined) {
            return '';
        }
        var keys = Object.keys(this.groupingType).filter(function (x) { return _this.groupingType[x] === value; });
        if (keys === undefined || keys.length === 0) {
            return '';
        }
        return keys[0];
    };
    /** @nocollapse */ GroupingComponent.ɵfac = function GroupingComponent_Factory(t) { return new (t || GroupingComponent)(ɵɵdirectiveInject(StorageService)); };
    /** @nocollapse */ GroupingComponent.ɵcmp = ɵɵdefineComponent({ type: GroupingComponent, selectors: [["lib-grouping"]], inputs: { groupingType: "groupingType", coockieName: "coockieName", outlineButtons: "outlineButtons" }, outputs: { groupingTypeChanged: "groupingTypeChanged" }, decls: 3, vars: 2, consts: [["ngbRadioGroup", "", "name", "radioBasic", 1, "btn-group", "mr-0", 3, "ngModel", "ngModelChange"], [1, "btn-group-toggle", "btn-group-justified"], ["ngbButtonLabel", "", 3, "ngClass", 4, "ngFor", "ngForOf"], ["ngbButtonLabel", "", 3, "ngClass"], ["ngbButton", "", "type", "radio", 3, "value"]], template: function GroupingComponent_Template(rf, ctx) { if (rf & 1) {
            ɵɵelementStart(0, "div", 0);
            ɵɵlistener("ngModelChange", function GroupingComponent_Template_div_ngModelChange_0_listener($event) { return ctx.selectedGroupingType = $event; });
            ɵɵelementStart(1, "div", 1);
            ɵɵtemplate(2, GroupingComponent_label_2_Template, 4, 7, "label", 2);
            ɵɵelementEnd();
            ɵɵelementEnd();
        } if (rf & 2) {
            ɵɵproperty("ngModel", ctx.selectedGroupingType);
            ɵɵadvance(2);
            ɵɵproperty("ngForOf", ctx.getGroupingTypeValues());
        } }, directives: [NgbRadioGroup, NgControlStatus, NgModel, NgForOf, NgbButtonLabel, NgClass, NgbRadio], pipes: [TranslatePipe], styles: [".btn-group-toggle[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:last-child{margin-right:0}"] });
    return GroupingComponent;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(GroupingComponent, [{
        type: Component,
        args: [{
                selector: 'lib-grouping',
                templateUrl: './grouping.component.html',
                styleUrls: ['./grouping.component.css']
            }]
    }], function () { return [{ type: StorageService }]; }, { groupingType: [{
            type: Input
        }], coockieName: [{
            type: Input
        }], outlineButtons: [{
            type: Input
        }], groupingTypeChanged: [{
            type: Output
        }] }); })();

var STATISTICS_TEST_DATA = [
    { count: '-1', barcode: '', date: '2018-07-03T10:22:52.032000Z', gate: 'gate 1' },
    { count: '-1', barcode: '', date: '2018-07-03T10:35:10.962000Z', gate: 'gate 1' },
    { count: '-1', barcode: 'sdfs', date: '2018-07-03T10:36:06.643000Z', gate: 'gate 1' },
    { count: '1', barcode: '', date: '2018-07-03T10:40:04.251000Z', gate: 'gate 1' },
    { count: '1', barcode: '', date: '2018-07-03T10:41:00.851000Z', gate: 'gate 1' },
    { count: '1', barcode: 'sss', date: '2018-07-03T10:41:02.092000Z', gate: 'gate 1' },
    { count: '-1', barcode: '', date: '2018-07-03T10:22:52.032000Z', gate: 'gate 1' },
    { count: '-1', barcode: '', date: '2018-07-03T10:35:10.962000Z', gate: 'gate 1' },
    { count: '-1', barcode: 'sdfs', date: '2018-07-03T10:36:06.643000Z', gate: 'gate 1' },
    { count: '1', barcode: '', date: '2018-07-03T10:40:04.251000Z', gate: 'gate 1' },
    { count: '1', barcode: '', date: '2018-07-03T10:41:00.851000Z', gate: 'gate 1' },
    { count: '1', barcode: 'sss', date: '2018-07-03T10:41:02.092000Z', gate: 'gate 1' },
    { count: '-1', barcode: '', date: '2018-07-03T10:22:52.032000Z', gate: 'gate 2' },
    { count: '-1', barcode: '', date: '2018-07-03T10:35:10.962000Z', gate: 'gate 2' },
    { count: '-1', barcode: 'sdfs', date: '2018-07-03T10:36:06.643000Z', gate: 'gate 2' },
    { count: '1', barcode: '', date: '2018-07-03T10:40:04.251000Z', gate: 'gate 2' },
    { count: '1', barcode: '', date: '2018-07-03T10:41:00.851000Z', gate: 'gate 2' },
    { count: '1', barcode: 'sss', date: '2018-07-03T10:41:02.092000Z', gate: 'gate 2' },
    { count: '-1', barcode: '', date: '2018-07-03T10:22:52.032000Z', gate: 'gate 2' },
    { count: '-1', barcode: '', date: '2018-07-03T10:35:10.962000Z', gate: 'gate 2' },
    { count: '-1', barcode: 'sdfs', date: '2018-07-03T10:36:06.643000Z', gate: 'gate 2' },
    { count: '1', barcode: '', date: '2018-07-03T10:40:04.251000Z', gate: 'gate 2' },
    { count: '1', barcode: '', date: '2018-07-03T10:41:00.851000Z', gate: 'gate 2' },
    { count: '1', barcode: 'sss', date: '2018-07-03T10:41:02.092000Z', gate: 'gate 2' },
    { count: '-1', barcode: '', date: '2018-07-03T10:22:52.032000Z', gate: 'gate 3' },
    { count: '-1', barcode: '', date: '2018-07-03T10:35:10.962000Z', gate: 'gate 3' },
    { count: '-1', barcode: 'sdfs', date: '2018-07-03T10:36:06.643000Z', gate: 'gate 3' },
    { count: '1', barcode: '', date: '2018-07-03T10:40:04.251000Z', gate: 'gate 3' },
    { count: '1', barcode: '', date: '2018-07-03T10:41:00.851000Z', gate: 'gate 3' },
    { count: '1', barcode: 'sss', date: '2018-07-03T10:41:02.092000Z', gate: 'gate 3' },
    { count: '-1', barcode: '', date: '2018-07-03T10:22:52.032000Z', gate: 'gate 3' },
    { count: '-1', barcode: '', date: '2018-07-03T10:35:10.962000Z', gate: 'gate 3' },
    { count: '-1', barcode: 'sdfs', date: '2018-07-03T10:36:06.643000Z', gate: 'gate 3' },
    { count: '1', barcode: '', date: '2018-07-03T10:40:04.251000Z', gate: 'gate 3' },
    { count: '1', barcode: '', date: '2018-07-03T10:41:00.851000Z', gate: 'gate 3' },
    { count: '1', barcode: 'sss', date: '2018-07-03T10:41:02.092000Z', gate: 'gate 3' },
    { count: '-1', barcode: '', date: '2018-07-03T10:22:52.032000Z', gate: 'gate 4' },
    { count: '-1', barcode: '', date: '2018-07-03T10:35:10.962000Z', gate: 'gate 4' },
    { count: '-1', barcode: 'sdfs', date: '2018-07-03T10:36:06.643000Z', gate: 'gate 4' },
    { count: '1', barcode: '', date: '2018-07-03T10:40:04.251000Z', gate: 'gate 4' },
    { count: '1', barcode: '', date: '2018-07-03T10:41:00.851000Z', gate: 'gate 4' },
    { count: '1', barcode: 'sss', date: '2018-07-03T10:41:02.092000Z', gate: 'gate 4' },
    { count: '-1', barcode: '', date: '2018-07-03T10:22:52.032000Z', gate: 'gate 4' },
    { count: '-1', barcode: '', date: '2018-07-03T10:35:10.962000Z', gate: 'gate 4' },
    { count: '-1', barcode: 'sdfs', date: '2018-07-03T10:36:06.643000Z', gate: 'gate 4' },
    { count: '1', barcode: '', date: '2018-07-03T10:40:04.251000Z', gate: 'gate 4' },
    { count: '1', barcode: '', date: '2018-07-03T10:41:00.851000Z', gate: 'gate 4' },
    { count: '1', barcode: 'sss', date: '2018-07-03T10:41:02.092000Z', gate: 'gate 4' },
    { count: '-1', barcode: '', date: '2018-07-03T10:22:52.032000Z', gate: 'gate 5' },
    { count: '-1', barcode: '', date: '2018-07-03T10:35:10.962000Z', gate: 'gate 5' },
    { count: '-1', barcode: 'sdfs', date: '2018-07-03T10:36:06.643000Z', gate: 'gate 5' },
    { count: '1', barcode: '', date: '2018-07-03T10:40:04.251000Z', gate: 'gate 5' },
    { count: '1', barcode: '', date: '2018-07-03T10:41:00.851000Z', gate: 'gate 5' },
    { count: '1', barcode: 'sss', date: '2018-07-03T10:41:02.092000Z', gate: 'gate 5' },
    { count: '-1', barcode: '', date: '2018-07-03T10:22:52.032000Z', gate: 'gate 5' },
    { count: '-1', barcode: '', date: '2018-07-03T10:35:10.962000Z', gate: 'gate 5' },
    { count: '-1', barcode: 'sdfs', date: '2018-07-03T10:36:06.643000Z', gate: 'gate 5' },
    { count: '1', barcode: '', date: '2018-07-03T10:40:04.251000Z', gate: 'gate 5' },
    { count: '1', barcode: '', date: '2018-07-03T10:41:00.851000Z', gate: 'gate 5' },
    { count: '1', barcode: 'sss', date: '2018-07-03T10:41:02.092000Z', gate: 'gate 5' }
];

var DateGroupingEnum;
(function (DateGroupingEnum) {
    DateGroupingEnum["None"] = "Off";
    DateGroupingEnum["Day"] = "By Day";
    DateGroupingEnum["Month"] = "By Month";
})(DateGroupingEnum || (DateGroupingEnum = {}));

var EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
var EXCEL_EXTENSION = 'xlsx';
var ExcelService = /** @class */ (function () {
    function ExcelService() {
    }
    ExcelService.prototype.exportAsExcelFile = function (json, fileName) {
        var worksheet = utils.json_to_sheet(json);
        var workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        var buffer = write(workbook, { bookType: EXCEL_EXTENSION, type: 'array' });
        this.saveAsExcelFile(buffer, fileName);
    };
    ExcelService.prototype.saveAsExcelFile = function (buffer, fileName) {
        var data = new Blob([buffer], { type: EXCEL_TYPE });
        saveAs(data, fileName + "-" + new Date().getTime() + "." + EXCEL_EXTENSION);
    };
    /** @nocollapse */ ExcelService.ɵfac = function ExcelService_Factory(t) { return new (t || ExcelService)(); };
    /** @nocollapse */ ExcelService.ɵprov = ɵɵdefineInjectable({ token: ExcelService, factory: ExcelService.ɵfac });
    return ExcelService;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(ExcelService, [{
        type: Injectable
    }], null, null); })();

var ProjectConfiguration = /** @class */ (function () {
    function ProjectConfiguration() {
        this.environment = {};
        this.tokenCookieName = 'token';
        this.allowSimpleWebsocket = false;
        this.baseHref = null;
    }
    return ProjectConfiguration;
}());

var ProjectConfigurationService = /** @class */ (function () {
    function ProjectConfigurationService(projectConfiguration) {
        this._tokenCookieName = 'token';
        this._allowSimpleWebsocket = false;
        this._baseHref = null;
        this._environment = projectConfiguration.environment || {};
        this._tokenCookieName = projectConfiguration.tokenCookieName || this.tokenCookieName;
        this._allowSimpleWebsocket = projectConfiguration.allowSimpleWebsocket || false;
        this._baseHref = projectConfiguration.baseHref || null;
    }
    Object.defineProperty(ProjectConfigurationService.prototype, "name", {
        get: function () {
            return this._environment.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProjectConfigurationService.prototype, "production", {
        get: function () {
            return this._environment.production || false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProjectConfigurationService.prototype, "environment", {
        get: function () {
            return this._environment;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProjectConfigurationService.prototype, "baseUrl", {
        get: function () {
            return location.hostname + ":" + location.port;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProjectConfigurationService.prototype, "tokenCookieName", {
        get: function () {
            return this._tokenCookieName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProjectConfigurationService.prototype, "baseHttpUrl", {
        get: function () {
            return location.protocol + "//" + this.baseUrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProjectConfigurationService.prototype, "baseWsUrl", {
        get: function () {
            return (location.protocol === 'http:' ? 'ws:' : 'wss:') + "//" + this.baseUrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProjectConfigurationService.prototype, "allowSimpleWebsocket", {
        get: function () {
            return this._allowSimpleWebsocket;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProjectConfigurationService.prototype, "baseHref", {
        get: function () {
            return this._baseHref;
        },
        enumerable: true,
        configurable: true
    });
    /** @nocollapse */ ProjectConfigurationService.ɵfac = function ProjectConfigurationService_Factory(t) { return new (t || ProjectConfigurationService)(ɵɵinject(ProjectConfiguration)); };
    /** @nocollapse */ ProjectConfigurationService.ɵprov = ɵɵdefineInjectable({ token: ProjectConfigurationService, factory: ProjectConfigurationService.ɵfac });
    return ProjectConfigurationService;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(ProjectConfigurationService, [{
        type: Injectable
    }], function () { return [{ type: ProjectConfiguration }]; }, null); })();

var BaseBackendApiService = /** @class */ (function () {
    function BaseBackendApiService(http, projectConfigurationService) {
        this.http = http;
        this.projectConfigurationService = projectConfigurationService;
    }
    Object.defineProperty(BaseBackendApiService.prototype, "apiUrl", {
        get: function () {
            return this.projectConfigurationService.baseHttpUrl + "/api";
        },
        enumerable: true,
        configurable: true
    });
    BaseBackendApiService.prototype.getVersion = function () {
        return this.http.get(this.apiUrl + "/misc/version", { responseType: 'text' });
    };
    BaseBackendApiService.prototype.getDate = function () {
        return this.http.get(this.apiUrl + "/misc/date", { responseType: 'text' });
    };
    BaseBackendApiService.prototype.login = function (username, password) {
        return this.http.post(this.apiUrl + "/login", JSON.stringify({ name: username, password: password }), { responseType: 'text' });
    };
    BaseBackendApiService.prototype.prolongateToken = function (token) {
        return this.http.post(this.apiUrl + "/prolongate-token", JSON.stringify(token), { responseType: 'text' });
    };
    BaseBackendApiService.prototype.validateLoggedOnUserByName = function (name) {
        return this.http.post(this.apiUrl + "/validate-logged-on-user-by-name/" + name, JSON.stringify({}));
    };
    BaseBackendApiService.prototype.getUiConfiguration = function () {
        return this.http.get(this.apiUrl + "/misc/ui-configuration");
    };
    /** @nocollapse */ BaseBackendApiService.ɵfac = function BaseBackendApiService_Factory(t) { return new (t || BaseBackendApiService)(ɵɵinject(HttpClient), ɵɵinject(ProjectConfigurationService)); };
    /** @nocollapse */ BaseBackendApiService.ɵprov = ɵɵdefineInjectable({ token: BaseBackendApiService, factory: BaseBackendApiService.ɵfac });
    return BaseBackendApiService;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(BaseBackendApiService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }, { type: ProjectConfigurationService }]; }, null); })();

var BackendEventsService = /** @class */ (function () {
    function BackendEventsService(projectConfigurationService) {
        this.projectConfigurationService = projectConfigurationService;
        this._isWebsocketConnected = false;
        this._isConnectedToDatabase = false;
        this.websocketConnectionChanged = new Subject$1();
        this.connectionToDatabaseChanged = new Subject$1();
        this.eventReceived = new Subject$1();
        this.pingSubject = new Subject$1();
        var baseHref = projectConfigurationService.baseHref;
        var extendedPart = baseHref ? "/" + baseHref + "/socket-browser" : '/socket-browser';
        var url = "" + projectConfigurationService.baseWsUrl + extendedPart;
        console.log("websocket url: " + url);
        this.websocketSubject = webSocket(url);
    }
    BackendEventsService.prototype.startListening = function () {
        var _this = this;
        this.stopListening();
        console.log('Start listening');
        this.websocketSubscription = this.websocketSubject.pipe(tap(function (x) {
            _this.isWebsocketConnected = true;
            if (x.ping !== undefined) {
                _this.onPing(x.ping);
            }
        }), filter(function (x) { return x.ping === undefined; })).subscribe(function (x) {
            _this.eventReceived.next(x);
        }, function (e) {
            _this.isWebsocketConnected = false;
            console.error(e);
        }, function () { });
    };
    BackendEventsService.prototype.stopListening = function () {
        if (this.websocketSubscription != null) {
            console.log('Stop listening');
            this.websocketSubscription.unsubscribe();
        }
    };
    Object.defineProperty(BackendEventsService.prototype, "isWebsocketConnected", {
        get: function () {
            return this._isWebsocketConnected;
        },
        set: function (value) {
            if (this._isWebsocketConnected === value) {
                return;
            }
            this._isWebsocketConnected = value;
            this.websocketConnectionChanged.next(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BackendEventsService.prototype, "isConnectedToDatabase", {
        get: function () {
            return this._isConnectedToDatabase;
        },
        set: function (x) {
            if (x === this.isConnectedToDatabase) {
                return;
            }
            this._isConnectedToDatabase = x;
            this.connectionToDatabaseChanged.next(x);
        },
        enumerable: true,
        configurable: true
    });
    BackendEventsService.prototype.onPing = function (ping) {
        this.isConnectedToDatabase = ping.db_connected;
        this.pingSubject.next(ping);
    };
    /** @nocollapse */ BackendEventsService.ɵfac = function BackendEventsService_Factory(t) { return new (t || BackendEventsService)(ɵɵinject(ProjectConfigurationService)); };
    /** @nocollapse */ BackendEventsService.ɵprov = ɵɵdefineInjectable({ token: BackendEventsService, factory: BackendEventsService.ɵfac });
    return BackendEventsService;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(BackendEventsService, [{
        type: Injectable
    }], function () { return [{ type: ProjectConfigurationService }]; }, null); })();

var BackendDateService = /** @class */ (function () {
    function BackendDateService(backendApiService, backendEventsService) {
        var _this = this;
        this.backendEventsService = backendEventsService;
        this._date = null;
        this.dateChanged = new Subject$1();
        this.backendAvailabiltyChanged = new Subject$1();
        this._isBackendAvailable = false;
        this.backendApiService = backendApiService;
        this.backendEventsService.websocketConnectionChanged.subscribe(function (x) {
            if (!x) {
                _this.date = null;
            }
        });
        this.updateDate();
    }
    BackendDateService.prototype.schedule = function () {
        var _this = this;
        setTimeout(function () { return _this.updateDate(); }, 5000);
    };
    BackendDateService.prototype.updateDate = function () {
        var _this = this;
        this.backendApiService.getDate().subscribe(function (x) {
            _this.date = new Date(x);
            _this.schedule();
        }, function (e) {
            _this.date = null;
            _this.schedule();
        });
    };
    Object.defineProperty(BackendDateService.prototype, "date", {
        get: function () {
            return this._date;
        },
        set: function (x) {
            this._date = x;
            this.dateChanged.next(x);
            this.isBackendAvailable = x != null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BackendDateService.prototype, "isBackendAvailable", {
        get: function () {
            return this._isBackendAvailable;
        },
        set: function (x) {
            if (x === this._isBackendAvailable) {
                return;
            }
            this._isBackendAvailable = x;
            this.backendAvailabiltyChanged.next(x);
        },
        enumerable: true,
        configurable: true
    });
    /** @nocollapse */ BackendDateService.ɵfac = function BackendDateService_Factory(t) { return new (t || BackendDateService)(ɵɵinject(BaseBackendApiService), ɵɵinject(BackendEventsService)); };
    /** @nocollapse */ BackendDateService.ɵprov = ɵɵdefineInjectable({ token: BackendDateService, factory: BackendDateService.ɵfac });
    return BackendDateService;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(BackendDateService, [{
        type: Injectable
    }], function () { return [{ type: BaseBackendApiService }, { type: BackendEventsService }]; }, null); })();

var UITextService = /** @class */ (function () {
    function UITextService(translateService, projectConfigurationService, backendDateService, backendApiService) {
        var _this = this;
        this.translateService = translateService;
        this.backendDateService = backendDateService;
        this.backendApiService = backendApiService;
        this._UIText = {};
        var uitext = projectConfigurationService.environment.uitext || {};
        this._UIText = Object.assign({}, uitext);
        backendDateService.backendAvailabiltyChanged.subscribe(function (x) { return _this.onBackendAvailabiltyChanged(x); });
        this.updateUiTextFromHost();
    }
    UITextService.prototype.onBackendAvailabiltyChanged = function (isAvailable) {
        if (isAvailable) {
            this.updateUiTextFromHost();
        }
    };
    UITextService.prototype.updateUiTextFromHost = function () {
        var _this = this;
        this.backendApiService.getUiConfiguration().subscribe(function (x) { return _this._UIText = x; }, function (e) { return console.error(e); });
    };
    Object.defineProperty(UITextService.prototype, "UIText", {
        get: function () {
            return this._UIText;
        },
        set: function (value) {
            this._UIText = value || {};
        },
        enumerable: true,
        configurable: true
    });
    UITextService.prototype.getUIText = function (uiKey) {
        return uiKey ? this._UIText[uiKey] || uiKey : uiKey;
    };
    UITextService.prototype.getUITextlLocalized = function (uiKey) {
        var label = this.getUIText(uiKey);
        return label ? this.translateService.instant(label) : label;
    };
    /** @nocollapse */ UITextService.ɵfac = function UITextService_Factory(t) { return new (t || UITextService)(ɵɵinject(TranslateService), ɵɵinject(ProjectConfigurationService), ɵɵinject(BackendDateService), ɵɵinject(BaseBackendApiService)); };
    /** @nocollapse */ UITextService.ɵprov = ɵɵdefineInjectable({ token: UITextService, factory: UITextService.ɵfac });
    return UITextService;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(UITextService, [{
        type: Injectable
    }], function () { return [{ type: TranslateService }, { type: ProjectConfigurationService }, { type: BackendDateService }, { type: BaseBackendApiService }]; }, null); })();

var UITextTranslatePipe = /** @class */ (function () {
    function UITextTranslatePipe(uiTextService) {
        this.uiTextService = uiTextService;
    }
    UITextTranslatePipe.prototype.transform = function (value, args) {
        return this.uiTextService.getUITextlLocalized(value);
    };
    /** @nocollapse */ UITextTranslatePipe.ɵfac = function UITextTranslatePipe_Factory(t) { return new (t || UITextTranslatePipe)(ɵɵdirectiveInject(UITextService)); };
    /** @nocollapse */ UITextTranslatePipe.ɵpipe = ɵɵdefinePipe({ name: "uitexttranslate", type: UITextTranslatePipe, pure: false });
    return UITextTranslatePipe;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(UITextTranslatePipe, [{
        type: Pipe,
        args: [{
                name: 'uitexttranslate',
                pure: false
            }]
    }], function () { return [{ type: UITextService }]; }, null); })();

function StatisticsComponent_ng_template_25_Template(rf, ctx) { if (rf & 1) {
    ɵɵtext(0);
    ɵɵpipe(1, "localizedDate");
} if (rf & 2) {
    var value_r5 = ctx.value;
    var ctx_r0 = ɵɵnextContext();
    ɵɵtextInterpolate1(" ", ɵɵpipeBind2(1, 1, value_r5, ctx_r0.dateFormat), " ");
} }
function StatisticsComponent_ngx_datatable_column_26_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "ngx-datatable-column", 17);
    ɵɵpipe(1, "uitexttranslate");
} if (rf & 2) {
    ɵɵproperty("name", ɵɵpipeBind1(1, 2, "Gate"))("width", 200);
} }
function StatisticsComponent_ngx_datatable_column_27_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "ngx-datatable-column", 18);
    ɵɵpipe(1, "uitexttranslate");
} if (rf & 2) {
    ɵɵproperty("name", ɵɵpipeBind1(1, 2, "City"))("width", 200);
} }
function StatisticsComponent_ngx_datatable_column_28_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "ngx-datatable-column", 19);
    ɵɵpipe(1, "uitexttranslate");
} if (rf & 2) {
    ɵɵproperty("name", ɵɵpipeBind1(1, 2, "Country"))("width", 200);
} }
function StatisticsComponent_ng_template_34_Template(rf, ctx) { if (rf & 1) {
    var _r14 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 20);
    ɵɵelementStart(1, "strong");
    ɵɵtext(2);
    ɵɵpipe(3, "translate");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(4, "datatable-pager", 21);
    ɵɵlistener("change", function StatisticsComponent_ng_template_34_Template_datatable_pager_change_4_listener($event) { ɵɵrestoreView(_r14); var ctx_r13 = ɵɵnextContext(); return ctx_r13.datatableComponent.onFooterPage($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    var rowCount_r6 = ctx.rowCount;
    var pageSize_r7 = ctx.pageSize;
    var curPage_r10 = ctx.curPage;
    var ctx_r4 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵtextInterpolate2("", ɵɵpipeBind1(3, 10, "Count of rows"), ": ", ctx_r4.numberToLocalizedString(rowCount_r6), "");
    ɵɵadvance(2);
    ɵɵproperty("pagerLeftArrowIcon", "datatable-icon-left")("pagerRightArrowIcon", "datatable-icon-right")("pagerPreviousIcon", "datatable-icon-prev")("pagerNextIcon", "datatable-icon-skip")("page", curPage_r10)("size", pageSize_r7)("count", rowCount_r6)("hidden", !(rowCount_r6 / pageSize_r7 > 1));
} }
var _c0$4 = function (a1) { return ["btn", a1]; };
var _c1$1 = function (a0, a1) { return { emptyMessage: a0, totalMessage: a1, selectedMessage: false }; };
var FILE_NAME = 'statistics-visits';
var StatisticsComponent = /** @class */ (function () {
    function StatisticsComponent(translateService, localizedDatePipe, cd, excelService) {
        this.translateService = translateService;
        this.localizedDatePipe = localizedDatePipe;
        this.cd = cd;
        this.excelService = excelService;
        this.rows = [];
        this.reorderable = true;
        this.isLoading = false;
        this.summaryFunc = this.sum.bind(this);
        this.defaultFrom = new Date();
        this.defaultTo = new Date(this.defaultFrom.getTime() + 2 * 24 * 60 * 60 * 1000);
        this.groupingType = DateGroupingEnum;
        this.is_debug = false;
        this.csvFieldSeparator = ',';
    }
    StatisticsComponent.prototype.ngOnInit = function () { };
    StatisticsComponent.prototype.ngOnDestroy = function () {
        this.dateRangeComponentChanged.unsubscribe();
    };
    StatisticsComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.cd.detectChanges();
        this.dateRangeComponentChanged = this.dateRangeComponent.dateRangeChanged.subscribe(function () { return _this.refreshClick(); });
        this.refreshClick();
    };
    StatisticsComponent.prototype.getButtonClass = function (buttonType) {
        return ButtonClass.getButtonClass(this.outlineButtons, buttonType);
    };
    StatisticsComponent.prototype.onDateRangeSelection = function (range) {
        console.log("Selected range: " + range.from + " - " + range.to);
    };
    StatisticsComponent.prototype.sum = function (cells) {
        if (cells == null) {
            return 0;
        }
        else if (this.isGroupingEnabled) {
            return cells
                .reduce(function (x, y) { return x + y; })
                .toLocaleString(this.translateService.currentLang);
        }
        else {
            return cells
                .filter(function (cell) { return cell !== ''; })
                .length.toLocaleString(this.translateService.currentLang);
        }
    };
    StatisticsComponent.prototype.fetch = function (callback) {
        var _this = this;
        this.isLoading = true;
        if (this.is_debug) {
            this.isLoading = false;
            var shapedData = this.shapeData(STATISTICS_TEST_DATA);
            callback(shapedData);
        }
        else {
            var dr = this.dateRangeComponent.dateRange;
            var from = dr.from;
            var to = dr.to;
            console.log(from + " - " + to);
            this.statisticsProvider
                .getStatistics({ 'from': from, 'to': to })
                .subscribe(function (x) {
                _this.isLoading = false;
                var shapedData = _this.shapeData(x);
                callback(shapedData);
            }, function (e) {
                console.error(e);
                _this.isLoading = false;
            });
        }
    };
    StatisticsComponent.prototype.shapeData = function (data) {
        var _this = this;
        this.cachedData = data.map(function (x) {
            var barcode = x.barcode ? x.barcode : '?';
            var f = function (v, cond) { return cond ? v : ''; };
            return {
                date: DateTime.fromISOString(x.date),
                gate: f(x.gate, (_this.showGate && x.gate)),
                city: f(x.city, _this.showCity),
                country: f(x.country, _this.showCountry),
                entry: f(barcode, x.count > 0),
                exit: f(barcode, x.count < 0),
            };
        });
        if (this.isGroupingEnabled) {
            return this.groupData(this.cachedData, this.groupingComponent.selectedGroupingType);
        }
        return this.cachedData;
    };
    Object.defineProperty(StatisticsComponent.prototype, "isRefreshClickEnabled", {
        get: function () {
            if (!this.dateRangeComponent) {
                return false;
            }
            var dr = this.dateRangeComponent.dateRange;
            return DateRange.valid(dr) && !this.isLoading;
        },
        enumerable: true,
        configurable: true
    });
    StatisticsComponent.prototype.refreshClick = function () {
        var _this = this;
        this.rows = [];
        this.fetch(function (data) {
            _this.rows = data;
        });
    };
    StatisticsComponent.prototype.numberToLocalizedString = function (x) {
        return x.toLocaleString(this.translateService.currentLang);
    };
    StatisticsComponent.prototype.saveToFileClick = function () {
        var _this = this;
        var fileName = FILE_NAME + "-" + new Date().getTime();
        var options = {
            filename: fileName,
            fieldSeparator: this.csvFieldSeparator,
            quoteStrings: '"',
            decimalseparator: 'locale',
            showLabels: true,
            showTitle: false,
            useBom: true,
            headers: this.buildExportedHeader()
            // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
        };
        var csvExporter = new ExportToCsv(options);
        var data = this.rows.map(function (x) { return _this.buildExportedRow(x); });
        csvExporter.generateCsv(data);
    };
    StatisticsComponent.prototype.buildExportedHeader = function () {
        var _this = this;
        return [
            ['Date', true],
            ['Gate', this.showGate],
            ['City', this.showCity],
            ['Country', this.showCountry],
            ['Entry', true],
            ['Exit', true],
        ]
            .filter(function (x) { return x[1]; })
            .map(function (x) { return _this.translateService.instant(x[0]); });
    };
    StatisticsComponent.prototype.buildExportedRow = function (x) {
        var r = {
            date: this.getFormattedDateDependingOnGrouping(x.date),
        };
        if (this.showGate) {
            r['gate'] = x.gate;
        }
        if (this.showCity) {
            r['city'] = x.city;
        }
        if (this.showCountry) {
            r['country'] = x.country;
        }
        r['entry'] = x.entry;
        r['exit'] = x.exit;
        return r;
    };
    StatisticsComponent.prototype.groupData = function (data, groupingType) {
        switch (groupingType) {
            case DateGroupingEnum.Month:
                return this.groupDataByMonth(data);
            case DateGroupingEnum.Day:
                return this.groupDataByDay(data);
            default:
                break;
        }
        return data;
    };
    StatisticsComponent.prototype.groupDataByDay = function (data) {
        return this.calculateGroupedStatistics(data, 'mediumDate');
    };
    StatisticsComponent.prototype.groupDataByMonth = function (data) {
        return this.calculateGroupedStatistics(data, 'monthYear');
    };
    StatisticsComponent.prototype.calculateGroupedStatistics = function (data, groupKeyFormat) {
        var _this = this;
        if (data == null || data === undefined) {
            console.warn('calculateGroupedStatistics. Failed. input parameter "dataitem" is null or undefined.');
            return data;
        }
        var groupedData = new Map();
        Object.keys(data).forEach(function (key) {
            var item = data[key];
            var date = item.date;
            var dictKey = _this.localizedDatePipe.transform(date, groupKeyFormat);
            var existingValue = groupedData.get(dictKey);
            if (existingValue) {
                groupedData.set(dictKey, {
                    date: date,
                    entry: existingValue.entry + (item.entry === '' ? 0 : 1),
                    exit: existingValue.exit + (item.exit === '' ? 0 : 1),
                });
            }
            else {
                groupedData.set(dictKey, {
                    date: date,
                    entry: item.entry === '' ? 0 : 1,
                    exit: item.exit === '' ? 0 : 1,
                });
            }
        });
        return Array.from(groupedData.values());
    };
    Object.defineProperty(StatisticsComponent.prototype, "dateFormat", {
        get: function () {
            switch (this.groupingComponent.selectedGroupingType) {
                case DateGroupingEnum.Month:
                    return 'monthYear';
                case DateGroupingEnum.Day:
                    return 'mediumDate';
                default:
                    return 'mediumDateTime';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StatisticsComponent.prototype, "isGroupingEnabled", {
        get: function () {
            return this.groupingComponent.selectedGroupingType != null &&
                this.groupingComponent.selectedGroupingType !== undefined &&
                this.groupingComponent.selectedGroupingType !== this.groupingType.None;
        },
        enumerable: true,
        configurable: true
    });
    StatisticsComponent.prototype.onGroupingTypeChanged = function (groupingType) {
        if (this.cachedData) {
            this.rows = this.groupData(this.cachedData, groupingType);
        }
    };
    StatisticsComponent.prototype.getFormattedDateDependingOnGrouping = function (date) {
        var dateFormat;
        switch (this.groupingComponent.selectedGroupingType) {
            case DateGroupingEnum.Month:
                dateFormat = 'monthYear';
                break;
            case DateGroupingEnum.Day:
                dateFormat = 'mediumDate';
                break;
            default:
                dateFormat = 'mediumDateTime';
        }
        return this.localizedDatePipe.transform(date, dateFormat);
    };
    StatisticsComponent.prototype.saveToXlsxFileClick = function () {
        var _this = this;
        var json = this.rows.map(function (x) { return _this.buildExportedRow(x); });
        this.excelService.exportAsExcelFile(json, FILE_NAME);
    };
    /** @nocollapse */ StatisticsComponent.ɵfac = function StatisticsComponent_Factory(t) { return new (t || StatisticsComponent)(ɵɵdirectiveInject(TranslateService), ɵɵdirectiveInject(LocalizedDatePipe), ɵɵdirectiveInject(ChangeDetectorRef), ɵɵdirectiveInject(ExcelService)); };
    /** @nocollapse */ StatisticsComponent.ɵcmp = ɵɵdefineComponent({ type: StatisticsComponent, selectors: [["lib-statistics"]], viewQuery: function StatisticsComponent_Query(rf, ctx) { if (rf & 1) {
            ɵɵstaticViewQuery(CompositeDateRangeComponent, true);
            ɵɵstaticViewQuery(DatatableComponent, true);
            ɵɵstaticViewQuery(GroupingComponent, true);
        } if (rf & 2) {
            var _t;
            ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.dateRangeComponent = _t.first);
            ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.datatableComponent = _t.first);
            ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.groupingComponent = _t.first);
        } }, inputs: { statisticsProvider: "statisticsProvider", outlineButtons: "outlineButtons", showGate: "showGate", showCity: "showCity", showCountry: "showCountry", is_debug: "is_debug", csvFieldSeparator: "csvFieldSeparator" }, decls: 35, vars: 63, consts: [[1, "mb-3"], [3, "outlineButtons"], [1, "row"], [1, "col"], [3, "ngClass", "disabled", "click"], [1, "float-right"], [1, "mr-2", "mb-0", "align-middle"], [3, "groupingType", "outlineButtons", "groupingTypeChanged"], [1, "bootstrap", 3, "rows", "loadingIndicator", "columnMode", "rowHeight", "headerHeight", "summaryRow", "summaryPosition", "footerHeight", "limit", "reorderable", "messages"], ["prop", "date", 3, "name", "width"], ["ngx-datatable-cell-template", ""], ["prop", "gate", 3, "name", "width", 4, "ngIf"], ["prop", "city", 3, "name", "width", 4, "ngIf"], ["prop", "country", 3, "name", "width", 4, "ngIf"], ["prop", "entry", 3, "name", "width", "summaryFunc"], ["prop", "exit", 3, "name", "width", "summaryFunc"], ["ngx-datatable-footer-template", ""], ["prop", "gate", 3, "name", "width"], ["prop", "city", 3, "name", "width"], ["prop", "country", 3, "name", "width"], [1, "page-count"], [3, "pagerLeftArrowIcon", "pagerRightArrowIcon", "pagerPreviousIcon", "pagerNextIcon", "page", "size", "count", "hidden", "change"]], template: function StatisticsComponent_Template(rf, ctx) { if (rf & 1) {
            ɵɵelementStart(0, "div", 0);
            ɵɵelement(1, "lib-composite-date-range", 1);
            ɵɵelementEnd();
            ɵɵelementStart(2, "div", 0);
            ɵɵelementStart(3, "div", 2);
            ɵɵelementStart(4, "div", 3);
            ɵɵelementStart(5, "button", 4);
            ɵɵlistener("click", function StatisticsComponent_Template_button_click_5_listener() { return ctx.refreshClick(); });
            ɵɵtext(6);
            ɵɵpipe(7, "translate");
            ɵɵelementEnd();
            ɵɵelementStart(8, "button", 4);
            ɵɵlistener("click", function StatisticsComponent_Template_button_click_8_listener() { return ctx.saveToFileClick(); });
            ɵɵtext(9);
            ɵɵpipe(10, "translate");
            ɵɵelementEnd();
            ɵɵelementStart(11, "button", 4);
            ɵɵlistener("click", function StatisticsComponent_Template_button_click_11_listener() { return ctx.saveToXlsxFileClick(); });
            ɵɵtext(12);
            ɵɵpipe(13, "translate");
            ɵɵelementEnd();
            ɵɵelementEnd();
            ɵɵelementStart(14, "div", 3);
            ɵɵelementStart(15, "div", 5);
            ɵɵelementStart(16, "label", 6);
            ɵɵtext(17);
            ɵɵpipe(18, "translate");
            ɵɵelementEnd();
            ɵɵelementStart(19, "lib-grouping", 7);
            ɵɵlistener("groupingTypeChanged", function StatisticsComponent_Template_lib_grouping_groupingTypeChanged_19_listener($event) { return ctx.onGroupingTypeChanged($event); });
            ɵɵelementEnd();
            ɵɵelementEnd();
            ɵɵelementEnd();
            ɵɵelementEnd();
            ɵɵelementEnd();
            ɵɵelementStart(20, "ngx-datatable", 8);
            ɵɵpipe(21, "translate");
            ɵɵpipe(22, "translate");
            ɵɵelementStart(23, "ngx-datatable-column", 9);
            ɵɵpipe(24, "translate");
            ɵɵtemplate(25, StatisticsComponent_ng_template_25_Template, 2, 4, "ng-template", 10);
            ɵɵelementEnd();
            ɵɵtemplate(26, StatisticsComponent_ngx_datatable_column_26_Template, 2, 4, "ngx-datatable-column", 11);
            ɵɵtemplate(27, StatisticsComponent_ngx_datatable_column_27_Template, 2, 4, "ngx-datatable-column", 12);
            ɵɵtemplate(28, StatisticsComponent_ngx_datatable_column_28_Template, 2, 4, "ngx-datatable-column", 13);
            ɵɵelement(29, "ngx-datatable-column", 14);
            ɵɵpipe(30, "translate");
            ɵɵelement(31, "ngx-datatable-column", 15);
            ɵɵpipe(32, "translate");
            ɵɵelementStart(33, "ngx-datatable-footer");
            ɵɵtemplate(34, StatisticsComponent_ng_template_34_Template, 5, 12, "ng-template", 16);
            ɵɵelementEnd();
            ɵɵelementEnd();
        } if (rf & 2) {
            ɵɵadvance(1);
            ɵɵproperty("outlineButtons", ctx.outlineButtons);
            ɵɵadvance(4);
            ɵɵproperty("ngClass", ɵɵpureFunction1(54, _c0$4, ctx.getButtonClass("success")))("disabled", !ctx.isRefreshClickEnabled);
            ɵɵadvance(1);
            ɵɵtextInterpolate1(" ", ɵɵpipeBind1(7, 36, "Refresh"), " ");
            ɵɵadvance(2);
            ɵɵproperty("ngClass", ɵɵpureFunction1(56, _c0$4, ctx.getButtonClass("primary")))("disabled", ctx.rows == null || !ctx.rows.length || ctx.isLoading);
            ɵɵadvance(1);
            ɵɵtextInterpolate1(" ", ɵɵpipeBind1(10, 38, "Save as"), " .csv ");
            ɵɵadvance(2);
            ɵɵproperty("ngClass", ɵɵpureFunction1(58, _c0$4, ctx.getButtonClass("primary")))("disabled", ctx.rows == null || !ctx.rows.length || ctx.isLoading);
            ɵɵadvance(1);
            ɵɵtextInterpolate1(" ", ɵɵpipeBind1(13, 40, "Save as"), " .xlsx ");
            ɵɵadvance(5);
            ɵɵtextInterpolate1("", ɵɵpipeBind1(18, 42, "Grouping"), ": ");
            ɵɵadvance(2);
            ɵɵproperty("groupingType", ctx.groupingType)("outlineButtons", ctx.outlineButtons);
            ɵɵadvance(1);
            ɵɵproperty("rows", ctx.rows)("loadingIndicator", ctx.isLoading)("columnMode", "force")("rowHeight", 40)("headerHeight", 40)("summaryRow", true)("summaryPosition", "bottom")("footerHeight", 40)("limit", 20)("rowHeight", "auto")("reorderable", ctx.reorderable)("messages", ɵɵpureFunction2(60, _c1$1, ɵɵpipeBind1(21, 44, "No data to display"), ɵɵpipeBind1(22, 46, "Total")));
            ɵɵadvance(3);
            ɵɵproperty("name", ɵɵpipeBind1(24, 48, "Date"))("width", 220);
            ɵɵadvance(3);
            ɵɵproperty("ngIf", ctx.showGate);
            ɵɵadvance(1);
            ɵɵproperty("ngIf", ctx.showCity);
            ɵɵadvance(1);
            ɵɵproperty("ngIf", ctx.showCountry);
            ɵɵadvance(1);
            ɵɵproperty("name", ɵɵpipeBind1(30, 50, "Entry"))("width", 300)("summaryFunc", ctx.summaryFunc);
            ɵɵadvance(2);
            ɵɵproperty("name", ɵɵpipeBind1(32, 52, "Exit"))("width", 300)("summaryFunc", ctx.summaryFunc);
        } }, directives: [CompositeDateRangeComponent, NgClass, GroupingComponent, DatatableComponent, DataTableColumnDirective, DataTableColumnCellDirective, NgIf, DatatableFooterDirective, DataTableFooterTemplateDirective, DataTablePagerComponent], pipes: [TranslatePipe, LocalizedDatePipe, UITextTranslatePipe], styles: [".datatable-header-cell-label{font-weight:700}.datatable-footer-inner{background-color:#f8f9fa;color:#000}.ngx-datatable.bootstrap .datatable-footer .datatable-pager ul li:not(.disabled).active a,.ngx-datatable.bootstrap .datatable-footer .datatable-pager ul li:not(.disabled):hover a{background-color:#dbdbdb;font-weight:700}.pager li a{color:#007bff!important}.ngx-datatable .datatable-body .progress-linear{display:block;width:100%;height:8px;padding:0;margin:0;position:absolute}.ngx-datatable .datatable-body .progress-linear .container{display:block;position:relative;overflow:hidden;width:100%;height:8px;transform:translate(0,0) scale(1,1);background-color:#468aff}.ngx-datatable .datatable-body .progress-linear .container .bar{transition:transform .15s linear;-webkit-animation:.5s cubic-bezier(.39,.575,.565,1) infinite query;animation:.5s cubic-bezier(.39,.575,.565,1) infinite query;background-color:#2351cf;position:absolute;left:0;top:0;bottom:0;width:100%;height:8px}.ngx-datatable .datatable-body-cell,.ngx-datatable .datatable-footer{overflow-x:hidden!important;overflow-y:hidden!important}@-webkit-keyframes query{0%{opacity:1;transform:translateX(35%) scale(.3,1)}100%{opacity:0;transform:translateX(-50%) scale(0,1)}}@keyframes query{0%{opacity:1;transform:translateX(35%) scale(.3,1)}100%{opacity:0;transform:translateX(-50%) scale(0,1)}}"], encapsulation: 2 });
    return StatisticsComponent;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(StatisticsComponent, [{
        type: Component,
        args: [{
                selector: 'lib-statistics',
                templateUrl: 'statistics.component.html',
                styleUrls: ['statistics.component.scss'],
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: TranslateService }, { type: LocalizedDatePipe }, { type: ChangeDetectorRef }, { type: ExcelService }]; }, { dateRangeComponent: [{
            type: ViewChild,
            args: [CompositeDateRangeComponent, { static: true }]
        }], datatableComponent: [{
            type: ViewChild,
            args: [DatatableComponent, { static: true }]
        }], groupingComponent: [{
            type: ViewChild,
            args: [GroupingComponent, { static: true }]
        }], statisticsProvider: [{
            type: Input
        }], outlineButtons: [{
            type: Input
        }], showGate: [{
            type: Input
        }], showCity: [{
            type: Input
        }], showCountry: [{
            type: Input
        }], is_debug: [{
            type: Input
        }], csvFieldSeparator: [{
            type: Input
        }] }); })();

var LOGIN_COMMAND = '/login';
var TOKEN_UDPATE_BEFORE_EXPIRATION_SECONDS = 30;
var AuthenticationService = /** @class */ (function () {
    function AuthenticationService(router, baseBackendApiService, translateService, jwtHelperService, cookieService, backendDateService, projectConfiguration) {
        var _this = this;
        this.router = router;
        this.baseBackendApiService = baseBackendApiService;
        this.translateService = translateService;
        this.jwtHelperService = jwtHelperService;
        this.cookieService = cookieService;
        this.backendDateService = backendDateService;
        this.projectConfiguration = projectConfiguration;
        this._isAuthenticated = false;
        this._redirectUrl = null;
        this.authenticationChanged = new Subject$1();
        this.loginInProgressChanged = new Subject$1();
        this._isLoginInProgress = false;
        this.isTokenUpdateInProgress = false;
        this.updateState('constructor');
        this.backendDateService.dateChanged.subscribe(function (x) { return _this.updateState('dateChanged'); });
        console.log(projectConfiguration);
    }
    AuthenticationService.prototype.login = function (username, password) {
        var _this = this;
        this.loginFailedReason = null;
        this.loginInProgress = true;
        this.baseBackendApiService.login(username, password).subscribe(function (x) {
            _this.loginInProgress = false;
            setTimeout(function () { return _this.updateToken(x); }, 1);
        }, function (e) {
            var statusText = _this.translateService.instant(e.statusText);
            _this.loginFailedReason = _this.translateService.instant('Login failed') + " (" + statusText + ")";
            _this.loginInProgress = false;
            console.error(e);
        });
    };
    AuthenticationService.prototype.onLoginPageInit = function () {
        if (this.redirectUrl == null) {
            this.redirectUrl = '/';
        }
    };
    AuthenticationService.prototype.logout = function (removeToken) {
        if (removeToken === void 0) { removeToken = true; }
        if (removeToken) {
            this.cookieService.remove(this.tokenCookieName);
        }
        this.username = null;
        var url = this.router.url;
        if (url !== LOGIN_COMMAND) {
            this.redirectUrl = url;
            this.router.navigate([LOGIN_COMMAND]);
        }
        this.updateState('logout');
    };
    Object.defineProperty(AuthenticationService.prototype, "isAuthenticated", {
        get: function () {
            return this._isAuthenticated;
        },
        set: function (value) {
            if (value === this._isAuthenticated) {
                return;
            }
            this._isAuthenticated = value;
            this.authenticationChanged.next(value);
            if (value) {
                this.tryToRedirect();
            }
            else {
                this.logout(false);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthenticationService.prototype, "redirectUrl", {
        get: function () {
            return this._redirectUrl;
        },
        set: function (url) {
            this._redirectUrl = url;
        },
        enumerable: true,
        configurable: true
    });
    AuthenticationService.prototype.updateState = function (callContext) {
        var token = this.cookieService.get(this.tokenCookieName);
        var isAuthenticated = !this.isTokenExpired(token, 0);
        this.isAuthenticated = isAuthenticated;
        if (isAuthenticated) {
            this.prolongateToken(token);
            var payload = this.jwtHelperService.decodeToken(token);
            this.username = payload ? payload.name : null;
            this.ensureLoggedOn();
        }
        else {
            this.username = null;
        }
    };
    Object.defineProperty(AuthenticationService.prototype, "tokenCookieName", {
        get: function () {
            return this.projectConfiguration.tokenCookieName;
        },
        enumerable: true,
        configurable: true
    });
    AuthenticationService.prototype.prolongateToken = function (token) {
        var _this = this;
        if (this.isTokenUpdateInProgress ||
            !this.isAuthenticated ||
            !this.isTokenExpired(token, TOKEN_UDPATE_BEFORE_EXPIRATION_SECONDS)) {
            return;
        }
        this.isTokenUpdateInProgress = true;
        this.baseBackendApiService.prolongateToken(token).subscribe(function (x) {
            _this.updateToken(x);
            _this.isTokenUpdateInProgress = false;
        }, function (e) {
            console.error(e);
            _this.isTokenUpdateInProgress = false;
        });
    };
    AuthenticationService.prototype.isTokenExpired = function (token, shiftInSeconds) {
        if (shiftInSeconds === void 0) { shiftInSeconds = 0; }
        if (token == null) {
            return true;
        }
        var date = this.backendDateService.date;
        if (date == null) {
            return true;
        }
        var tokenDate = this.jwtHelperService.getTokenExpirationDate(token);
        var tokenDateStamp = tokenDate.getTime();
        var timeStamp = date.getTime();
        var diff = tokenDateStamp - timeStamp - shiftInSeconds * 1000;
        return diff < 0;
    };
    AuthenticationService.prototype.updateToken = function (token) {
        if (token != null) {
            this.loginInProgress = false;
            this.cookieService.put(this.tokenCookieName, token);
            this.updateState('updateToken');
        }
    };
    AuthenticationService.prototype.tryToRedirect = function () {
        var url = this.redirectUrl ? this.redirectUrl : '/';
        this.router.navigate([url]);
    };
    Object.defineProperty(AuthenticationService.prototype, "loginInProgress", {
        get: function () {
            return this._isLoginInProgress;
        },
        set: function (value) {
            if (value === this.loginInProgress) {
                return;
            }
            this._isLoginInProgress = value;
            this.loginInProgressChanged.next(value);
        },
        enumerable: true,
        configurable: true
    });
    AuthenticationService.prototype.ensureLoggedOn = function () {
        var _this = this;
        if (!this.isAuthenticated) {
            return;
        }
        var username = this.username;
        if (!this.username) {
            return;
        }
        this.baseBackendApiService.validateLoggedOnUserByName(username).subscribe(function (x) { }, function (e) {
            _this.logout(true);
            console.log("logout. user " + _this.username + " not valid");
        });
    };
    /** @nocollapse */ AuthenticationService.ɵfac = function AuthenticationService_Factory(t) { return new (t || AuthenticationService)(ɵɵinject(Router), ɵɵinject(BaseBackendApiService), ɵɵinject(TranslateService), ɵɵinject(JwtHelperService), ɵɵinject(CookieService), ɵɵinject(BackendDateService), ɵɵinject(ProjectConfigurationService)); };
    /** @nocollapse */ AuthenticationService.ɵprov = ɵɵdefineInjectable({ token: AuthenticationService, factory: AuthenticationService.ɵfac });
    return AuthenticationService;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(AuthenticationService, [{
        type: Injectable
    }], function () { return [{ type: Router }, { type: BaseBackendApiService }, { type: TranslateService }, { type: JwtHelperService }, { type: CookieService }, { type: BackendDateService }, { type: ProjectConfigurationService }]; }, null); })();

var ConnectionState;
(function (ConnectionState) {
    ConnectionState[ConnectionState["None"] = 0] = "None";
    ConnectionState[ConnectionState["NoBackendAvailable"] = 1] = "NoBackendAvailable";
    ConnectionState[ConnectionState["NoWebcocketConnection"] = 2] = "NoWebcocketConnection";
    ConnectionState[ConnectionState["NoDatabaseConnection"] = 3] = "NoDatabaseConnection";
    ConnectionState[ConnectionState["NotAuthenticated"] = 4] = "NotAuthenticated";
    ConnectionState[ConnectionState["NoLoadedData"] = 5] = "NoLoadedData";
    ConnectionState[ConnectionState["Ready"] = 6] = "Ready";
})(ConnectionState || (ConnectionState = {}));
var AppStateService = /** @class */ (function () {
    function AppStateService(authenticationService, backendDateService, backendEventsService, projectConfigurationService) {
        var _this = this;
        this.authenticationService = authenticationService;
        this.backendDateService = backendDateService;
        this.backendEventsService = backendEventsService;
        this.projectConfigurationService = projectConfigurationService;
        this.connectionState = ConnectionState.None;
        this.connectionStateChanged = new Subject$1();
        this.backendEvent = new Subject$1();
        this.dataLoadedDate = null;
        this._isDataLoaded = false;
        this.dataLoadedTimer = null;
        this.backendEventsService = backendEventsService;
        this.backendEventsService = backendEventsService;
        backendEventsService.websocketConnectionChanged.subscribe(function () {
            _this.updateConnectionState();
        });
        backendEventsService.eventReceived.subscribe(function (x) { return _this.onEvent(x); });
        backendEventsService.connectionToDatabaseChanged.subscribe(function () {
            return _this.updateConnectionState();
        });
        backendDateService.backendAvailabiltyChanged.subscribe(function (x) { return _this.updateConnectionState(); });
        authenticationService.authenticationChanged.subscribe(function (x) {
            return _this.updateConnectionState();
        });
        this.updateConnectionState();
    }
    Object.defineProperty(AppStateService.prototype, "isDataLoaded", {
        get: function () {
            return this._isDataLoaded;
        },
        set: function (x) {
            this._isDataLoaded = x;
        },
        enumerable: true,
        configurable: true
    });
    AppStateService.prototype.onDataLoaded = function () {
        this.isDataLoaded = true;
        console.log('Data loaded');
        this.updateConnectionState();
    };
    AppStateService.prototype.updateConnectionState = function () {
        var _this = this;
        var isBackendAvailable = this.backendDateService.isBackendAvailable;
        var isWebsocketConnected = this.backendEventsService.isWebsocketConnected;
        var isConnectedToDatabase = this.backendEventsService.isConnectedToDatabase;
        var isAuthenticated = this.authenticationService.isAuthenticated;
        var state = ConnectionState.None;
        var calculateStateForSimpleSocket = function () {
            var s = ConnectionState.None;
            if (!isBackendAvailable) {
                s = ConnectionState.NoBackendAvailable;
                _this.isDataLoaded = false;
            }
            else if (!isWebsocketConnected) {
                s = ConnectionState.NoWebcocketConnection;
            }
            else if (!isConnectedToDatabase) {
                s = ConnectionState.NoDatabaseConnection;
            }
            else if (!isAuthenticated) {
                s = ConnectionState.NotAuthenticated;
            }
            else if (!_this.isDataLoaded) {
                s = ConnectionState.NoLoadedData;
            }
            else if (_this.isDataLoaded) {
                s = ConnectionState.Ready;
            }
            return s;
        };
        var calculateStateForSocket = function () {
            var s = ConnectionState.None;
            if (!isBackendAvailable) {
                s = ConnectionState.NoBackendAvailable;
                _this.isDataLoaded = false;
            }
            else if (!isAuthenticated) {
                s = ConnectionState.NotAuthenticated;
            }
            else if (!isWebsocketConnected) {
                s = ConnectionState.NoWebcocketConnection;
            }
            else if (!isConnectedToDatabase) {
                s = ConnectionState.NoDatabaseConnection;
            }
            else if (!_this.isDataLoaded) {
                s = ConnectionState.NoLoadedData;
            }
            else if (_this.isDataLoaded) {
                s = ConnectionState.Ready;
            }
            return s;
        };
        if (this.projectConfigurationService.allowSimpleWebsocket) {
            state = calculateStateForSimpleSocket();
        }
        else {
            state = calculateStateForSocket();
        }
        var isChanged = state !== this.connectionState;
        this.connectionState = state;
        if (!isChanged) {
            return;
        }
        console.log(ConnectionState[state]);
        if (state < ConnectionState.NoLoadedData) {
            this.dataLoadedDate = null;
            if (this.dataLoadedTimer) {
                clearTimeout(this.dataLoadedTimer);
            }
        }
        this.connectionStateChanged.next(state);
        this.authenticationService.updateState("AppState. state changed to " + ConnectionState[state]);
        if (state < ConnectionState.NoWebcocketConnection) {
            this.backendEventsService.stopListening();
        }
        if (state === ConnectionState.NoWebcocketConnection) {
            this.backendEventsService.startListening();
        }
        if (state === ConnectionState.NoLoadedData) { }
    };
    AppStateService.prototype.onEvent = function (event) {
        this.backendEvent.next(event);
    };
    Object.defineProperty(AppStateService.prototype, "isReady", {
        get: function () {
            return this.connectionState === ConnectionState.Ready;
        },
        enumerable: true,
        configurable: true
    });
    /** @nocollapse */ AppStateService.ɵfac = function AppStateService_Factory(t) { return new (t || AppStateService)(ɵɵinject(AuthenticationService), ɵɵinject(BackendDateService), ɵɵinject(BackendEventsService), ɵɵinject(ProjectConfigurationService)); };
    /** @nocollapse */ AppStateService.ɵprov = ɵɵdefineInjectable({ token: AppStateService, factory: AppStateService.ɵfac });
    return AppStateService;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(AppStateService, [{
        type: Injectable
    }], function () { return [{ type: AuthenticationService }, { type: BackendDateService }, { type: BackendEventsService }, { type: ProjectConfigurationService }]; }, null); })();

function NoConnectionComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 1);
    ɵɵtext(1);
    ɵɵpipe(2, "translate");
    ɵɵelement(3, "i", 2);
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(2, 1, ctx_r0.reason), "\u00A0...\u00A0");
} }
var _c0$5 = ["*"];
var NoConnectionComponent = /** @class */ (function () {
    function NoConnectionComponent(appStateService) {
        this.appStateService = appStateService;
        this.cssClassConnected = '';
        this.cssClassDisconnected = '';
        this.overlayClass = '';
    }
    Object.defineProperty(NoConnectionComponent.prototype, "isConnected", {
        get: function () {
            var _this = this;
            return ([ConnectionState.NotAuthenticated, ConnectionState.Ready].find(function (x) { return x === _this.appStateService.connectionState; }) != null);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NoConnectionComponent.prototype, "reason", {
        get: function () {
            switch (this.appStateService.connectionState) {
                case ConnectionState.NoBackendAvailable:
                    return 'Waiting for a response from server';
                case ConnectionState.NoWebcocketConnection:
                    return 'Opening a websocket connection';
                case ConnectionState.NoDatabaseConnection:
                    return 'Connecting to database';
                default:
                    return 'Loading data';
            }
        },
        enumerable: true,
        configurable: true
    });
    /** @nocollapse */ NoConnectionComponent.ɵfac = function NoConnectionComponent_Factory(t) { return new (t || NoConnectionComponent)(ɵɵdirectiveInject(AppStateService)); };
    /** @nocollapse */ NoConnectionComponent.ɵcmp = ɵɵdefineComponent({ type: NoConnectionComponent, selectors: [["lib-no-connection"]], inputs: { cssClassConnected: "cssClassConnected", cssClassDisconnected: "cssClassDisconnected", overlayClass: "overlayClass" }, ngContentSelectors: _c0$5, decls: 3, vars: 2, consts: [["class", "alert alert-danger", 4, "ngIf"], [1, "alert", "alert-danger"], [1, "fa", "fa-spinner", "fa-spin"]], template: function NoConnectionComponent_Template(rf, ctx) { if (rf & 1) {
            ɵɵprojectionDef();
            ɵɵelementStart(0, "div");
            ɵɵtemplate(1, NoConnectionComponent_div_1_Template, 4, 3, "div", 0);
            ɵɵprojection(2);
            ɵɵelementEnd();
        } if (rf & 2) {
            ɵɵattribute("class", ctx.overlayClass + " " + (ctx.isConnected ? ctx.cssClassConnected : "overlay " + ctx.cssClassDisconnected));
            ɵɵadvance(1);
            ɵɵproperty("ngIf", !ctx.isConnected);
        } }, directives: [NgIf], pipes: [TranslatePipe], styles: [".overlay[_ngcontent-%COMP%]{position:relative;pointer-events:none;height:100%!important}.overlay[_ngcontent-%COMP%]:after{content:\" \";z-index:10;display:block;position:absolute;height:100%!important;width:100%!important;top:0;left:0;right:0;background:rgba(0,0,0,.5)}.alert[_ngcontent-%COMP%]{display:block!important;position:absolute!important;top:75px;left:20px;z-index:2}div.notification[_ngcontent-%COMP%]{display:block;top:0;margin:10px;padding:8px;position:absolute;z-index:500;text-align:center;border-width:1px;border-style:solid;color:#fff}div.notification-warning[_ngcontent-%COMP%]{background-color:#d9534f;border-color:#d43f3a}div.notification-ok[_ngcontent-%COMP%]{background-color:#5cb85c;border-color:#4cae4c}div.notification[_ngcontent-%COMP%] > .icon-spinner[_ngcontent-%COMP%]{font-size:18px;vertical-align:middle}"] });
    return NoConnectionComponent;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(NoConnectionComponent, [{
        type: Component,
        args: [{
                selector: 'lib-no-connection',
                templateUrl: 'no-connection.component.html',
                styleUrls: ['no-connection.component.scss']
            }]
    }], function () { return [{ type: AppStateService }]; }, { cssClassConnected: [{
            type: Input
        }], cssClassDisconnected: [{
            type: Input
        }], overlayClass: [{
            type: Input
        }] }); })();

var WebUtility = /** @class */ (function () {
    function WebUtility() {
    }
    WebUtility.unescapeUrl = function (x) {
        if (x == null) {
            return x;
        }
        var count = 5;
        while (count-- > 0) {
            var c = decodeURIComponent((x + '').replace(/\+/g, '%20'));
            if (c === x) {
                break;
            }
            x = c;
        }
        return x;
    };
    return WebUtility;
}());

var AuthGuardService = /** @class */ (function () {
    function AuthGuardService(router, authenitcationService, location) {
        var _this = this;
        this.router = router;
        this.authenitcationService = authenitcationService;
        location.onPopState(function () {
            var pathname = window.location.pathname;
            if (_this.authenitcationService.isAuthenticated && pathname && pathname.endsWith(LOGIN_COMMAND)) {
                window.location.reload();
            }
        });
    }
    AuthGuardService.prototype.canActivate = function (route, state) {
        if (!this.authenitcationService.isAuthenticated) {
            this.authenitcationService.redirectUrl = WebUtility.unescapeUrl(state.url);
            this.router.navigate([LOGIN_COMMAND]);
            return false;
        }
        return true;
    };
    /** @nocollapse */ AuthGuardService.ɵfac = function AuthGuardService_Factory(t) { return new (t || AuthGuardService)(ɵɵinject(Router), ɵɵinject(AuthenticationService), ɵɵinject(PlatformLocation)); };
    /** @nocollapse */ AuthGuardService.ɵprov = ɵɵdefineInjectable({ token: AuthGuardService, factory: AuthGuardService.ɵfac });
    return AuthGuardService;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(AuthGuardService, [{
        type: Injectable
    }], function () { return [{ type: Router }, { type: AuthenticationService }, { type: PlatformLocation }]; }, null); })();

function ErrorComponent_div_0_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵtext(1);
    ɵɵpipe(2, "translate");
    ɵɵpipe(3, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate2("", ɵɵpipeBind1(2, 2, ctx_r1.error.statusText), ". ", ɵɵpipeBind1(3, 4, ctx_r1.error.error), "");
} }
function ErrorComponent_div_0_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵtext(1);
    ɵɵpipe(2, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r2 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate(ɵɵpipeBind1(2, 1, ctx_r2.error));
} }
function ErrorComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 1);
    ɵɵtemplate(1, ErrorComponent_div_0_span_1_Template, 4, 6, "span", 2);
    ɵɵtemplate(2, ErrorComponent_div_0_span_2_Template, 3, 3, "span", 2);
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r0.isString);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.isString);
} }
var ErrorComponent = /** @class */ (function () {
    function ErrorComponent() {
    }
    Object.defineProperty(ErrorComponent.prototype, "isString", {
        get: function () {
            return typeof this.error === 'string';
        },
        enumerable: true,
        configurable: true
    });
    /** @nocollapse */ ErrorComponent.ɵfac = function ErrorComponent_Factory(t) { return new (t || ErrorComponent)(); };
    /** @nocollapse */ ErrorComponent.ɵcmp = ɵɵdefineComponent({ type: ErrorComponent, selectors: [["lib-error"]], inputs: { error: "error" }, decls: 1, vars: 1, consts: [["class", "error", 4, "ngIf"], [1, "error"], [4, "ngIf"]], template: function ErrorComponent_Template(rf, ctx) { if (rf & 1) {
            ɵɵtemplate(0, ErrorComponent_div_0_Template, 3, 2, "div", 0);
        } if (rf & 2) {
            ɵɵproperty("ngIf", ctx.error != null);
        } }, directives: [NgIf], pipes: [TranslatePipe], styles: [".error[_ngcontent-%COMP%]{color:red;margin-bottom:0}"] });
    return ErrorComponent;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(ErrorComponent, [{
        type: Component,
        args: [{
                selector: 'lib-error',
                templateUrl: 'error.component.html',
                styleUrls: ['error.component.scss']
            }]
    }], null, { error: [{
            type: Input
        }] }); })();

var Locale = /** @class */ (function () {
    function Locale(id, displayName) {
        this.id = id;
        this.displayName = displayName;
    }
    Locale.prototype.toString = function () {
        return "" + this.id;
    };
    return Locale;
}());

var LOCALES = [
    new Locale('en', 'English'),
    new Locale('de', 'Deutsch')
];
var STORAGE_KEY = 'localeId';
function getLanguageFactory(languageService) {
    return languageService.selectedLocale.id;
}
var LanguageService = /** @class */ (function () {
    function LanguageService(storageService, translateService) {
        this.storageService = storageService;
        this.translateService = translateService;
        var languageId = this.storageService.get(STORAGE_KEY);
        this.setSelectedLanguageById(languageId);
    }
    Object.defineProperty(LanguageService.prototype, "locales", {
        get: function () {
            return LOCALES;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LanguageService.prototype, "defaultLocale", {
        get: function () {
            var locale = LOCALES[1]; // TODO: Configure the default language somewhere
            console.log(locale);
            return locale;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LanguageService.prototype, "selectedLocale", {
        get: function () {
            return this._selectedLocale;
        },
        set: function (value) {
            var languages = this.locales.filter(function (x) { return x === value; });
            if (languages.length === 0) {
                console.error("LanguageService. selectedLocale. locale not found: '" + value + "'");
                return;
            }
            if (this._selectedLocale === value) {
                return;
            }
            this._selectedLocale = value;
            this.storageService.set(STORAGE_KEY, value.id);
            this.translateService.use(value.id);
        },
        enumerable: true,
        configurable: true
    });
    LanguageService.prototype.setSelectedLanguageById = function (value) {
        value = value ? value : this.defaultLocale.id;
        var locale = this.getLocaleByLanguageId(value);
        if (locale == null) {
            locale = this.getLocaleByLanguageId(this.defaultLocale.id);
        }
        this.selectedLocale = locale;
    };
    LanguageService.prototype.getLocaleByLanguageId = function (value) {
        var locales = this.locales.filter(function (x) { return x.id === value; });
        if (locales.length > 0) {
            return locales[0];
        }
        console.error("LanguageService. getLocaleByLanguageId. locale not found by: '" + value + "'");
        return null;
    };
    LanguageService.prototype.isDefaultLocale = function (value) {
        return value === this.defaultLocale;
    };
    /** @nocollapse */ LanguageService.ɵfac = function LanguageService_Factory(t) { return new (t || LanguageService)(ɵɵinject(StorageService), ɵɵinject(TranslateService)); };
    /** @nocollapse */ LanguageService.ɵprov = ɵɵdefineInjectable({ token: LanguageService, factory: LanguageService.ɵfac });
    return LanguageService;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(LanguageService, [{
        type: Injectable
    }], function () { return [{ type: StorageService }, { type: TranslateService }]; }, null); })();

var UITextPipe = /** @class */ (function () {
    function UITextPipe(uiTextService) {
        this.uiTextService = uiTextService;
    }
    UITextPipe.prototype.transform = function (value, args) {
        return this.uiTextService.getUIText(value);
    };
    /** @nocollapse */ UITextPipe.ɵfac = function UITextPipe_Factory(t) { return new (t || UITextPipe)(ɵɵdirectiveInject(UITextService)); };
    /** @nocollapse */ UITextPipe.ɵpipe = ɵɵdefinePipe({ name: "uitext", type: UITextPipe, pure: false });
    return UITextPipe;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(UITextPipe, [{
        type: Pipe,
        args: [{
                name: 'uitext',
                pure: false
            }]
    }], function () { return [{ type: UITextService }]; }, null); })();

var GateBlinkingMode;
(function (GateBlinkingMode) {
    GateBlinkingMode["FireAlarm"] = "FireAlarm";
    GateBlinkingMode["Emergency"] = "Emergency";
    GateBlinkingMode["Weac"] = "Weac";
})(GateBlinkingMode || (GateBlinkingMode = {}));

var Dispatcher = /** @class */ (function () {
    function Dispatcher() {
        this.name = null;
        this.isPrimary = null;
        this.isConnected = null;
    }
    return Dispatcher;
}());

var GateStatus = /** @class */ (function () {
    function GateStatus(init) {
        this.alarms = [];
        this.devices = [];
        this.dispatcher = new Dispatcher();
        Object.assign(this, init);
    }
    return GateStatus;
}());

var Icon = /** @class */ (function () {
    function Icon() {
    }
    Icon.getBooleanCssClass = function (x, colorTrue, colorFalse, hideFalse) {
        if (colorTrue === void 0) { colorTrue = 'color-green'; }
        if (colorFalse === void 0) { colorFalse = 'color-red'; }
        if (hideFalse === void 0) { hideFalse = false; }
        colorFalse = hideFalse ? '' : "fa fa-lg fa-thumbs-down " + colorFalse;
        return x
            ? "fa fa-lg fa-thumbs-up  " + colorTrue
            : colorFalse;
    };
    return Icon;
}());

function GateStatusComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 10);
    ɵɵtext(1);
    ɵɵpipe(2, "localizedDate");
    ɵɵpipe(3, "localizedDate");
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r2 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate2(" ", ɵɵpipeBind2(2, 2, ctx_r2.status.pingTime, "mediumDate"), " ", ɵɵpipeBind2(3, 5, ctx_r2.status.pingTime, "mediumTime"), " ");
} }
function GateStatusComponent_div_0_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 11);
    ɵɵelement(2, "i");
    ɵɵelementStart(3, "span");
    ɵɵtext(4);
    ɵɵpipe(5, "translate");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    var x_r7 = ctx.$implicit;
    ɵɵadvance(2);
    ɵɵclassMap(x_r7[1]);
    ɵɵadvance(1);
    ɵɵclassMap(x_r7[2]);
    ɵɵadvance(1);
    ɵɵtextInterpolate(ɵɵpipeBind1(5, 5, x_r7[0]));
} }
function GateStatusComponent_div_0_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 12);
    ɵɵelement(1, "i");
    ɵɵelementStart(2, "span", 6);
    ɵɵtext(3);
    ɵɵpipe(4, "translate");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    var alarm_r8 = ctx.$implicit;
    var ctx_r4 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵclassMap(ctx_r4.alarmClass);
    ɵɵadvance(2);
    ɵɵtextInterpolate(ɵɵpipeBind1(4, 3, alarm_r8));
} }
function GateStatusComponent_div_0_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 11);
    ɵɵelement(1, "i");
    ɵɵelementStart(2, "span", 6);
    ɵɵtext(3);
    ɵɵpipe(4, "translate");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r5 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵclassMap(ctx_r5.suppressAlarmClass);
    ɵɵadvance(2);
    ɵɵtextInterpolate(ɵɵpipeBind1(4, 3, "Clearance"));
} }
function GateStatusComponent_div_0_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 12);
    ɵɵelement(1, "i", 13);
    ɵɵelementStart(2, "span", 6);
    ɵɵtext(3);
    ɵɵpipe(4, "translate");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r6 = ɵɵnextContext(2);
    ɵɵadvance(3);
    ɵɵtextInterpolate(ɵɵpipeBind1(4, 1, ctx_r6.status.configurationsConfig.selectedConfiguration == null ? null : ctx_r6.status.configurationsConfig.selectedConfiguration.displayName));
} }
function GateStatusComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 2);
    ɵɵtemplate(1, GateStatusComponent_div_0_div_1_Template, 4, 8, "div", 3);
    ɵɵelementStart(2, "div", 4);
    ɵɵelementStart(3, "span", 5);
    ɵɵelement(4, "i");
    ɵɵelementStart(5, "span", 6);
    ɵɵtext(6);
    ɵɵpipe(7, "translate");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(8, GateStatusComponent_div_0_ng_container_8_Template, 6, 7, "ng-container", 7);
    ɵɵtemplate(9, GateStatusComponent_div_0_div_9_Template, 5, 5, "div", 8);
    ɵɵtemplate(10, GateStatusComponent_div_0_div_10_Template, 5, 5, "div", 9);
    ɵɵtemplate(11, GateStatusComponent_div_0_div_11_Template, 5, 3, "div", 1);
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.showPingTime);
    ɵɵadvance(3);
    ɵɵclassMap(ctx_r0.modeStateIconClasses);
    ɵɵadvance(2);
    ɵɵtextInterpolate(ɵɵpipeBind1(7, 8, ctx_r0.status.mode));
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", ctx_r0.failedDeviceClasses);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r0.status.alarms);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.status.isSuppressAlarm);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.showConfiguration);
} }
function GateStatusComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 12);
    ɵɵelement(1, "i", 14);
    ɵɵelementStart(2, "span", 6);
    ɵɵtext(3);
    ɵɵpipe(4, "translate");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(3);
    ɵɵtextInterpolate(ɵɵpipeBind1(4, 1, "Disconnected"));
} }
var baseFa = 'align-baseline fa fa-lg fa-fw ';
var GateStatusComponent = /** @class */ (function () {
    function GateStatusComponent() {
        this.showPingTime = false;
        this.failedDeviceClasses = [];
    }
    Object.defineProperty(GateStatusComponent.prototype, "status", {
        get: function () {
            return this._status;
        },
        set: function (x) {
            this._status = x;
            this.updateState();
        },
        enumerable: true,
        configurable: true
    });
    GateStatusComponent.prototype.updateState = function () {
        var _this = this;
        this.modeStateIconClasses = this.getModeStateIconClasses();
        this.simpleStateIconClass = this.getSimpleStateIconClass();
        this.connectedIconClass = this.getConnectedIconClass();
        this.status.devices.filter(function (x) { return x.failure; });
        this.failedDeviceClasses = this.status.devices
            .filter(function (x) { return x.failure; })
            .map(function (x) { return [x.name, _this.getDeviceIconClass(x), _this.getDeviceTextClass(x)]; });
        this.alarmClass = this.getAlarmClass();
        this.simpleStateIconClass = this.getSuppressAlarmClass();
    };
    GateStatusComponent.prototype.getModeStateIconClasses = function () {
        var mode = this.status.mode;
        var isConnected = this.status.isConnected;
        var isBlinking = mode in GateBlinkingMode;
        var modeClasses = new Map([
            ['Weac', 'fa-wrench color-aqua'],
            ['Normal', 'fa-thumbs-up color-green'],
            ['Service', 'fa-unlock color-green'],
            ['FireAlarm', 'fa-fire color-red'],
            ['Emergency', 'fa-phone color-red'],
            ['Locked', 'fa-lock color-warning'],
            ['LockedEntry', 'fa-lock color-warning'],
            ['LockedExit', 'fa-lock color-warning'],
            ['Winner', 'fa-star color-red blinking'],
        ]).get(mode);
        return baseFa + " " + modeClasses + " " + (isConnected ? '' : ' inactive-color ') + " " + (isBlinking ? ' blinking' : '');
    };
    GateStatusComponent.prototype.getSimpleStateIconClass = function () {
        var state = this.status.simpleState;
        var css = '';
        switch (state) {
            case 'Closed':
                css = 'fa-minus-circle color-blue';
                break;
            case 'OpenEntry':
                css = 'fa-arrow-up color-green';
                break;
            case 'OpenExit':
                css = 'fa-arrow-down color-green';
                break;
            case 'Unknown':
                css = 'fa-question color-warning';
                break;
        }
        css = css ? baseFa + css : '';
        if (css != null) {
            css = this.status.isConnected ? css : css + " inactive-color";
        }
        return css;
    };
    GateStatusComponent.prototype.getConnectedIconClass = function () {
        return Icon.getBooleanCssClass(this.status.isConnected, undefined, 'color-gray', true);
    };
    GateStatusComponent.prototype.getDeviceIconClass = function (x) {
        var css = '';
        if (!x.failure) {
            css = 'fa-thumbs-up color-green';
        }
        else if (x.isOptional) {
            css = 'fa-thumbs-up color-warning';
        }
        else {
            css = 'fa-thumbs-down color-red';
        }
        css = css ? baseFa + css : '';
        return this.status.isConnected ? css : css + " inactive-color";
    };
    GateStatusComponent.prototype.getDeviceTextClass = function (x) {
        var css = '';
        if (!x.failure) {
            css = 'color-green';
        }
        else if (x.isOptional) {
            css = 'color-warning';
        }
        else {
            css = 'color-red';
        }
        return this.status.isConnected ? css : css + " inactive-color";
    };
    Object.defineProperty(GateStatusComponent.prototype, "dispatcherIconClass", {
        get: function () {
            var css = '';
            var dispatcher = this.status.dispatcher;
            if (dispatcher) {
                if (dispatcher.isConnected && dispatcher.isPrimary) {
                    css = 'fa-thumbs-up color-green';
                }
                else if (dispatcher.isConnected) {
                    css = 'fa-thumbs-up color-warning';
                }
                else {
                    css = 'fa-thumbs-down color-red';
                }
            }
            css = css ? baseFa + css : '';
            if (css != null) {
                css = this.status.isConnected ? css : css + " inactive-color";
            }
            return css;
        },
        enumerable: true,
        configurable: true
    });
    GateStatusComponent.prototype.getAlarmClass = function () {
        var alarms = this.status.alarms;
        var alarm = alarms != null && alarms.length;
        return alarm && this.status.isConnected ? baseFa + 'fa-bell color-red blinking' : 'hide';
    };
    GateStatusComponent.prototype.getSuppressAlarmClass = function () {
        var alarm = this.status.isSuppressAlarm && this.status.isConnected;
        return alarm ? baseFa + 'fa-bell color-warning blinking' : 'hide';
    };
    Object.defineProperty(GateStatusComponent.prototype, "showConfiguration", {
        get: function () {
            var s = this.status;
            var c = s === null || s === void 0 ? void 0 : s.configurationsConfig;
            return s && s.isConnected && (c === null || c === void 0 ? void 0 : c.canSelect);
        },
        enumerable: true,
        configurable: true
    });
    /** @nocollapse */ GateStatusComponent.ɵfac = function GateStatusComponent_Factory(t) { return new (t || GateStatusComponent)(); };
    /** @nocollapse */ GateStatusComponent.ɵcmp = ɵɵdefineComponent({ type: GateStatusComponent, selectors: [["lib-gate-status"]], inputs: { showPingTime: "showPingTime", status: "status" }, decls: 2, vars: 2, consts: [["class", "gates-grid-item-status", 4, "ngIf"], ["class", "truncate", 4, "ngIf"], [1, "gates-grid-item-status"], ["class", "pr-2", 4, "ngIf"], [1, "mb-1", "truncate"], [2, "white-space", "nowrap"], [1, "align-baseline"], [4, "ngFor", "ngForOf"], ["class", "truncate", 4, "ngFor", "ngForOf"], ["class", "mb-1", 4, "ngIf"], [1, "pr-2"], [1, "mb-1"], [1, "truncate"], [1, "fa", "fa-info-circle", "fa-fw", "fa-lg", "color-blue", "bold"], [1, "fa", "fa-unlink", "fa-lg", "fa-fw", "color-red", "bold"]], template: function GateStatusComponent_Template(rf, ctx) { if (rf & 1) {
            ɵɵtemplate(0, GateStatusComponent_div_0_Template, 12, 10, "div", 0);
            ɵɵtemplate(1, GateStatusComponent_div_1_Template, 5, 3, "div", 1);
        } if (rf & 2) {
            ɵɵproperty("ngIf", ctx.status && ctx.status.isConnected);
            ɵɵadvance(1);
            ɵɵproperty("ngIf", !ctx.status || !ctx.status.isConnected);
        } }, directives: [NgIf, NgForOf], pipes: [TranslatePipe, LocalizedDatePipe], styles: [".blinking[_ngcontent-%COMP%]{animation:1s steps(2,start) infinite blink-animation;-webkit-animation:1s steps(2,start) infinite blink-animation}@keyframes blink-animation{to{visibility:hidden}}@-webkit-keyframes blink-animation{to{visibility:hidden}}.truncate[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:25ch}.color-red[_ngcontent-%COMP%]{color:red}.color-gray[_ngcontent-%COMP%]{color:#777}.color-green[_ngcontent-%COMP%]{color:#40a73f}.color-warning[_ngcontent-%COMP%]{color:#f9c000}.color-blue[_ngcontent-%COMP%]{color:#007bff}"] });
    return GateStatusComponent;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(GateStatusComponent, [{
        type: Component,
        args: [{
                selector: 'lib-gate-status',
                templateUrl: 'gate-status.component.html',
                styleUrls: ['gate-status.component.scss']
            }]
    }], null, { showPingTime: [{
            type: Input
        }], status: [{
            type: Input
        }] }); })();

var GateType;
(function (GateType) {
    GateType[GateType["GalaxyGate"] = 0] = "GalaxyGate";
    GateType[GateType["GalaxyPort"] = 1] = "GalaxyPort";
    GateType[GateType["Turnstile"] = 2] = "Turnstile";
    GateType[GateType["Door"] = 3] = "Door";
    GateType[GateType["SlidingDoor"] = 4] = "SlidingDoor";
})(GateType || (GateType = {}));
function parseGateType(x) {
    var defaultResult = GateType.GalaxyGate;
    if (x == null) {
        return defaultResult;
    }
    try {
        var r = Object.keys(GateType).find(function (y) { return y === x; });
        return r ? GateType[r] : defaultResult;
    }
    catch (e) {
        return GateType.GalaxyGate;
    }
}

var GateControl = /** @class */ (function () {
    function GateControl(init) {
        this.id = null;
        this.alarmState = null;
        this.changed = new Subject$1();
        this.gateType = null;
        this.anyFailedDevice = null;
        this.mode = null;
        this.simpleState = null;
        this.isConnected = null;
        this.isLightAlarmActive = null;
        Object.assign(this, init);
    }
    GateControl.prototype.update = function (other) {
        var _this = this;
        if (!other) {
            return false;
        }
        var state = { changed: false };
        var u = function (x1, x2, attrName) {
            if (attrName === 'changed') {
                return;
            }
            var v1 = x1[attrName];
            var v2 = x2[attrName];
            if (v1 === v2 || v2 === undefined || isEqual(v1, v2)) {
                return;
            }
            x1[attrName] = v2;
            state.changed = true;
        };
        Object.keys(this).forEach(function (x) { return u(_this, other, x); });
        this.changed.next();
    };
    return GateControl;
}());

var GateAction;
(function (GateAction) {
    GateAction[GateAction["Normal"] = 0] = "Normal";
    GateAction[GateAction["Locked"] = 1] = "Locked";
    GateAction[GateAction["LockedEntry"] = 2] = "LockedEntry";
    GateAction[GateAction["LockedExit"] = 3] = "LockedExit";
    GateAction[GateAction["ServiceEntry"] = 4] = "ServiceEntry";
    GateAction[GateAction["ServiceExit"] = 5] = "ServiceExit";
    GateAction[GateAction["SingleOpenExit"] = 6] = "SingleOpenExit";
    GateAction[GateAction["SingleOpenEntry"] = 7] = "SingleOpenEntry";
    GateAction[GateAction["Emergency"] = 8] = "Emergency";
    GateAction[GateAction["EmergencyCancel"] = 9] = "EmergencyCancel";
    GateAction[GateAction["RestartApp"] = 10] = "RestartApp";
    GateAction[GateAction["SuppressAlarm"] = 11] = "SuppressAlarm";
    GateAction[GateAction["SuppressAlarmCancel"] = 12] = "SuppressAlarmCancel";
})(GateAction || (GateAction = {}));

var _c0$6 = ["gateElement"];
/* tslint:disable:no-bitwise */
var DrawFlag;
(function (DrawFlag) {
    DrawFlag[DrawFlag["None"] = 0] = "None";
    DrawFlag[DrawFlag["Gate"] = 1] = "Gate";
    DrawFlag[DrawFlag["Buttons"] = 2] = "Buttons";
    DrawFlag[DrawFlag["Text"] = 4] = "Text";
    DrawFlag[DrawFlag["All"] = 255] = "All";
})(DrawFlag || (DrawFlag = {}));
var defaultGateDoorOnClass = 'gateDoorOn';
var defaultGateDoorOffClass = 'gateDoorOff';
var defaultGateDoorRedClass = 'gateDoorRed';
var defaultInactiveLightGateClass = 'gateLightInactive';
var defaultGreenLightGateClass = 'gateGreen';
var defaultGreenPassGateClass = 'gatePassGreen';
var defaultRedLightGateClass = 'gateRed';
var greenBlinkingClass = defaultGreenPassGateClass + " blinking";
var alarmBlinkingClass = defaultGateDoorRedClass + " blinking";
var alarmSlowBlinkingClass = defaultGateDoorRedClass + " blinking-slow";
var GateControlComponent = /** @class */ (function () {
    function GateControlComponent(element, translateService, d3Service, router) {
        this.element = element;
        this.translateService = translateService;
        this.d3Service = d3Service;
        this.router = router;
        this.svgWidth = 200;
        this.disabled = false;
        this.gateWidth = 0;
        this.gateHeight = 0;
        this.baseSvgHeight = 468;
        this.onceDrawnFlags = DrawFlag.None;
        this.timer = null;
        this.actionInProgressTimer = null;
        this.d3 = d3Service.getD3();
    }
    GateControlComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscrGateChanged = this.gate.changed.subscribe(function () { return _this.updateState(); });
        this.subscrLangChanged = this.translateService.onLangChange.subscribe(function () { return _this.draw(DrawFlag.Buttons | DrawFlag.Text); });
        // this.gateUnits = m.getGateUnitsByGateId(id);
        this.startTimer(true);
    };
    GateControlComponent.prototype.ngOnDestroy = function () {
        this.subscrGateChanged.unsubscribe();
        this.subscrLangChanged.unsubscribe();
        clearTimeout(this.timer);
        clearTimeout(this.actionInProgressTimer);
    };
    GateControlComponent.prototype.ngAfterViewInit = function () {
        var rect = this.gateElement.nativeElement.getBoundingClientRect();
        this.gateWidth = rect.width;
        this.gateHeight = rect.height;
        this.updateState();
    };
    GateControlComponent.prototype.startTimer = function (isStart) {
        var _this = this;
        if (isStart === void 0) { isStart = false; }
        if (!isStart && !this.timer) {
            return;
        }
        this.timer = setTimeout(function () {
            if (_this.isConnected) {
                _this.updateState();
            }
            _this.startTimer();
        }, 5000);
    };
    GateControlComponent.prototype.updateState = function (forceDrawflag) {
        if (forceDrawflag === void 0) { forceDrawflag = null; }
        var gate = this.gate;
        var oldIsConnected = this.isConnected;
        this.isConnected = gate.isConnected;
        var connectionChanged = oldIsConnected !== this.isConnected;
        var oldMode = this.mode;
        this.mode = gate.mode;
        var modeChanged = oldMode !== this.mode;
        var oldSimpleState = this.simpleState;
        this.simpleState = gate.simpleState;
        var simpleStateChanged = oldSimpleState !== this.simpleState;
        // const oldGateUnits = this.gateUnits;
        // this.gateUnits = newState.gateUnits;
        // const gateUnitsChanged = !_.isEqual(oldGateUnits, this.gateUnits);
        var oldalArmState = this.alarmState;
        this.alarmState = gate.alarmState;
        this.isLightAlarmActive = gate.isLightAlarmActive;
        var isAlarmChanged = !isEqual(oldalArmState, this.alarmState);
        var oldGateType = this.gateType;
        this.gateType = this.gate.gateType;
        var isGateTypeChanged = oldGateType !== this.gateType;
        var oldIsAnyFailedDevice = this.isAnyFailedDevice;
        this.isAnyFailedDevice = gate.anyFailedDevice;
        var isAnyFailedDeviceChanged = oldIsAnyFailedDevice !== this.isAnyFailedDevice;
        if (connectionChanged
            || forceDrawflag === DrawFlag.Buttons
            || !this.isFlagSet(DrawFlag.Buttons, this.onceDrawnFlags)) {
            this.draw(DrawFlag.Buttons);
        }
        if (connectionChanged
            || modeChanged
            || simpleStateChanged
            || isAlarmChanged
            || isGateTypeChanged
            || isAnyFailedDeviceChanged
            //      || gateUnitsChanged
            || !this.isFlagSet(DrawFlag.Gate, this.onceDrawnFlags)) {
            this.draw(DrawFlag.Gate);
        }
        if (!this.isFlagSet(DrawFlag.Text, this.onceDrawnFlags)) {
            this.draw(DrawFlag.Text);
        }
    };
    GateControlComponent.prototype.isFlagSet = function (flag, flags) {
        return (flag & flags) === flag;
    };
    GateControlComponent.prototype.draw = function (flags) {
        if (flags === void 0) { flags = DrawFlag.All; }
        var d3 = this.d3;
        var d3ParentElement = d3.select(this.element.nativeElement);
        var root = d3ParentElement.select('#gateElement');
        if (this.isFlagSet(DrawFlag.Gate, flags)) {
            this.drawGate(root);
        }
        if (this.isFlagSet(DrawFlag.Buttons, flags)) {
            this.drawButtons(root);
        }
        if (this.isFlagSet(DrawFlag.Text, flags)) {
            this.drawText(root);
        }
        this.drawAlarm(root);
    };
    GateControlComponent.prototype.drawAlarm = function (parent) {
        var _this = this;
        var gate = this.gate;
        var g = this.recreateSvgContainer(parent, 'svg-alarm');
        [
            { id: 0, isEntry: true, x: 33, y: 55 },
            { id: 1, isEntry: false, x: 221, y: 55 },
            { id: 2, isEntry: true, x: 33, y: 247 },
            { id: 3, isEntry: false, x: 221, y: 247 },
        ].forEach(function (x) {
            return g.append('rect')
                .attr('id', "gg-alarm-" + gate.id + "-" + x.id)
                .attr('class', _this.alarmClass)
                .attr('x', x.x)
                .attr('y', x.y)
                .attr('width', 26)
                .attr('height', 155)
                .attr('rx', 3)
                .attr('ry', 3);
        });
    };
    GateControlComponent.prototype.drawText = function (parent) {
        this.onceDrawnFlags |= DrawFlag.Text;
        var g = this.recreateSvgContainer(parent, 'svg-text-root');
        var gate = this.gate;
        var text = this.translateService.instant('Entry');
        var x = 242;
        var y = 402;
        g.append('text')
            .attr('id', "direction-" + gate.id)
            .attr('class', 'directionText')
            .attr('x', x)
            .attr('y', y)
            .attr('transform', "rotate(-90 " + x + " " + y + ")")
            .text(text);
    };
    GateControlComponent.prototype.drawButtons = function (parent) {
        var _this = this;
        this.onceDrawnFlags |= DrawFlag.Buttons;
        var g = this.recreateSvgContainer(parent, 'svg-buttons-root');
        var gate = this.gate;
        var enabled = this.isConnected;
        var drawButton = function (tag, x, y, height, width, text, action) {
            var btnClass = 'svg-button';
            var cssClass = enabled ? btnClass : btnClass + " " + btnClass + "-disabled";
            var c = g.append('g');
            if (enabled) {
                c.attr('class', 'svg-button-container');
            }
            c.append('rect')
                .attr('id', "button-" + tag + "-" + gate.id)
                .attr('class', cssClass)
                .attr('x', x)
                .attr('y', y)
                .attr('width', width)
                .attr('height', height)
                .attr('rx', 3)
                .attr('ry', 3)
                .on('click', function () { return enabled ? _this.onActionRequest(action) : function () { }; });
            var txtClass = 'svg-button-text';
            cssClass = enabled ? txtClass : txtClass + " " + txtClass + "-disabled";
            c.append('text')
                .attr('id', "text-" + tag + "-" + gate.id)
                .attr('x', x + width / 2)
                .attr('y', y + height / 2)
                .attr('dominant-baseline', 'middle')
                .attr('text-anchor', 'middle')
                .attr('class', cssClass)
                .text(_this.translateService.instant(text));
        };
        [
            { tag: 'exit-single-free', y: 55, text: 'Single Free', action: GateAction.SingleOpenExit },
            { tag: 'exit-lock', y: 110, text: 'SwitchToLocked', action: GateAction.LockedExit },
            { tag: 'exit-open-service', y: 165, text: 'Open Service', action: GateAction.ServiceExit },
            { tag: 'entry-open-service', y: 247, text: 'Open Service', action: GateAction.ServiceEntry },
            { tag: 'entry-lock', y: 302, text: 'SwitchToLocked', action: GateAction.LockedEntry },
            { tag: 'entry-single-free', y: 357, text: 'Single Free', action: GateAction.SingleOpenEntry },
        ].forEach(function (x) { return drawButton(x.tag, 60, x.y, 45, 160, x.text, x.action); });
        drawButton('normal', 2, 412, 45, 276, 'SwitchToNomal', GateAction.Normal);
        drawButton('locked', 2, 467, 45, 276, 'SwitchToLocked', GateAction.Locked);
    };
    GateControlComponent.prototype.drawGate = function (parent) {
        this.onceDrawnFlags |= DrawFlag.Gate;
        var g = this.recreateSvgContainer(parent, 'svg-gate-root');
        var gate = this.gate;
        switch (this.gateType) {
            case GateType.GalaxyPort:
                this.drawGateGP(g);
                break;
            case GateType.Turnstile:
                this.drawGateTurntile(g);
                break;
            case GateType.Door:
                this.drawGateDoor(g);
                break;
            case GateType.SlidingDoor:
                this.drawSlidingDoor(g);
                break;
            case GateType.GalaxyGate:
            default:
                this.drawGateGG(g);
        }
    };
    GateControlComponent.prototype.drawSlidingDoor = function (g) {
        var gate = this.gate;
        var id = this.gate.id;
        [
            { name: 'box-left', x: 0, y: 0, height: 32 },
            { name: 'box-right-1', x: 227, y: 0, height: 10 },
            { name: 'box-right-2', x: 227, y: 22, height: 10 },
        ].forEach(function (x) {
            return g.append('rect')
                .attr('id', "sd-" + x.name + "-" + gate.id)
                .attr('class', 'svg-gate-body')
                .attr('x', x.x)
                .attr('y', x.y)
                .attr('height', x.height)
                .attr('width', 50);
        });
        var door = g.append('rect')
            .attr('id', "gg-door-" + gate.id)
            .attr('class', this.gateDoorClass)
            .attr('x', 54)
            .attr('y', 11)
            .attr('rx', 3)
            .attr('ry', 3)
            .attr('height', 10)
            .attr('width', 210);
        g.attr('transform', 'translate(1, 214)');
        return;
        // if (!this.gateUnits) {
        //   return;
        // }
        // const gateUnit = this.gateUnits && this.gateUnits.length ? this.gateUnits[0] : null;
        // if (!gateUnit) {
        //   return;
        // }
        // const position = gateUnit.position ? gateUnit.position : null;
        // let isOpen = false;
        // if (position != null) {
        //   isOpen = position === GateUnitPosition.OpenEntry || position === GateUnitPosition.OpenExit;
        // } else {
        //   isOpen = ['OpenEntry', 'OpenExit'].includes(this.simpleState);
        // }
        // if (isOpen) {
        //   door.attr('transform', 'translate(166, 0)');
        // }
        // this.drawTrafficeLight(g);
    };
    GateControlComponent.prototype.drawTrafficeLight = function (g) {
        // const gate = this.gate;
        // const gateUnit = this.gateUnits && this.gateUnits.length ? this.gateUnits[0] : null;
        // const position = gateUnit.position ? gateUnit.position : null;
        // const r = 24;
        // const y = -110;
        // ['red', 'green'].forEach(x => {
        //   g.append('circle')
        //     .attr('id', `tl-${gate.id}`)
        //     .attr('class', this.getTrafficLightClass(x, position))
        //     .attr('cx', r)
        //     .attr('cy', x === 'red' ? y : y + 2 * r + 5)
        //     .attr('r', r);
        // });
    };
    // private getTrafficLightClass(color: string, p: GateUnitPosition): string {
    //   const off = 'traffic-light-off';
    //   const red = 'traffic-light-red';
    //   const green = 'traffic-light-green';
    //   const c = this.isConnected;
    //   switch (color) {
    //     case 'red':
    //       return p === GateUnitPosition.Closed && c ? red : `${red} ${off}`;
    //     case 'green':
    //       return [GateUnitPosition.OpenEntry,
    //       GateUnitPosition.OpenExit].some(x => x === p) && c ? green : `${green} ${off}`;
    //   }
    //   return null;
    // }
    GateControlComponent.prototype.drawGateGG = function (g) {
        var _this = this;
        var gate = this.gate;
        [
            { isMaster: true, x: 248 },
            { isMaster: false, x: 2 }
        ].forEach(function (x) {
            return g.append('rect')
                .attr('id', "gg-" + _this.getPartNameX(x.isMaster) + "-" + gate.id)
                .attr('class', 'svg-gate-body')
                .attr('x', x.x)
                .attr('y', 53)
                .attr('width', 30)
                .attr('height', 350)
                .attr('rx', 3)
                .attr('ry', 3);
        });
        [
            { isMaster: false, isEntry: false, x: 15, y: 76 },
            { isMaster: false, isEntry: true, x: 15, y: 258 },
            { isMaster: true, isEntry: false, x: 261, y: 76 },
            { isMaster: false, isEntry: true, x: 261, y: 258 },
        ].forEach(function (x) {
            g.append('rect')
                .attr('id', "gg-light-" + _this.getPartNameX(x.isMaster) + "-" + _this.getPartNameY(x.isEntry) + "-" + gate.id)
                .attr('class', _this.getGateLightClass(x.isEntry))
                .attr('x', x.x)
                .attr('y', x.y)
                .attr('width', 5)
                .attr('height', 120)
                .attr('rx', 1)
                .attr('ry', 1);
        });
        this.drawDoorArms(g, 145, 40, 224, 95);
        [
            { isMaster: true, d: 'M9.797174393178826e-16,-16A16,16,0,1,1,9.797174393178826e-16,16L0,0Z', transform: 'translate(32, 229)' },
            { isMaster: false, d: 'M9.797174393178826e-16,16A16,16,0,1,1,-2.9391523179536475e-15,-16L0,0Z', transform: 'translate(248, 229)' }
        ].forEach(function (x) {
            return g.append('path')
                .attr('id', "gg-axis-" + _this.getPartNameX(x.isMaster) + "-" + gate.id)
                .attr('class', 'svg-gate-body')
                .attr('d', x.d)
                .attr('transform', x.transform);
        });
    };
    GateControlComponent.prototype.doorHandle = function (g) {
        return g.append('path')
            .attr('id', 'gg-door-handle')
            .attr('class', this.gateDoorClass)
            .attr('d', 'M 48,5 V 4 H 49 V 0 C 49,-0.5 49.53,-1 50,-1 H 66 V -0.3 V 2 H 64 V 1 H 52.69 C 52.32,1 52,1.3 52,1.7 V 4 H 53 V 5 Z');
    };
    GateControlComponent.prototype.drawGateDoor = function (g) {
        var _this = this;
        var gate = this.gate;
        [
            { name: 'box-left', x: 0, y: 0 },
            { name: 'box-right', x: 220, y: 0 },
        ].forEach(function (x) {
            return g.append('rect')
                .attr('id', "gd-" + x.name + "-" + gate.id)
                .attr('class', 'svg-gate-body')
                .attr('x', x.x)
                .attr('y', x.y)
                .attr('height', 20)
                .attr('width', 32);
        });
        var state_to_angle = function (state) {
            switch (state) {
                case 'OpenEntry':
                    return 90;
                case 'OpenExit':
                    return 270;
                default:
                    return 0;
            }
        };
        var getTransformation = function (b) {
            return "rotate(" + state_to_angle(_this.simpleState) + ", " + ((b.width - b.height / 2) + b.x) + ", " + (b.height / 2 + b.y) + ")";
        };
        var door = g.append('rect')
            .attr('id', "gg-door-" + gate.id)
            .attr('class', this.gateDoorClass)
            .attr('x', 36)
            .attr('y', 5)
            .attr('rx', 2)
            .attr('ry', 2)
            .attr('height', 8)
            .attr('width', 180);
        var handle = this.doorHandle(g);
        g.attr('transform', 'translate(19, 220)');
        [
            door,
            handle
        ].forEach(function (x) { return x.attr('transform', "" + getTransformation(door.node().getBBox())); });
    };
    GateControlComponent.prototype.drawGateGP = function (g) {
        var _this = this;
        var gate = this.gate;
        this.drawDoorArms(g, 145, 20, 224, 115);
        var xM = 260;
        var xS = 20;
        [
            { isMaster: true, x: xM, r: 16, cssClass: 'svg-gate-body' },
            { isMaster: false, x: xS, r: 16, cssClass: 'svg-gate-body' },
            { isMaster: true, x: xM, r: 19, cssClass: 'svg-gate-border' },
            { isMaster: false, x: xS, r: 19, cssClass: 'svg-gate-border' },
        ].forEach(function (x) {
            return g.append('circle')
                .attr('id', "gp-axis-" + _this.getPartNameX(x.isMaster) + "-" + gate.id)
                .attr('class', x.cssClass)
                .attr('cx', x.x)
                .attr('cy', 228)
                .attr('r', x.r);
        });
    };
    GateControlComponent.prototype.drawDoorArms = function (g, xMaster, xSlave, y, w) {
        var _this = this;
        [
            { isMaster: true, x: xMaster },
            { isMaster: false, x: xSlave }
        ].forEach(function (x) {
            var h = 10;
            var gate = _this.gate;
            g.append('rect')
                .attr('id', "gg-door-" + _this.getPartNameX(x.isMaster) + "-" + gate.id)
                .attr('class', _this.gateDoorClass)
                .attr('x', x.x)
                .attr('y', y)
                .attr('width', w)
                .attr('height', 10)
                .attr('rx', 3)
                .attr('ry', 3)
                .attr('transform', _this.getDoorTransformation(x.isMaster, x.x, y, w, h));
        });
    };
    GateControlComponent.prototype.drawGateTurntile = function (g) {
        var _this = this;
        var gate = this.gate;
        var xAxis = 260;
        this.drawTurnstileRod(g, 260, 224, 200, 0);
        this.drawTurnstileRod(g, 260, 224, 80, 70);
        this.drawTurnstileRod(g, 260, 224, 80, -70);
        this.drawTurnstileWall(g);
        [
            { isMaster: true, x: xAxis, r: 16, cssClass: 'svg-gate-body' },
            { isMaster: true, x: xAxis, r: 19, cssClass: 'svg-gate-border' },
        ].forEach(function (x) {
            return g.append('circle')
                .attr('id', "gp-axis-" + _this.getPartNameX(x.isMaster) + "-" + gate.id)
                .attr('class', x.cssClass)
                .attr('cx', x.x)
                .attr('cy', 228)
                .attr('r', x.r);
        });
    };
    GateControlComponent.prototype.drawTurnstileRod = function (g, x, y, width, angle) {
        var gate = this.gate;
        var h = 10;
        var y_ = angle === 0 ? y : y + h / 2;
        var w_ = angle === 0 && (this.simpleState === 'OpenExit' || this.simpleState === 'OpenEntry') ? width / 4 : width;
        g.append('rect')
            .attr('id', "gg-turnstile-main-" + gate.id)
            .attr('class', this.gateDoorClass)
            .attr('x', x - w_)
            .attr('y', y)
            .attr('width', w_)
            .attr('height', h)
            .attr('rx', 3)
            .attr('ry', 3)
            .attr('transform', "rotate(" + angle + " " + x + " " + y_ + ")");
    };
    GateControlComponent.prototype.drawTurnstileWall = function (g) {
        var arc = this.d3.arc()
            .innerRadius(100)
            .outerRadius(120)
            .startAngle(240 * (Math.PI / 180))
            .endAngle(300 * (Math.PI / 180));
        g.append('path')
            .attr('d', arc)
            .attr('class', 'svg-gate-body')
            .attr('transform', 'translate(124,224)');
    };
    GateControlComponent.prototype.recreateSvgContainer = function (parent, containerId) {
        var g = parent.select('#' + containerId);
        if (g.size()) {
            g.remove();
        }
        g = parent.append('g').attr('id', containerId);
        return g;
    };
    GateControlComponent.prototype.getPartNameX = function (isMaster) {
        return isMaster ? 'master' : 'slave';
    };
    GateControlComponent.prototype.getPartNameY = function (isEntry) {
        return isEntry ? 'entry' : 'exit';
    };
    GateControlComponent.prototype.getDoorTransformation = function (isMaster, x, y, w, h) {
        var s = this.simpleState;
        var angle = 0;
        var deltaX = isMaster ? w : 0;
        var deltaY = h / 2;
        switch (s) {
            case 'OpenEntry':
                angle = isMaster ? 90 : -90;
                x += deltaX;
                y += deltaY;
                break;
            case 'OpenExit':
                angle = isMaster ? -90 : 90;
                x += deltaX;
                y += deltaY;
                break;
            default:
                angle = 0;
        }
        return "rotate(" + angle + " " + x + " " + y + ")";
    };
    Object.defineProperty(GateControlComponent.prototype, "baseSvgWidth", {
        get: function () {
            return 280;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GateControlComponent.prototype, "viewBox", {
        get: function () {
            return '0 0 ' + this.baseSvgWidth + ' ' + this.baseSvgHeight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GateControlComponent.prototype, "gateStateClass", {
        get: function () {
            return this.isConnected ? 'gateZoneOff' : 'gateOff';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GateControlComponent.prototype, "alarmClass", {
        get: function () {
            return this.isLightAlarmActive ? alarmBlinkingClass : 'hide';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GateControlComponent.prototype, "gateDoorClass", {
        get: function () {
            var mode = this.mode;
            if (!this.isConnected) {
                return defaultGateDoorOffClass;
            }
            if (this.isLightAlarmActive && !this.anyEmergencyMode(mode)) {
                return alarmBlinkingClass;
            }
            if (this.isAnyFailedDevice && !this.anyEmergencyMode(mode)) {
                return alarmSlowBlinkingClass;
            }
            var modeClass = new Map([
                ['Weac', defaultGateDoorOnClass],
                ['Normal', defaultGateDoorOnClass],
                ['Service', defaultGreenPassGateClass],
                ['FireAlarm', greenBlinkingClass],
                ['Emergency', greenBlinkingClass],
                ['Locked', defaultGateDoorRedClass],
                ['LockedEntry', defaultGateDoorOnClass],
                ['LockedExit', defaultGateDoorOnClass],
            ]).get(mode);
            if (modeClass) {
                return modeClass;
            }
            return defaultGreenPassGateClass;
        },
        enumerable: true,
        configurable: true
    });
    GateControlComponent.prototype.anyEmergencyMode = function (mode) {
        return ['FireAlarm', 'Emergency'].some(function (x) { return x === mode; });
    };
    GateControlComponent.prototype.getGateLightClass = function (isEntry) {
        var mode = this.mode;
        if (!this.isConnected) {
            return defaultGateDoorOffClass;
        }
        if (this.isLightAlarmActive && !this.anyEmergencyMode(mode)) {
            return alarmBlinkingClass;
        }
        if (this.isAnyFailedDevice) {
            return alarmSlowBlinkingClass;
        }
        var normalClass = defaultInactiveLightGateClass;
        if (mode === 'Normal') {
            var s = this.simpleState;
            switch (s) {
                case 'OpenEntry':
                    normalClass = isEntry ? defaultGreenLightGateClass : defaultRedLightGateClass;
                    break;
                case 'OpenExit':
                    normalClass = isEntry ? defaultRedLightGateClass : defaultGreenLightGateClass;
                    break;
                default:
                    normalClass = defaultInactiveLightGateClass;
            }
        }
        var cssClass = new Map([
            ['Weac', defaultInactiveLightGateClass],
            ['Normal', normalClass],
            ['Service', defaultGreenLightGateClass],
            ['FireAlarm', greenBlinkingClass],
            ['Emergency', greenBlinkingClass],
            ['Locked', defaultRedLightGateClass],
            ['LockedEntry', isEntry ? defaultRedLightGateClass : normalClass],
            ['LockedExit', isEntry ? normalClass : defaultRedLightGateClass],
        ]).get(mode);
        if (cssClass) {
            return cssClass;
        }
        return defaultInactiveLightGateClass;
    };
    GateControlComponent.prototype.onActionRequest = function (action) {
        var _this = this;
        if (typeof this.actionCallback !== 'function') {
            console.error('Bad action');
            return;
        }
        this.actionInProgressTimer = setTimeout(function () {
            _this.onceDrawnFlags = DrawFlag.Buttons;
            _this.updateState(DrawFlag.Buttons);
        }, 500);
        this.actionCallback(action, this.gate.id);
    };
    /** @nocollapse */ GateControlComponent.ɵfac = function GateControlComponent_Factory(t) { return new (t || GateControlComponent)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(TranslateService), ɵɵdirectiveInject(D3Service), ɵɵdirectiveInject(Router)); };
    /** @nocollapse */ GateControlComponent.ɵcmp = ɵɵdefineComponent({ type: GateControlComponent, selectors: [["lib-gate-control"]], viewQuery: function GateControlComponent_Query(rf, ctx) { if (rf & 1) {
            ɵɵstaticViewQuery(_c0$6, true);
        } if (rf & 2) {
            var _t;
            ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.gateElement = _t.first);
        } }, inputs: { gate: "gate", svgWidth: "svgWidth", actionCallback: "actionCallback", disabled: "disabled" }, decls: 3, vars: 2, consts: [[1, "svg"], ["id", "gateElement", "transform", "translate(0 -52)"], ["gateElement", ""]], template: function GateControlComponent_Template(rf, ctx) { if (rf & 1) {
            ɵɵnamespaceSVG();
            ɵɵelementStart(0, "svg", 0);
            ɵɵelement(1, "g", 1, 2);
            ɵɵelementEnd();
        } if (rf & 2) {
            ɵɵattribute("width", ctx.svgWidth)("viewBox", ctx.viewBox);
        } }, styles: [".passage{fill:#d6d6d6;stroke-width:1px;stroke:#d6d6d6}.svg-button-primary{cursor:pointer;fill:#327cfe}.svg-button-primary-disabled{fill:#7aaafe}.svg-button-primary:hover{fill:#2762c6}.svg-button-success{cursor:pointer;fill:#41a644}.svg-button-success-disabled{fill:#84c586}.svg-button-success:hover{fill:#358738}.svg-button-warning{cursor:pointer;fill:#f9c11e}.svg-button-warning-disabled{fill:#fbd76d}.svg-button-warning:hover{fill:#daa817}.svg-button-secondary{cursor:pointer;stroke:#6c757d;stroke-width:1px;fill:transparent}.svg-button-secondary-disabled{opacity:.3}.svg-button-secondary-disabled:hover{opacity:.3;cursor:auto!important;fill:transparent!important}.svg-button-secondary:hover{fill:#6c757d}.svg-button{cursor:pointer;stroke:#6c757d;stroke-width:1px;fill:#f2f2f2}.svg-button:hover{fill:#6c757d}.svg-button-disabled{opacity:.3}.svg-button-disabled:hover{opacity:.3;cursor:auto!important;fill:transparent!important}.svg-gate-body{stroke:#6c757d;stroke-width:1px;fill:#f2f2f2;pointer-events:none}.svg-gate-border{stroke:#6c757d;stroke-width:1px;fill:transparent;pointer-events:none}.svg-button-text-disabled{opacity:.5}.svg-button-text{fill:#6c757d;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none;font-size:15pt}.svg-button-container:hover text{fill:#fff!important}.svg{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.svg text::-moz-selection{background:0 0}.svg text::selection{background:0 0}.red-box{fill:red}.gateGreen{fill:#5cb85c;stroke:#ccc;stroke-width:1px}.gatePassGreen{fill:#5cb85c}.gateRed{fill:red;stroke:#ccc;stroke-width:1px}.gatePassRed{fill:red}.gateLightInactive{fill:#337ab7;stroke:#ccc;stroke-width:1px}.blinking{-webkit-animation:1.5s linear infinite blinker;animation:1.5s linear infinite blinker}.blinking-slow{-webkit-animation:3s linear infinite blinker-slow;animation:3s linear infinite blinker-slow}@-webkit-keyframes blinker{50%{opacity:0}}@keyframes blinker{50%{opacity:0}}@-webkit-keyframes blinker-slow{10%{opacity:0}}@keyframes blinker-slow{10%{opacity:0}}.gate-link{font:1.7em/1 FontAwesome;fill:grey}.alarm{fill:rgba(255,0,0,.8)}.directionText{font-size:16px;font-weight:700;fill:#777;text-transform:uppercase;font-family:Arial,Gadget,sans-serif}.gateDoorOn{fill:#337ab7}.gateDoorOff{fill:grey;fill-opacity:.3}.gateDoorRed{fill:red}.traffic-light-red{fill:red;stroke:#ba0000}.traffic-light-green{fill:#33a532;stroke:#257824}.traffic-light-off{opacity:.1}.hide{display:none}"], encapsulation: 2 });
    return GateControlComponent;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(GateControlComponent, [{
        type: Component,
        args: [{
                selector: 'lib-gate-control',
                templateUrl: 'gate-control.component.html',
                styleUrls: ['gate-control.component.scss'],
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ElementRef }, { type: TranslateService }, { type: D3Service }, { type: Router }]; }, { gate: [{
            type: Input
        }], svgWidth: [{
            type: Input
        }], actionCallback: [{
            type: Input
        }], disabled: [{
            type: Input
        }], gateElement: [{
            type: ViewChild,
            args: ['gateElement', { static: true }]
        }] }); })();

var GateControlPanel = /** @class */ (function () {
    function GateControlPanel(init) {
        Object.assign(this, init);
    }
    return GateControlPanel;
}());

function ModalComponent_button_11_Template(rf, ctx) { if (rf & 1) {
    var _r3 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 8);
    ɵɵlistener("click", function ModalComponent_button_11_Template_button_click_0_listener() { ɵɵrestoreView(_r3); var ctx_r2 = ɵɵnextContext(); return ctx_r2.modal.close("Ok click"); });
    ɵɵtext(1);
    ɵɵpipe(2, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate(ɵɵpipeBind1(2, 1, ctx_r0.okName));
} }
function ModalComponent_button_12_Template(rf, ctx) { if (rf & 1) {
    var _r5 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 9);
    ɵɵlistener("click", function ModalComponent_button_12_Template_button_click_0_listener() { ɵɵrestoreView(_r5); var ctx_r4 = ɵɵnextContext(); return ctx_r4.modal.dismiss("cancel click"); });
    ɵɵtext(1);
    ɵɵpipe(2, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate(ɵɵpipeBind1(2, 1, ctx_r1.cancelName));
} }
var ModalComponent = /** @class */ (function () {
    function ModalComponent(modal, t) {
        this.modal = modal;
        this.t = t;
        this.okName = 'Confirm';
        this.cancelName = 'Cancel';
    }
    /** @nocollapse */ ModalComponent.ɵfac = function ModalComponent_Factory(t) { return new (t || ModalComponent)(ɵɵdirectiveInject(NgbActiveModal), ɵɵdirectiveInject(TranslateService)); };
    /** @nocollapse */ ModalComponent.ɵcmp = ɵɵdefineComponent({ type: ModalComponent, selectors: [["lib-modal"]], decls: 13, vars: 8, consts: [[1, "modal-header"], ["id", "modal-title", 1, "modal-title"], ["type", "button", "aria-describedby", "modal-title", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "modal-body"], [1, "modal-footer"], ["type", "button", "class", "btn btn-danger", 3, "click", 4, "ngIf"], ["type", "button", "class", "btn btn-outline-secondary", 3, "click", 4, "ngIf"], ["type", "button", 1, "btn", "btn-danger", 3, "click"], ["type", "button", 1, "btn", "btn-outline-secondary", 3, "click"]], template: function ModalComponent_Template(rf, ctx) { if (rf & 1) {
            ɵɵelementStart(0, "div", 0);
            ɵɵelementStart(1, "h4", 1);
            ɵɵtext(2);
            ɵɵpipe(3, "translate");
            ɵɵelementEnd();
            ɵɵelementStart(4, "button", 2);
            ɵɵlistener("click", function ModalComponent_Template_button_click_4_listener() { return ctx.modal.dismiss("Cross click"); });
            ɵɵelementStart(5, "span", 3);
            ɵɵtext(6, "\u00D7");
            ɵɵelementEnd();
            ɵɵelementEnd();
            ɵɵelementEnd();
            ɵɵelementStart(7, "div", 4);
            ɵɵtext(8);
            ɵɵpipe(9, "translate");
            ɵɵelementEnd();
            ɵɵelementStart(10, "div", 5);
            ɵɵtemplate(11, ModalComponent_button_11_Template, 3, 3, "button", 6);
            ɵɵtemplate(12, ModalComponent_button_12_Template, 3, 3, "button", 7);
            ɵɵelementEnd();
        } if (rf & 2) {
            ɵɵadvance(2);
            ɵɵtextInterpolate(ɵɵpipeBind1(3, 4, ctx.title));
            ɵɵadvance(6);
            ɵɵtextInterpolate1(" ", ɵɵpipeBind1(9, 6, ctx.message), "\n");
            ɵɵadvance(3);
            ɵɵproperty("ngIf", ctx.okName);
            ɵɵadvance(1);
            ɵɵproperty("ngIf", ctx.cancelName);
        } }, directives: [NgIf], pipes: [TranslatePipe], styles: [""] });
    return ModalComponent;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(ModalComponent, [{
        type: Component,
        args: [{
                selector: 'lib-modal',
                templateUrl: 'modal.component.html',
                styleUrls: ['modal.component.scss']
            }]
    }], function () { return [{ type: NgbActiveModal }, { type: TranslateService }]; }, null); })();

var GateControlPanelComponent = /** @class */ (function () {
    function GateControlPanelComponent(modalService) {
        this.modalService = modalService;
    }
    Object.defineProperty(GateControlPanelComponent.prototype, "disabled", {
        get: function () {
            return !this.panel.isConnected;
        },
        enumerable: true,
        configurable: true
    });
    GateControlPanelComponent.prototype.onEmergencyChange = function (event) {
        this.actionCallback(event ? GateAction.Emergency : GateAction.EmergencyCancel, this.panel.id);
    };
    GateControlPanelComponent.prototype.onSuppressAlarmChange = function (event) {
        this.actionCallback(event ? GateAction.SuppressAlarm : GateAction.SuppressAlarmCancel, this.panel.id);
    };
    GateControlPanelComponent.prototype.restart = function () {
        var _this = this;
        var m = this.modalService.open(ModalComponent);
        m.componentInstance.title = 'Restart Confirmation';
        m.componentInstance.message = 'Do you really want to restart the application?';
        m.result.then(function () { return _this.actionCallback(GateAction.RestartApp, _this.panel.id); }, function () { });
    };
    /** @nocollapse */ GateControlPanelComponent.ɵfac = function GateControlPanelComponent_Factory(t) { return new (t || GateControlPanelComponent)(ɵɵdirectiveInject(NgbModal)); };
    /** @nocollapse */ GateControlPanelComponent.ɵcmp = ɵɵdefineComponent({ type: GateControlPanelComponent, selectors: [["lib-gate-control-panel"]], inputs: { panel: "panel", actionCallback: "actionCallback" }, decls: 14, vars: 14, consts: [[1, "d-flex", "justify-content-between"], [1, "d-flex", "justify-content-start", "align-items-center"], [1, "label", "label-default"], ["color", "#f9c000", 1, "mr-3", "align-middle", 3, "ngModel", "disabled", "ngModelChange", "valueChange"], ["color", "#ff0000", 1, "mr-3", "align-middle", 3, "ngModel", "disabled", "ngModelChange", "valueChange"], ["type", "button", 1, "btn", "btn-danger", "m-0", 3, "disabled", "click"]], template: function GateControlPanelComponent_Template(rf, ctx) { if (rf & 1) {
            ɵɵelementStart(0, "div", 0);
            ɵɵelementStart(1, "div", 1);
            ɵɵelementStart(2, "span", 2);
            ɵɵtext(3);
            ɵɵpipe(4, "translate");
            ɵɵelementEnd();
            ɵɵelementStart(5, "ui-switch", 3);
            ɵɵlistener("ngModelChange", function GateControlPanelComponent_Template_ui_switch_ngModelChange_5_listener($event) { return ctx.panel.isSuppressAlarm = $event; })("valueChange", function GateControlPanelComponent_Template_ui_switch_valueChange_5_listener($event) { return ctx.onSuppressAlarmChange($event); });
            ɵɵelementEnd();
            ɵɵelementStart(6, "span", 2);
            ɵɵtext(7);
            ɵɵpipe(8, "translate");
            ɵɵelementEnd();
            ɵɵelementStart(9, "ui-switch", 4);
            ɵɵlistener("ngModelChange", function GateControlPanelComponent_Template_ui_switch_ngModelChange_9_listener($event) { return ctx.panel.isEmergency = $event; })("valueChange", function GateControlPanelComponent_Template_ui_switch_valueChange_9_listener($event) { return ctx.onEmergencyChange($event); });
            ɵɵelementEnd();
            ɵɵelementEnd();
            ɵɵelementStart(10, "div");
            ɵɵelementStart(11, "button", 5);
            ɵɵlistener("click", function GateControlPanelComponent_Template_button_click_11_listener() { return ctx.restart(); });
            ɵɵtext(12);
            ɵɵpipe(13, "translate");
            ɵɵelementEnd();
            ɵɵelementEnd();
            ɵɵelementEnd();
        } if (rf & 2) {
            ɵɵadvance(3);
            ɵɵtextInterpolate(ɵɵpipeBind1(4, 8, "Clearance"));
            ɵɵadvance(2);
            ɵɵproperty("ngModel", ctx.panel.isSuppressAlarm)("disabled", ctx.disabled);
            ɵɵadvance(2);
            ɵɵtextInterpolate(ɵɵpipeBind1(8, 10, "Emergency"));
            ɵɵadvance(2);
            ɵɵproperty("ngModel", ctx.panel.isEmergency)("disabled", ctx.disabled);
            ɵɵadvance(2);
            ɵɵproperty("disabled", ctx.disabled);
            ɵɵadvance(1);
            ɵɵtextInterpolate(ɵɵpipeBind1(13, 12, "Restart"));
        } }, directives: [UiSwitchComponent, NgControlStatus, NgModel], pipes: [TranslatePipe], styles: [""] });
    return GateControlPanelComponent;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(GateControlPanelComponent, [{
        type: Component,
        args: [{
                selector: 'lib-gate-control-panel',
                templateUrl: 'gate-control-panel.component.html',
                styleUrls: ['gate-control-panel.component.scss']
            }]
    }], function () { return [{ type: NgbModal }]; }, { panel: [{
            type: Input
        }], actionCallback: [{
            type: Input
        }] }); })();

var ConfigurationsConfigConverter = /** @class */ (function () {
    function ConfigurationsConfigConverter() {
    }
    ConfigurationsConfigConverter.prototype.serialize = function (x) {
        throw new Error('Not implemented');
    };
    ConfigurationsConfigConverter.prototype.deserialize = function (x) {
        try {
            return ConfigurationsConfig.fromJSON(x);
        }
        catch (_a) {
            return null;
        }
    };
    ConfigurationsConfigConverter = __decorate([
        JsonConverter
    ], ConfigurationsConfigConverter);
    return ConfigurationsConfigConverter;
}());
var ConfigurationsConfig = /** @class */ (function () {
    function ConfigurationsConfig(selectedName, configurations) {
        this.selectedName = selectedName;
        this.configurations = configurations;
        this.selectedConfiguration = selectedName ? this.configurations.find(function (x) { return x.name === selectedName; }) : null;
    }
    ConfigurationsConfig.fromJSON = function (data) {
        if (!data) {
            return null;
        }
        var selectedConfiguration = data.selected_name;
        var configurations = data.configurations.map(function (x) {
            return {
                name: x.name,
                displayName: x.display_name,
                enableCron: x.enable_cron,
                startDate: x.start_date,
                startTime: x.start_time,
                intervalType: x.interval_type,
                intervalNumber: x.interval_number,
            };
        });
        return new ConfigurationsConfig(selectedConfiguration, configurations);
    };
    Object.defineProperty(ConfigurationsConfig.prototype, "canSelect", {
        get: function () {
            return this.configurations && this.configurations.length > 1;
        },
        enumerable: true,
        configurable: true
    });
    return ConfigurationsConfig;
}());

function GateConfigurationSelectorComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 2);
    ɵɵelement(1, "i", 3);
    ɵɵelementStart(2, "label", 4);
    ɵɵtext(3);
    ɵɵpipe(4, "translate");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(3);
    ɵɵtextInterpolate(ɵɵpipeBind1(4, 1, "Please click 'Apply' to activate this configuration"));
} }
function GateConfigurationSelectorComponent_div_1_option_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "option", 11);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    var x_r3 = ctx.$implicit;
    ɵɵproperty("ngValue", x_r3);
    ɵɵadvance(1);
    ɵɵtextInterpolate(x_r3.displayName);
} }
function GateConfigurationSelectorComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    var _r5 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 5);
    ɵɵelementStart(1, "div", 6);
    ɵɵelementStart(2, "label", 4);
    ɵɵtext(3);
    ɵɵpipe(4, "translate");
    ɵɵelementEnd();
    ɵɵelementStart(5, "select", 7);
    ɵɵlistener("ngModelChange", function GateConfigurationSelectorComponent_div_1_Template_select_ngModelChange_5_listener($event) { ɵɵrestoreView(_r5); var ctx_r4 = ɵɵnextContext(); return ctx_r4.selectedConfiguration = $event; })("ngModelChange", function GateConfigurationSelectorComponent_div_1_Template_select_ngModelChange_5_listener($event) { ɵɵrestoreView(_r5); var ctx_r6 = ɵɵnextContext(); return ctx_r6.onChange($event); });
    ɵɵtemplate(6, GateConfigurationSelectorComponent_div_1_option_6_Template, 2, 2, "option", 8);
    ɵɵelementEnd();
    ɵɵelementStart(7, "button", 9);
    ɵɵlistener("click", function GateConfigurationSelectorComponent_div_1_Template_button_click_7_listener() { ɵɵrestoreView(_r5); var ctx_r7 = ɵɵnextContext(); return ctx_r7.apply(); });
    ɵɵtext(8);
    ɵɵpipe(9, "translate");
    ɵɵelementEnd();
    ɵɵelementStart(10, "button", 10);
    ɵɵlistener("click", function GateConfigurationSelectorComponent_div_1_Template_button_click_10_listener() { ɵɵrestoreView(_r5); var ctx_r8 = ɵɵnextContext(); return ctx_r8.reset(); });
    ɵɵtext(11);
    ɵɵpipe(12, "translate");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵtextInterpolate1("", ɵɵpipeBind1(4, 8, "Configuration"), ":");
    ɵɵadvance(2);
    ɵɵproperty("ngModel", ctx_r1.selectedConfiguration)("disabled", !ctx_r1.enabled);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r1.config.configurations);
    ɵɵadvance(1);
    ɵɵproperty("disabled", !ctx_r1.dirty || !ctx_r1.enabled);
    ɵɵadvance(1);
    ɵɵtextInterpolate(ɵɵpipeBind1(9, 10, "Apply"));
    ɵɵadvance(2);
    ɵɵproperty("disabled", !ctx_r1.dirty || !ctx_r1.enabled);
    ɵɵadvance(1);
    ɵɵtextInterpolate(ɵɵpipeBind1(12, 12, "Cancel"));
} }
var GateConfigurationSelectorComponent = /** @class */ (function () {
    function GateConfigurationSelectorComponent(modalService) {
        this.modalService = modalService;
        this.dirty = false;
        this._enabled = null;
        this.applied = false;
    }
    Object.defineProperty(GateConfigurationSelectorComponent.prototype, "config", {
        get: function () {
            return this._config;
        },
        set: function (x) {
            if (isEqual(x, this.config)) {
                return;
            }
            this._config = x;
            this.applied = false;
            this.reset();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GateConfigurationSelectorComponent.prototype, "enabled", {
        get: function () {
            return this._enabled;
        },
        set: function (x) {
            if (x === this._enabled) {
                return;
            }
            this._enabled = x;
            if (!this.applied && !x) {
                this.reset();
            }
        },
        enumerable: true,
        configurable: true
    });
    GateConfigurationSelectorComponent.prototype.onChange = function (x) {
        this.updateState();
    };
    GateConfigurationSelectorComponent.prototype.updateState = function () {
        this.dirty = !(this.config && this.selectedConfiguration
            && this.selectedConfiguration.name === this.config.selectedName);
    };
    GateConfigurationSelectorComponent.prototype.reset = function () {
        var c = this.config;
        if (c) {
            this.selectedConfiguration = c.selectedConfiguration;
        }
        this.updateState();
    };
    GateConfigurationSelectorComponent.prototype.apply = function () {
        var _this = this;
        this.applied = true;
        var m = this.modalService.open(ModalComponent);
        m.componentInstance.title = 'Configuration Confirmation';
        m.componentInstance.message = 'The configuration will be applied and the applicaton will be restarted. Continue?';
        m.result.then(function () { return _this.applyConfigurationCallback(_this.selectedConfiguration); });
    };
    /** @nocollapse */ GateConfigurationSelectorComponent.ɵfac = function GateConfigurationSelectorComponent_Factory(t) { return new (t || GateConfigurationSelectorComponent)(ɵɵdirectiveInject(NgbModal)); };
    /** @nocollapse */ GateConfigurationSelectorComponent.ɵcmp = ɵɵdefineComponent({ type: GateConfigurationSelectorComponent, selectors: [["lib-gate-configuration-selector"]], inputs: { applyConfigurationCallback: "applyConfigurationCallback", config: "config", enabled: "enabled" }, decls: 2, vars: 3, consts: [["class", "mb-1", 4, "ngIf", "ngIfAnd"], ["class", "w-100", 4, "ngIf"], [1, "mb-1"], [1, "fa", "fa-exclamation-triangle", "fa-lg", "text-danger", "mr-2"], [1, "mr-2"], [1, "w-100"], [1, "d-flex", "align-items-end"], [1, "custom-select", "w-100", 3, "ngModel", "disabled", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], [1, "btn", "btn-outline-primary", "ml-3", "mr-3", 3, "disabled", "click"], [1, "btn", "btn-outline-secondary", "mr-0", 3, "disabled", "click"], [3, "ngValue"]], template: function GateConfigurationSelectorComponent_Template(rf, ctx) { if (rf & 1) {
            ɵɵtemplate(0, GateConfigurationSelectorComponent_div_0_Template, 5, 3, "div", 0);
            ɵɵtemplate(1, GateConfigurationSelectorComponent_div_1_Template, 13, 14, "div", 1);
        } if (rf & 2) {
            ɵɵproperty("ngIf", ctx.dirty)("ngIfAnd", !ctx.applied);
            ɵɵadvance(1);
            ɵɵproperty("ngIf", ctx.config);
        } }, directives: [NgIf, SelectControlValueAccessor, NgControlStatus, NgModel, NgForOf, NgSelectOption, ɵangular_packages_forms_forms_x], pipes: [TranslatePipe], styles: [""] });
    return GateConfigurationSelectorComponent;
}());
/*@__PURE__*/ (function () { ɵsetClassMetadata(GateConfigurationSelectorComponent, [{
        type: Component,
        args: [{
                selector: 'lib-gate-configuration-selector',
                templateUrl: 'gate-configuration-selector.component.html',
                styleUrls: ['gate-configuration-selector.component.scss']
            }]
    }], function () { return [{ type: NgbModal }]; }, { applyConfigurationCallback: [{
            type: Input
        }], config: [{
            type: Input
        }], enabled: [{
            type: Input
        }] }); })();

function getToken() {
    return _cookieService.get(_projectConfiguration.tokenCookieName);
}
var _cookieService = null;
var _projectConfiguration = null;
var whitelistedDomains = [new RegExp('[sS]*')];
function jwtOptionsFactory() {
    return { tokenGetter: getToken, whitelistedDomains: whitelistedDomains };
}
var FmcuCoreNgModule = /** @class */ (function () {
    function FmcuCoreNgModule(cookieService, projectConfiguration) {
        _cookieService = cookieService;
        _projectConfiguration = projectConfiguration;
    }
    FmcuCoreNgModule.forRoot = function (projectConfiguration) {
        return {
            ngModule: FmcuCoreNgModule,
            providers: [
                { provide: ProjectConfiguration, useValue: projectConfiguration }
            ]
        };
    };
    /** @nocollapse */ FmcuCoreNgModule.ɵmod = ɵɵdefineNgModule({ type: FmcuCoreNgModule });
    /** @nocollapse */ FmcuCoreNgModule.ɵinj = ɵɵdefineInjector({ factory: function FmcuCoreNgModule_Factory(t) { return new (t || FmcuCoreNgModule)(ɵɵinject(CookieService), ɵɵinject(ProjectConfigurationService)); }, providers: [
            LocalizedDatePipe,
            StorageService,
            ExcelService,
            AuthGuardService,
            BaseBackendApiService,
            BackendDateService,
            BackendEventsService,
            ProjectConfigurationService,
            LanguageService,
            UITextService,
            UITextPipe,
            UITextTranslatePipe,
        ], imports: [[
                CommonModule,
                RouterModule,
                FormsModule,
                ReactiveFormsModule,
                TranslateModule,
                NgbModule,
                NgxDatatableModule,
                CookieModule.forRoot(),
                JwtModule.forRoot({
                    jwtOptionsProvider: {
                        provide: JWT_OPTIONS,
                        useFactory: jwtOptionsFactory
                    }
                }),
                UiSwitchModule,
            ]] });
    return FmcuCoreNgModule;
}());
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(FmcuCoreNgModule, { declarations: [FmcuCoreNgComponent,
        CardComponent,
        ComboBoxComponent,
        ItemsListComponent,
        PredefinedDateRangeComponent,
        DatepickerRangeComponent,
        DateRangeSelectionComponent,
        CompositeDateRangeComponent,
        LocalizedDatePipe,
        GroupingComponent,
        ErrorComponent,
        StatisticsComponent,
        NoConnectionComponent,
        UITextPipe,
        UITextTranslatePipe,
        GateControlComponent,
        GateStatusComponent,
        GateControlPanelComponent,
        ModalComponent,
        GateConfigurationSelectorComponent], imports: [CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        NgbModule,
        NgxDatatableModule, CookieModule, JwtModule, UiSwitchModule], exports: [FmcuCoreNgComponent,
        CardComponent,
        ComboBoxComponent,
        ItemsListComponent,
        PredefinedDateRangeComponent,
        DatepickerRangeComponent,
        DateRangeSelectionComponent,
        CompositeDateRangeComponent,
        LocalizedDatePipe,
        GroupingComponent,
        StatisticsComponent,
        ErrorComponent,
        NoConnectionComponent,
        UITextPipe,
        UITextTranslatePipe,
        GateControlComponent,
        GateStatusComponent,
        GateControlPanelComponent,
        ModalComponent,
        GateConfigurationSelectorComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(FmcuCoreNgModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    FmcuCoreNgComponent,
                    CardComponent,
                    ComboBoxComponent,
                    ItemsListComponent,
                    PredefinedDateRangeComponent,
                    DatepickerRangeComponent,
                    DateRangeSelectionComponent,
                    CompositeDateRangeComponent,
                    LocalizedDatePipe,
                    GroupingComponent,
                    ErrorComponent,
                    StatisticsComponent,
                    NoConnectionComponent,
                    UITextPipe,
                    UITextTranslatePipe,
                    GateControlComponent,
                    GateStatusComponent,
                    GateControlPanelComponent,
                    ModalComponent,
                    GateConfigurationSelectorComponent,
                ],
                imports: [
                    CommonModule,
                    RouterModule,
                    FormsModule,
                    ReactiveFormsModule,
                    TranslateModule,
                    NgbModule,
                    NgxDatatableModule,
                    CookieModule.forRoot(),
                    JwtModule.forRoot({
                        jwtOptionsProvider: {
                            provide: JWT_OPTIONS,
                            useFactory: jwtOptionsFactory
                        }
                    }),
                    UiSwitchModule,
                ],
                exports: [
                    FmcuCoreNgComponent,
                    CardComponent,
                    ComboBoxComponent,
                    ItemsListComponent,
                    PredefinedDateRangeComponent,
                    DatepickerRangeComponent,
                    DateRangeSelectionComponent,
                    CompositeDateRangeComponent,
                    LocalizedDatePipe,
                    GroupingComponent,
                    StatisticsComponent,
                    ErrorComponent,
                    NoConnectionComponent,
                    UITextPipe,
                    UITextTranslatePipe,
                    GateControlComponent,
                    GateStatusComponent,
                    GateControlPanelComponent,
                    ModalComponent,
                    GateConfigurationSelectorComponent,
                ],
                providers: [
                    LocalizedDatePipe,
                    StorageService,
                    ExcelService,
                    AuthGuardService,
                    BaseBackendApiService,
                    BackendDateService,
                    BackendEventsService,
                    ProjectConfigurationService,
                    LanguageService,
                    UITextService,
                    UITextPipe,
                    UITextTranslatePipe,
                ]
            }]
    }], function () { return [{ type: CookieService }, { type: ProjectConfigurationService }]; }, null); })();

var FileUtility = /** @class */ (function () {
    function FileUtility() {
    }
    FileUtility.saveToFile = function (fileName, blob, mimeType) {
        if (mimeType === void 0) { mimeType = 'text/plain'; }
        var anchor = document.createElement('a');
        anchor.download = fileName;
        anchor.type = mimeType;
        anchor.href = (window.URL || window.webkitURL).createObjectURL(blob);
        anchor.dataset.downloadurl = [
            mimeType,
            anchor.download,
            anchor.href
        ].join(':');
        anchor.click();
    };
    FileUtility.saveBase64ToFile = function (fileName, base64) {
        var anchor = document.createElement('a');
        anchor.href = "data:application/octet-stream;charset=utf-8;base64," + base64;
        anchor.download = fileName;
        anchor.click();
    };
    FileUtility.selectFiles = function (inputAccept, change, multiple) {
        if (multiple === void 0) { multiple = false; }
        var openFile = function (event) {
            change(event.target.files);
        };
        var input = document.createElement('input');
        input.type = 'file';
        input.accept = inputAccept;
        input.setAttribute('style', 'style="display: block;');
        if (multiple) {
            input.setAttribute('multiple', '');
        }
        input.addEventListener('change', openFile, false);
        input.click();
    };
    return FileUtility;
}());

var Device = /** @class */ (function () {
    function Device(init) {
        this.name = null;
        this.state = null;
        this.failure = null;
        this.isOptional = null;
        this.isSimulator = null;
        Object.assign(this, init);
    }
    Device.getFailedNames = function (devices, includeOptional) {
        if (includeOptional === void 0) { includeOptional = false; }
        return devices ? devices
            .filter(function (x) { return x.failure && (!x.isOptional || x.isOptional && includeOptional); })
            .map(function (x) { return x.name; }) : [];
    };
    return Device;
}());

/*
 * Public API Surface of fmcu-core-ng
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AppStateService, AuthGuardService, AuthenticationService, BackendDateService, BackendEventsService, BaseBackendApiService, CardComponent, ComboBoxComponent, ComboBoxItem, CompositeDateRangeComponent, ConfigurationsConfig, ConfigurationsConfigConverter, ConnectionState, ControlsVisibilityFlags, DateGroupingEnum, DateRange, DateRangeCalculator, DateRangeSelectionComponent, DateTime, DatepickerRangeComponent, Device, Dispatcher, ElementBase, ErrorComponent, FileUtility, FmcuCoreNgComponent, FmcuCoreNgModule, FmcuCoreNgService, GateAction, GateBlinkingMode, GateConfigurationSelectorComponent, GateControl, GateControlComponent, GateControlPanel, GateControlPanelComponent, GateStatus, GateStatusComponent, GateType, GroupingComponent, Highlighter, Icon, ItemsListComponent, JsonConvertorUtility, LOGIN_COMMAND, LanguageService, LocalizedDatePipe, ModalComponent, NoConnectionComponent, PredefinedDateRange, PredefinedDateRangeComponent, ProjectConfigurationService, StaffCard, StatisticsComponent, StorageService, TOKEN_UDPATE_BEFORE_EXPIRATION_SECONDS, UITextPipe, UITextService, UITextTranslatePipe, ValueAccessorBase, WebUtility, barcodeInUseValidator, composeValidators, getLanguageFactory, getToken, jwtOptionsFactory, message, parseGateType, validate, whitelistedDomains };
//# sourceMappingURL=fmcu-core-ng.js.map
